<template>
  <nav
    ref="mainNav"
    :id="[pathUrl == 'FullStream' || pathUrl.toLocaleLowerCase() == 'fullstreamdga' ? 'Fusion_nav_FullStream' : '']"
    v-if="
      !backToSuperAdminLoading &&
      ((pathUrl == 'FullStream' && Status_Error == false) || pathUrl != 'FullStream') &&
      // ((pathUrl.toLocaleLowerCase() == 'fullstreamdga' && Status_Error == false) || pathUrl.toLocaleLowerCase() != 'fullstreamdga')

      pathUrl != 'Snippet'
    "
  >
    <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64px" class="pa-0" type="card">
      <v-app-bar
        :elevation="0"
        :class="[
          // portal: แถบบนแบบตายตัวตาม design (ไม่อ่าน config theme ของบริษัทแล้ว — สี/โลโก้/พื้นหลังมาจาก token)
          pathUrl == 'FullStream' || pathUrl.toLocaleLowerCase() == 'fullstreamdga' ? 'dga-navbar' : 'portal-topbar',
        ]"
        :id="[pathUrl == 'FullStream' || pathUrl.toLocaleLowerCase() == 'fullstreamdga' ? 'Fusion_toolbar_FullStream' : '']"
        :style="{
          'box-shadow': 'none !important',
          height: '64px !important',
          'padding-right': '8px',
        }"
      >
        <!-- Logo สำหรับ FullStream บน Desktop -->
        <!-- Logo DGA สำหรับ FullStream บน Desktop -->

        <!-- Logo สำหรับหน้าอื่นๆ -->
        <img
          v-if="pathUrl != 'FullStream' && pathUrl.toLocaleLowerCase() != 'fullstreamdga'"
          id="Fusion_Logo_Other"
          alt="DGA"
          class="portal-topbar__logo clickable"
          :src="images.logo"
          width="70"
          height="40"
          @click="$router.currentRoute.name != 'dashboard' ? homepage() : ''"
        />

        <v-app-bar-nav-icon
          v-if="pathUrl == 'FullStream' && !mdAndUp"
          @click.stop="drawerMobile = !drawerMobile"
          style="margin-left: 10px; z-index: 5000"
          :disabled="(!Snippet_Username && Snippet_Status == true) || (!Snippet_Username == '' && !Snippet_Status)"
          color="rgb(76, 175, 135)"
        >
          <v-tooltip activator="parent" location="top">{{ $t('navb_toggleSidebar') }}</v-tooltip>
        </v-app-bar-nav-icon>
        <v-app-bar-nav-icon
          v-if="pathUrl != 'FullStream' && pathUrl.toLocaleLowerCase() != 'fullstreamdga' && drawerIsTemporary"
          class="portal-topbar__burger"
          @click.stop="drawer = !drawer"
        >
          <!-- a slot child replaces the default $menu icon, so the icon has to be given explicitly next to the tooltip -->
          <v-icon>mdi-menu</v-icon>
          <v-tooltip activator="parent" location="top">{{ $t('navb_toggleMenu') }}</v-tooltip>
        </v-app-bar-nav-icon>
        <div v-if="pathUrl == 'FullStream' && !mdAndUp" style="width: 100%; font-size: 12px; position: absolute; left: 60px; right: 0; top: 50%; bottom: 0; transform: translateY(-50%); display: flex">
          <span class="model-label-fade-in" style="color: #71717a; max-width: 50vw; white-space: nowrap; text-overflow: ellipsis; pointer-events: none">
            {{ ModelFirst == '' ? '' : modelFirstComputed }}<br />
            {{ TopicName == '' ? '' : truncateText(TopicName) }}
          </span>
        </div>
        <v-spacer></v-spacer>

        <v-menu v-if="pathUrl != 'FullStream' && pathUrl.toLocaleLowerCase() != 'fullstreamdga'" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              icon
              variant="flat"
              size="small"
              v-bind="props"
              class="portal-topbar__btn"
            >
              <flag :iso="currentflag" />
              <v-tooltip activator="parent" location="top">{{ $t('navb_language') }}</v-tooltip>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language, entry.flag)">
              <template v-slot:prepend>
                <flag :iso="entry.flag" v-bind:squared="false" />
              </template>
              <v-list-item-title>{{ entry.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- add button  Turn sound on/off -->
        <v-btn
          v-if="pathUrl != 'FullStream' && pathUrl.toLocaleLowerCase() != 'fullstreamdga'"
          icon
          variant="flat"
          size="small"
          class="portal-topbar__btn"
          @click="toggleSound"
        >
          <v-icon size="20">
            {{ soundEnabled ? 'mdi-volume-high' : 'mdi-volume-off' }}
          </v-icon>
          <v-tooltip activator="parent" location="top">{{ $t('navb_toggleSound') }}</v-tooltip>
        </v-btn>

        <v-menu
          v-if="pathUrl != 'FullStream' && pathUrl.toLocaleLowerCase() != 'fullstreamdga'"
          v-model="profileMenuOpen"
          location="bottom"
          :close-on-content-click="false"
          transition="slide-y-transition"
          :offset="10"
          rounded="lg"
          min-width="220"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              id="button-username-navbar"
              v-bind="props"
              class="user-profile-button portal-topbar__profile"
              variant="flat"
              :ripple="false"
            >
              <div class="d-flex align-center">
                <v-avatar size="28" class="portal-topbar__avatar mr-2" variant="flat">
                  <span class="text-caption font-weight-medium">
                    {{ username ? username.substring(0, 1).toUpperCase() : 'U' }}
                  </span>
                </v-avatar>
                <span class="user-name">
                  {{ username }}
                </span>
                <v-icon size="small" class="ml-1"> mdi-chevron-down </v-icon>
              </div>
              <v-tooltip activator="parent" location="top">{{ $t('navb_accountMenu') }}</v-tooltip>
            </v-btn>
          </template>

          <v-card class="user-menu-card" elevation="3">
            <!-- User profile header -->
            <v-card-item class="user-menu-header pa-4">
              <template v-slot:prepend>
                <v-avatar size="42" color="primary" class="mr-3">
                  <span class="text-h6 font-weight-medium white--text">
                    {{ shotName }}
                  </span>
                </v-avatar>
              </template>

              <v-card-title class="pa-0">
                <div>
                  <div class="text-body-1 font-weight-medium mb-0">
                    {{ fullName }}
                  </div>
                  <div class="text-caption text-medium-emphasis">
                    {{ companyName ? `${companyName} - ${role}` : role }}
                  </div>
                </div>
              </v-card-title>
            </v-card-item>

            <v-divider></v-divider>

            <!-- Menu items -->
            <v-list class="pa-2" nav density="comfortable">
              <v-list-item v-for="v in ddProfile" :key="v.no" :value="v.title" @click="v.action" :to="v.route" class="menu-list-item mb-1 rounded" :ripple="true">
                <template v-slot:prepend>
                  <v-icon :color="v.no === 4 ? 'error' : 'primary'" size="small" class="mr-2">{{ v.icon }}</v-icon>
                </template>
                <v-list-item-title class="menu-item-title" :class="{ 'text-error': v.no === 4 }">
                  {{ localize(v.title) }}
                </v-list-item-title>
              </v-list-item>
            </v-list>

            <v-card-text class="pt-2 pb-3 px-4 text-center">
              <div class="text-caption text-medium-emphasis">
                {{ $t('navb_version') + ' R' + versioning }}
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
        <div
          v-if="Snippet_Username != ''"
          style="
            color: black;
            padding-top: 4px;
            text-align: center;
            font-weight: bold;
            height: 25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          {{ Snippet_Username }}
          <!-- DGA account menu -->
        </div>
        <!-- {{$route.name}}LoginSnippet -->
        <div
          v-if="isSnippet && $route.name != 'LoginSnippet' && (Snippet_Username == '' || Snippet_Username == null || Snippet_Username == undefined)"
          style="
            background-color: #333;
            margin-top: 3px;
            margin-right: 15px;
            padding: 5px;
            font-size: 12px;
            width: 70px;
            height: 25px;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
            z-index: 9999;
          "
          v-on:click="OpenTabLogin()"
        >
          <span style="color: white; text-align: center"> {{ $t('navb_login') }} </span>
        </div>
        <div
          v-else-if="Snippet_Username != ''"
          style="
            background-color: #333;
            margin-top: 8px;
            margin-left: 8px;
            padding: 5px;
            font-size: 12px;
            width: 70px;
            height: 25px;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
            z-index: 9999;
          "
          v-on:click="chatLogout()"
        >
          <span style="color: white; text-align: center"> {{ $t('navb_logout') }} </span>
        </div>

        <!-- {{ Fullstream USER_ID }} -->
        <div v-if="pathUrl == 'FullStream' && !isSnippet && User_Id_Show != null && User_Id_Show != '' && User_Id_Show != undefined && mdAndUp">
          <span>{{ User_Id_Show != null && User_Id_Show != '' && User_Id_Show != undefined ? User_Id_Show : '' }}</span>
          <v-btn
            size="small"
            icon
            text
            style="font-size: 16px; font-family: inter, sans-serif; font-style: normal; margin-left: 14px"
            :style="'background: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ? NavbarBtnColorTheme : 'D96666')"
            disabled
            fab
          >
            <span :style="'color: #' + (NavbarTxtColorTheme != null || NavbarTxtColorTheme != undefined ? NavbarTxtColorTheme : 'FFFFFF')">{{
              User_Id_Show != null && User_Id_Show != '' && User_Id_Show != undefined && User_Id_Show.length > 1 ? User_Id_Show.substring(0, 2) : ''
            }}</span>
          </v-btn>
        </div>

        <div v-if="pathUrl.toLocaleLowerCase() == 'fullstreamdga' && !isSnippet && User_Id_Show != null && User_Id_Show != '' && User_Id_Show != undefined && mdAndUp">
          <span>{{ User_Id_Show != null && User_Id_Show != '' && User_Id_Show != undefined ? User_Id_Show : '' }}</span>
          <v-btn
            size="small"
            icon
            text
            style="font-size: 16px; font-family: inter, sans-serif; font-style: normal; margin-left: 14px"
            :style="'background: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ? NavbarBtnColorTheme : 'D96666')"
            disabled
            fab
          >
            <span :style="'color: #' + (NavbarTxtColorTheme != null || NavbarTxtColorTheme != undefined ? NavbarTxtColorTheme : 'FFFFFF')">{{
              User_Id_Show != null && User_Id_Show != '' && User_Id_Show != undefined && User_Id_Show.length > 1 ? User_Id_Show.substring(0, 2) : ''
            }}</span>
          </v-btn>
        </div>

        <!-- {{ Fullstream USER_ID Mobile }} -->
      </v-app-bar>
    </v-skeleton-loader>

    <v-tooltip location="bottom" v-model="showSidebarTooltip">
      <template v-slot:activator="{ props }">
        <div v-if="pathUrl == 'FullStream' && mdAndUp && !drawerFull" class="floating-nav-button-div" style="left: 15px" @click="sidebarClickHandle" v-bind="props">
          <v-img
            :src="fullDrawerImg"
            alt="Nav Menu Icon"
            contain
            height="24"
            width="24"
            class="colored-icon"
            style="filter: brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(831%) hue-rotate(102deg) brightness(95%) contrast(88%)"
          />
        </div>
      </template>
      <span>{{ $t('navb_openSidebar') }}</span>
    </v-tooltip>

    <v-tooltip location="bottom">
      <template v-slot:activator="{ props }">
        <div v-if="pathUrl == 'FullStream' && mdAndUp && !drawerFull" class="floating-nav-button-div" style="left: 60px" @click="newChat()" v-bind="props">
          <v-img
            :src="chatTopicPlusIcon"
            alt="Plus Icon"
            height="22"
            width="22"
            style="display: inline; margin-left: 2px; filter: brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(831%) hue-rotate(102deg) brightness(95%) contrast(88%)"
          />
        </div>
      </template>
      <span>{{ $t('navb_newChat') }}</span>
    </v-tooltip>

    <v-col
      v-if="isAllowLLMChange && pathUrl == 'FullStream' && mdAndUp"
      style="border-radius: 18px !important; left: 110px; width: auto"
      cols="auto"
      :style="drawerFull ? 'left: 275px; width: auto;' : 'left: 110px; width: auto;'"
      class="floating-nav-dropdown"
    >
      <div class="model-selector">
        <!-- แทนที่ v-menu ด้วย div ปกติที่มีการจัดการ click event -->
        <div class="dropdown-container">
          <!-- Activator ที่เคยอยู่ใน v-slot:activator -->
          <div class="model-dropdown d-flex align-center" @click="toggleModelDropdown">
            <span class="model-name">{{ selectedLLMModel ? selectedLLMModel.modelDisplay : $t('navb_llmsDefault') }}</span>
            <v-tooltip location="top" max-width="420">
              <template #activator="{ props }">
                <v-icon v-bind="props" size="x-small" color="grey-darken-1" class="ml-1" style="cursor: help;" @click.stop>mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('navb_help_llmSelector') }}</span>
            </v-tooltip>
            <v-btn v-if="selectedLLMModel" variant="text" icon x-small class="ml-3 clear-model-btn" @click="clearSelectedModel">
              <v-icon size="14" color="grey">mdi-close-circle</v-icon>
              <v-tooltip activator="parent" location="top" max-width="420">{{ $t('navb_help_clearModel') }}</v-tooltip>
            </v-btn>
            <v-icon size="18" class="ml-1 text--secondary">mdi-chevron-down</v-icon>
          </div>

          <!-- Dropdown content ที่จะแสดงเมื่อคลิก -->
          <div v-if="showModelDropdown" class="custom-dropdown-menu" v-click-outside="closeModelDropdown">
            <div class="custom-model-card">
              <div class="custom-model-header">{{ $t('navb_selectLlmModel') }}</div>
              <div class="custom-model-content">
                <v-expansion-panels v-model="expandedPanel" variant="accordion" class="minimal-panels" flat>
                  <v-expansion-panel v-for="provider in providers" :key="provider.id" class="minimal-panel">
                    <v-expansion-panel-title class="py-2 minimal-header">
                      <div class="d-flex align-center">
                        <v-icon size="16" :color="provider.color" class="mr-2">{{ provider.icon }}</v-icon>
                        <span class="provider-name">{{ provider.name }}</span>
                        <v-chip size="x-small" class="ml-2 minimal-chip" :color="`${provider.color}15`" :text-color="provider.color">
                          {{ getModelsByProvider(provider.id).length }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="pt-0 pb-0 minimal-content">
                      <v-list density="compact" class="model-list py-0 minimal-list">
                        <v-list-item
                          v-for="model in getModelsByProvider(provider.id)"
                          :key="model.id"
                          @click="
                            SelectLLMMdel(model);
                            closeModelDropdown();
                          "
                          class="minimal-list-item"
                          :class="{ 'selected-model': selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay }"
                        >
                          <v-list-item-content class="py-1">
                            <v-list-item-title class="subtitle-2">{{ model.modelDisplay }}</v-list-item-title>
                            <v-list-item-subtitle class="caption text--secondary">{{ model.modelName }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <template v-if="selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay">
                            <v-list-item-action>
                              <v-icon size="16" color="primary">mdi-check</v-icon>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>


    <v-btn fab small color="transparent" elevation="0" style="transition: transform 0.3s cubic-bezier(0.2, 0, 0.4, 1)">
    </v-btn>
    <!-- Fullstream -->
    <v-navigation-drawer
      id="NavFullStream"
      v-if="pathUrl == 'FullStream' && mdAndUp"
      v-show="$route.name == 'FullStream' || $route.name == 'FullStreamV2'"
      style="
        top: 64px;
        max-height: calc(-64px + 100dvh);
        height: calc(-64px + 100dvh);
        border-radius: 0%;
        box-shadow: none !important;
        border-style: none !important;
        padding-bottom: calc(0px + env(safe-area-inset-bottom));
        z-index: 10;
      "
      :style="mini ? 'background-color: #FFFFFF' : 'background-color: #ECF0F4'"
      v-model="drawerFull"
      overlay-opacity="0.2"
      app
      left
      v-model:mini-variant="checkMini"
    >
      <v-col class="drawer-header-sticky" :class="{ scrolled: isScrolled }">
        <!-- USER ID -->
        <v-row v-show="!mini" style="scale: 0.9; margin-top: 54px; margin-left: -15px; width: 120px !important">
          <v-col style="padding: 0px">
            <div class="user-id-badge">
              <div class="user-id-icon">
                <v-icon size="15" color="white">mdi-account</v-icon>
              </div>
              <div class="user-id-content">
                <span class="user-id-label">{{ $t('navb_userId') }}</span>
                <span class="user-id-value">{{ User_Id_Show || $t('navb_notAssigned') }}</span>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-tooltip location="bottom">
          <template v-slot:activator="{ props }">
            <div class="floating-nav-button-div" @click="drawerFull = false" v-bind="props" style="top: 68px">
              <v-img
                :src="fullDrawerImg"
                alt="Nav Menu Icon"
                contain
                height="24"
                width="24"
                class="colored-icon"
                style="filter: brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(831%) hue-rotate(102deg) brightness(95%) contrast(88%)"
              />
            </div>
          </template>
          <span>{{ $t('navb_closeSidebar') }}</span>
        </v-tooltip>
      </v-col>
      <v-col style="margin-top: 75px">
        <!-- Parameter -->
        <v-row v-show="!mini">
          <v-col class="pb-0">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">{{ $t('navb_parameters') }}</span>
            <v-tooltip location="top" max-width="440">
              <template #activator="{ props }">
                <v-icon v-bind="props" size="small" color="grey-darken-1" class="ml-1" style="cursor: help;">mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('navb_help_parameters') }}</span>
            </v-tooltip>
          </v-col>
          <v-col v-show="!mini">
            <div style="position: absolute; font-size: 12px; left: 0px; bottom: -1px; background-color: rgb(236, 240, 244); height: 20px; width: 95px; z-index: 9999; border-radius: 0 12px 0 0">
              <span style="font-size: 12px; color: #5f5f5f; margin-left: 8px">
                {{ versioning != '' || versioning != null ? 'Version' : '' }}
                {{ 'R' + versioning }}
              </span>
            </div>
          </v-col>
        </v-row>
        <!-- Time delay -->
        <v-row v-show="!mini">
          <v-col style="padding-top: 0px" class="px-4">
            <span style="font-size: 14px">Time Delay</span>
            <v-tooltip location="top" max-width="440">
              <template #activator="{ props }">
                <v-icon v-bind="props" size="x-small" color="grey-darken-1" class="ml-1" style="cursor: help;">mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('navb_help_timeDelay') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-show="!mini" style="margin-top: 0px">
          <v-col style="padding-top: 0px; padding-bottom: 0px" class="px-4">
            <v-text-field
              v-model="Time_Delay"
              type="number"
              variant="outlined"
              density="compact"
              hide-details
              min="0"
              max="1000"
              suffix="ms"
              prepend-inner-icon="mdi-timer-outline"
              class="time-delay-input"
              rounded="lg"
              color="primary"
              bg-color="white"
              :rules="[(v) => (v >= 0 && v <= 1000) || 'Value must be between 0-1000']"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <!-- Folder -->
        <v-row v-show="!mini" style="padding-top: 21px">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Folder</span>
          </v-col>

          <v-col class="col-7" style="background-color: transparent; padding-top: 0px; display: flex; justify-content: flex-end; align-items: center">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
                <div class="new-chat-fab" style="margin-right: 7px" :color="selectedColor" v-bind="props" @click="createFolder">
                  <v-icon style="color: rgb(76, 175, 135)" size="24"> mdi-folder-plus </v-icon>
                </div>
              </template>
              <span>{{ $t('navb_createFolder') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-skeleton-loader style="margin-top: 5px; margin-bottom: 15px; background-color: transparent" :loading="flagLoadingFolders" transition="scale-transition" type="list-item">
          <v-row v-show="!mini" id="folder_list_id_desktop" style="margin-top: 0px; display: block">
            <v-col class="col-12" style="padding: 0">
              <div id="folder-list-desktop" class="folder-list-container">
                <draggable :disabled="true" :group="{ name: 'folder', pull: false, put: false }" :sort="false" v-model="folders" item-key="id">
                  <template #item="{ element: folder, index: idx }">
                    <div class="folder-item">
                      <div
                        class="folder-view"
                        :class="{
                          'drop-target': isDroppingOnFolder === folder.id,
                          'folder-updated-success': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success',
                          'folder-updated-error': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error',
                        }"
                        elevation="0"
                        @click="toggleFolder(folder)"
                        @dragover="onDragOverFolder($event, folder)"
                        @dragleave.prevent="onDragLeaveFolder(folder.id)"
                        @drop.stop.prevent="handleDropForNone($event)"
                      >
                        <div class="folder-view-content">
                          <v-icon size="24" class="mr-2" :color="folder.expanded ? selectedColor : 'rgba(0,0,0,0.6)'">
                            {{ folder.expanded ? 'mdi-folder-open' : 'mdi-folder' }}
                          </v-icon>
                          <span class="folder-name" :class="{ 'folder-name-active': folder.expanded }">{{ folder.name }}</span>
                          <!-- Success indicator -->
                          <transition name="fade">
                            <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success'" color="success" size="20" class="folder-status-icon success-bounce">
                              mdi-check-circle
                            </v-icon>
                          </transition>
                          <!-- Error indicator -->
                          <transition name="fade">
                            <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error'" color="error" size="20" class="folder-status-icon error-shake">
                              mdi-alert-circle
                            </v-icon>
                          </transition>
                          <v-menu bottom right transition="slide-y-transition" :close-on-content-click="true" offset-y min-width="180" content-class="folder-menu-container">
                            <template v-slot:activator="{ props }">
                              <v-btn icon v-bind="props" variant="text" size="large" :color="selectedColor" class="topic-menu-button" style="width: 35px !important; height: 35px !important">
                                <v-icon size="small">mdi-dots-vertical</v-icon>
                                <v-tooltip activator="parent" location="top">{{ $t('navb_moreActions') }}</v-tooltip>
                              </v-btn>
                            </template>
                            <v-card class="folder-menu-card">
                              <div class="folder-menu-list">
                                <div
                                  class="folder-menu-item mb-1 px-2"
                                  @click="startEditFolder(folder, idx)"
                                  style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease"
                                >
                                  <div class="mr-2 d-flex align-center justify-center">
                                    <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                  </div>
                                  <div>
                                    <span class="body-2">Rename</span>
                                  </div>
                                </div>
                                <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px"></div>
                                <div
                                  class="folder-menu-item mt-1 px-2"
                                  @click="openDeleteDialog(folder, idx)"
                                  style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease"
                                >
                                  <div class="mr-2 d-flex align-center justify-center">
                                    <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                  </div>
                                  <div>
                                    <span class="body-2 error--text" style="color: #ff5252 !important">Delete</span>
                                  </div>
                                  <v-tooltip activator="parent" location="end" max-width="420"><span>{{ $t('navb_help_folderDelete') }}</span></v-tooltip>
                                </div>
                              </div>
                            </v-card>
                          </v-menu>
                        </div>
                      </div>
                      <!-- {{ Subtopic }} -->
                      <div v-if="folder.expanded" class="folder-subtopics" style="padding: 8px 0px 0px 6px !important">
                        <div class="topic-list-container">
                          <div v-show="folder.topics">
                            <draggable
                              :list="folder.topics"
                              :group="{ name: 'topics', pull: true, put: false }"
                              :sort="false"
                              :animation="150"
                              item-key="topicID"
                              ghost-class="sortable-ghost"
                              @start="(onDragStart($event, folder), onDragStartFromOutside(false))"
                              @end="onDragEnd($event, folder)"
                              class="no-select"
                            >
                              <template #item="{ element: item, index }">
                                <div :key="item.topicID" class="topic-item" :class="item.topicID === Log_History_TopicID ? 'highlighted-topic' : ''">
                                  <!-- Editing State -->
                                  <div v-if="item.status == true" class="topic-item--editing">
                                    <div class="d-flex align-center w-100">
                                      <div class="flex-grow-1 mr-2">
                                        <v-text-field
                                          class="Cls_Text_field_TopicName"
                                          :id="'TopicId_' + item.topicID"
                                          variant="outlined"
                                          density="compact"
                                          hide-details
                                          v-model="item.topicName"
                                          rounded="lg"
                                          style="width: 100%; background-color: #ffffff; font-family: 'Inter', sans-serif"
                                          @blur="
                                            () => {
                                              item.status = false;
                                              RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token);
                                            }
                                          "
                                          @keyup="keyupKeyRename()"
                                          @keyup.enter="
                                            item.status = false;
                                            RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token);
                                          "
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Normal State -->
                                  <div v-else class="topic-item--clickable" @click="selectTopic(item)">
                                    <div class="d-flex align-center w-100">
                                      <div class="topic-icon-wrapper mr-3">
                                        <v-img :src="chatTopicIcon" alt="Topic Icon" height="16" width="16" contain />
                                      </div>
                                      <div class="topic-content flex-grow-1 mr-2">
                                        <v-tooltip location="top" open-delay="300" max-width="300">
                                          <template v-slot:activator="{ props }">
                                            <div v-bind="props" class="topic-title-wrapper" style="max-width: 100%">
                                              <span class="topic-title text-truncate">
                                                {{ item.topicName }}
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ item.topicName.length > 100 ? item.topicName.substring(0, 100) + '...' : item.topicName }}</span>
                                        </v-tooltip>
                                      </div>

                                      <!-- เมนูของ topic ใน folder -->
                                      <v-menu location="right top" transition="slide-y-transition" :close-on-content-click="true" offset-y min-width="200" content-class="topic-menu-container">
                                        <template v-slot:activator="{ props }">
                                          <v-btn icon v-bind="props" variant="text" size="large" :color="selectedColor" class="topic-menu-button">
                                            <v-icon size="small">mdi-dots-vertical</v-icon>
                                            <v-tooltip activator="parent" location="top">{{ $t('navb_moreActions') }}</v-tooltip>
                                          </v-btn>
                                        </template>
                                        <v-card class="topic-menu-card" style="width: 200px; max-width: 100%">
                                          <div class="topic-menu-list pa-2" style="border-radius: 12px; border: none; overflow: hidden; background: white">
                                            <div
                                              class="topic-menu-item mb-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                              @click="openMoveToFolderDialog(item)"
                                            >
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                                              </div>
                                              <div class="d-flex align-center">
                                                <span class="body-2">Move to folder</span>
                                              </div>
                                            </div>
                                            <div
                                              class="topic-menu-item mb-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                              @click="removeTopicFromFolder(folder.id, item.topicID, index)"
                                            >
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" color="warning">mdi-folder-remove</v-icon>
                                              </div>
                                              <div class="d-flex align-center">
                                                <span class="body-2">Remove from folder</span>
                                              </div>
                                              <v-tooltip activator="parent" location="end" max-width="420"><span>{{ $t('navb_help_topicMenuActions') }}</span></v-tooltip>
                                            </div>
                                            <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px"></div>
                                            <div
                                              class="topic-menu-item mt-1 mb-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                              @click="
                                                RenameChat(item);
                                                focusInput('TopicId_' + item.topicID);
                                              "
                                            >
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                              </div>
                                              <div>
                                                <span class="body-2">Rename</span>
                                              </div>
                                            </div>
                                            <div
                                              class="topic-menu-item mt-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                              @click="openDeleteTopicDialog(item)"
                                            >
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                              </div>
                                              <div>
                                                <span class="body-2 error--text" style="color: #ff5252 !important">Delete chat</span>
                                              </div>
                                              <v-tooltip activator="parent" location="end" max-width="420"><span>{{ $t('navb_help_topicMenuActions') }}</span></v-tooltip>
                                            </div>
                                          </div>
                                        </v-card>
                                      </v-menu>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </draggable>
                          </div>
                          <div v-if="!folder.topics || folder.topics.length === 0" class="empty-folder-state">
                            <v-icon color="grey lighten-1" size="20">mdi-chat-outline</v-icon>
                            <span class="empty-folder-text ml-2">No chats in this folder</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
              </div>
            </v-col>
          </v-row>
        </v-skeleton-loader>
        <!-- Topic -->
        <v-row v-show="!mini" style="padding-top: 21px" @dragover="onDragOverOutsideDragArea($event)">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Topics</span>
          </v-col>
          <!-- NEW CHAT -->
          <v-col class="col-7" style="background-color: transparent; padding-top: 0px; display: flex; justify-content: flex-end; align-items: center">
            <div :color="selectedColor" style="margin-right: 5px" depressed rounded hide-details class="new-chat-fab" v-on:click="newChat()">
              <v-img
                :src="chatTopicPlusIcon"
                alt="Plus Icon"
                style="
                  margin-top: 5px;
                  height: 18px !important;
                  width: 18px !important;
                  display: inline;
                  filter: brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(831%) hue-rotate(102deg) brightness(95%) contrast(88%);
                "
              />
            </div>
          </v-col>
        </v-row>
        <!-- Topic List -->
        <v-row v-show="!mini" id="topic_list_id_desktop" style="margin-top: 21px; display: block">
          <v-col
            class="col-12"
            style="padding-top: 0px; padding-bottom: 10px"
            :class="targetToOutsideArea && !isStartFromOutside ? 'drop-target-outside' : ''"
            @dragover="onDragOverOutsideTopic($event)"
          >
            <div class="topic-scroll-container">
              <draggable
                :list="topicsNotInFolders"
                :group="{ name: 'topics', pull: true, put: false }"
                :sort="false"
                :animation="150"
                item-key="topicID"
                ghost-class="sortable-ghost"
                @start="(onDragStart($event), onDragStartFromOutside(true))"
                @end="onDragEnd"
                class="no-select"
              >
                <template #item="{ element, index }">
                  <div :key="element.topicID" class="topic-item" @click="selectTopicOutside(element)" :class="highlightTopic(element)">
                    <!-- Editing State -->
                    <div v-if="element.status == true" class="topic-item--editing">
                      <div class="d-flex align-center w-100">
                        <div class="flex-grow-1">
                          <v-text-field
                            class="Cls_Text_field_TopicName"
                            :id="'TopicId_' + element.topicID"
                            variant="outlined"
                            density="compact"
                            hide-details
                            v-model="element.topicName"
                            rounded="lg"
                            style="width: 100%; background-color: #ffffff; font-family: 'Inter', sans-serif"
                            @blur="
                              () => {
                                element.status = false;
                                RenameTopicStream(element.topicID, element.keyTopic, element.topicName, index, auth_token);
                              }
                            "
                            @keyup="keyupKeyRename()"
                            @keyup.enter="
                              element.status = false;
                              RenameTopicStream(element.topicID, element.keyTopic, element.topicName, index, auth_token);
                            "
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Normal State -->
                    <div v-else class="topic-item--clickable" @click="selectTopicOutside(element)">
                      <div class="d-flex align-center w-100">
                        <div class="topic-icon-wrapper mr-3">
                          <v-img :src="chatTopicIcon" alt="Topic Icon" height="16" width="16" contain />
                        </div>

                        <div class="topic-content flex-grow-1 mr-2">
                          <v-tooltip location="top" open-delay="300" max-width="300">
                            <template v-slot:activator="{ props }">
                              <div v-bind="props" class="topic-title-wrapper">
                                <span class="topic-title text-truncate">
                                  {{ element.topicName }}
                                </span>
                              </div>
                            </template>
                            <span>{{ element.topicName.length > 100 ? element.topicName.substring(0, 100) + '...' : element.topicName }}</span>
                          </v-tooltip>
                        </div>
                        <v-menu location="right top" transition="slide-y-transition" :close-on-content-click="true" offset-y min-width="200" content-class="topic-menu-container">
                          <template v-slot:activator="{ props }">
                            <v-btn icon v-bind="props" variant="text" size="large" :color="selectedColor" class="topic-menu-button">
                              <v-icon size="small">mdi-dots-vertical</v-icon>
                              <v-tooltip activator="parent" location="top">{{ $t('navb_moreActions') }}</v-tooltip>
                            </v-btn>
                          </template>
                          <v-card class="topic-menu-card" style="width: 200px">
                            <div class="topic-menu-list pa-2" style="border-radius: 12px; border: none; overflow: hidden; background: white">
                              <div
                                class="topic-menu-item mb-1 d-flex align-center"
                                style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                @click="openMoveToFolderDialog(element)"
                              >
                                <div class="mr-2 d-flex align-center justify-center">
                                  <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                                </div>
                                <div class="d-flex align-center">
                                  <span class="body-2">Move to folder</span>
                                </div>
                              </div>

                              <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px"></div>

                              <div
                                class="topic-menu-item mt-1 mb-1"
                                style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                @click="
                                  RenameClick(element, 'TopicId_' + element.topicID);
                                  focusInput('TopicId_' + element.topicID);
                                "
                              >
                                <div class="mr-2 d-flex align-center justify-center">
                                  <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                </div>
                                <div>
                                  <span class="body-2">Rename</span>
                                </div>
                              </div>

                              <div
                                class="topic-menu-item mt-1"
                                style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                @click="openDeleteTopicDialog(element)"
                              >
                                <div class="mr-2 d-flex align-center justify-center">
                                  <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                </div>
                                <div>
                                  <span class="body-2 error--text" style="color: #ff5252 !important">Delete chat</span>
                                </div>
                              </div>
                            </div>
                          </v-card>
                        </v-menu>
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-navigation-drawer>

    <!-- MOBILE -->
    <v-navigation-drawer
      v-else-if="(pathUrl == 'FullStream' && !mdAndUp && drawerMobile) || (pathUrl == 'FullStream' && !mdAndUp && drawerMobile && LeftNavBar)"
      v-model="drawerMobile"
      style="background-color: #ecf0f4; padding-bottom: calc(0px + env(safe-area-inset-bottom)); transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important"
      :scrim="true"
      temporary
      left
      app
      clipped
      :width="280"
      touchless
    >
      <v-col style="padding-top: 80px; padding-left: 12px; padding-right: 12px">
        <!-- LOGO -->
        <v-row>
          <v-img id="Fusion_Logo_FullStream_Mobile" alt="DGA Logo" class="shrink mr-4 app" contain :src="images.dgaLogo" width="150" height="104" style="cursor: unset" />
        </v-row>
      </v-col>

      <v-col style="margin-top: 15px; padding: 0 12px">
        <!-- USER ID Badge -->
        <v-row style="margin-top: 19px; margin-left: -5px; width: 100% !important">
          <v-col style="padding: 0px">
            <div class="user-id-badge">
              <div class="user-id-icon">
                <v-icon size="15" color="white">mdi-account</v-icon>
              </div>
              <div class="user-id-content">
                <span class="user-id-label">{{ $t('navb_userId') }}</span>
                <span class="user-id-value" style="max-width: 200px">{{ User_Id_Show || $t('navb_notAssigned') }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
        <div style="position: absolute; font-size: 12px; left: 0px; bottom: -1px; background-color: rgb(236, 240, 244); height: 20px; width: 95px; z-index: 9999; border-radius: 0 12px 0 0">
          <span style="font-size: 12px; color: #5f5f5f; margin-left: 8px">
            {{ versioning != '' || versioning != null ? 'Version' : '' }}
            {{ 'R' + versioning }}
          </span>
        </div>

        <!-- Parameter -->
        <v-row>
          <v-col class="pb-0">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">{{ $t('navb_parameters') }}</span>
            <v-tooltip location="top" max-width="440">
              <template #activator="{ props }">
                <v-icon v-bind="props" size="small" color="grey-darken-1" class="ml-1" style="cursor: help;">mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('navb_help_parameters') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <!-- Time delay -->
        <v-row>
          <v-col style="padding-top: 0px" class="px-4">
            <span style="font-size: 14px">Time Delay</span>
            <v-tooltip location="top" max-width="440">
              <template #activator="{ props }">
                <v-icon v-bind="props" size="x-small" color="grey-darken-1" class="ml-1" style="cursor: help;">mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('navb_help_timeDelay') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row style="margin-top: 0px">
          <v-col style="padding-top: 0px; padding-bottom: 0px" class="px-4">
            <v-text-field
              v-model="Time_Delay"
              type="number"
              variant="outlined"
              density="compact"
              hide-details
              min="0"
              max="1000"
              suffix="ms"
              prepend-inner-icon="mdi-timer-outline"
              class="time-delay-input"
              rounded="lg"
              color="primary"
              bg-color="white"
              :rules="[(v) => (v >= 0 && v <= 1000) || 'Value must be between 0-1000']"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="isAllowLLMChange && pathUrl == 'FullStream' && !mdAndUp" style="border-radius: 18px !important; width: 105%; padding-top: 15px; padding-left: 15px; margin-bottom: 5px">
          <div class="model-selector" style="width: 100%">
            <span style="font-weight: 700; font-size: 18px; color: #71717a">LLM</span>
            <v-tooltip location="top" max-width="420">
              <template #activator="{ props }">
                <v-icon v-bind="props" size="x-small" color="grey-darken-1" class="ml-1" style="cursor: help;">mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('navb_help_llmSelector') }}</span>
            </v-tooltip>
            <!-- แทนที่ v-menu ด้วย div ปกติที่มีการจัดการ click event -->
            <div class="dropdown-container" style="margin-top: 10px">
              <!-- Activator ที่เคยอยู่ใน v-slot:activator -->
              <div class="model-dropdown-mobile d-flex align-center" style="display: flex !important; justify-content: space-between" @click="toggleModelDropdownDialog">
                <!-- selectedLLMModel.modelDisplay.substring(0, 12) + (selectedLLMModel.modelDisplay.length > 12 ? '...' : '') -->
                <span class="model-name" style="font-size: 12px">{{ selectedLLMModel ? selectedLLMModel.modelDisplay : $t('navb_llmsDefault') }}</span>
                <div style="display: flex; align-items: center">
                  <v-btn v-if="selectedLLMModel" variant="text" icon class="ml-3 clear-model-btn" @click="clearSelectedModel">
                    <v-icon size="20" color="grey">mdi-close-circle</v-icon>
                    <v-tooltip activator="parent" location="top" max-width="420">{{ $t('navb_help_clearModel') }}</v-tooltip>
                  </v-btn>
                  <v-icon size="18" class="ml-1 text--secondary">mdi-chevron-down</v-icon>
                </div>
              </div>
            </div>
          </div>
        </v-row>
        <!-- Folder -->
        <v-row style="padding-top: 10px">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Folder</span>
          </v-col>

          <v-col class="col-7" style="background-color: transparent; padding-top: 0px; display: flex; justify-content: flex-end; align-items: center">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
                <div class="new-chat-fab" style="margin-right: 9px" :color="selectedColor" v-bind="props" @click="createFolder">
                  <v-icon style="color: rgb(76, 175, 135)" size="28"> mdi-folder-plus </v-icon>
                </div>
              </template>
              <span>{{ $t('navb_createFolder') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-skeleton-loader style="margin-top: 0px; margin-bottom: 15px; background-color: transparent" :loading="flagLoadingFolders" transition="scale-transition" type="list-item">
          <v-row id="folder_list_id_mobile" style="margin-top: 0px; display: block">
            <v-col class="col-12" style="padding: 0">
              <div id="folder-list-mobile" class="folder-list-container" style="max-width: 275px">
                <div v-for="(folder, idx) in folders" :key="folder.id" class="folder-item">
                  <div
                    class="folder-view"
                    :class="{
                      'drop-target': isDroppingOnFolder === folder.id,
                      'folder-updated-success': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success',
                      'folder-updated-error': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error',
                    }"
                    elevation="0"
                    @click="toggleFolder(folder)"
                  >
                    <div class="folder-view-content">
                      <v-icon size="24" class="mr-2" :color="folder.expanded ? selectedColor : 'rgba(0,0,0,0.6)'">
                        {{ folder.expanded ? 'mdi-folder-open' : 'mdi-folder' }}
                      </v-icon>
                      <span class="folder-name" :class="{ 'folder-name-active': folder.expanded }">{{ folder.name }}</span>
                      <!-- Success indicator -->
                      <transition name="fade">
                        <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success'" color="success" size="20" class="folder-status-icon success-bounce">
                          mdi-check-circle
                        </v-icon>
                      </transition>
                      <!-- Error indicator -->
                      <transition name="fade">
                        <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error'" color="error" size="20" class="folder-status-icon error-shake">
                          mdi-alert-circle
                        </v-icon>
                      </transition>
                      <v-menu bottom right transition="slide-y-transition" :close-on-content-click="true" offset-y min-width="180" content-class="folder-menu-container">
                        <template v-slot:activator="{ props }">
                          <v-btn icon v-bind="props" variant="text" size="large" :color="selectedColor" class="topic-menu-button" style="width: 35px !important; height: 35px !important">
                            <v-icon size="small">mdi-dots-vertical</v-icon>
                            <v-tooltip activator="parent" location="top">{{ $t('navb_moreActions') }}</v-tooltip>
                          </v-btn>
                        </template>
                        <v-card class="folder-menu-card">
                          <div class="folder-menu-list">
                            <div
                              class="folder-menu-item mb-1 px-2"
                              @click="startEditFolder(folder, idx)"
                              style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease"
                            >
                              <div class="mr-2 d-flex align-center justify-center">
                                <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                              </div>
                              <div>
                                <span class="body-2">Rename</span>
                              </div>
                            </div>
                            <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px"></div>
                            <div
                              class="folder-menu-item mt-1 px-2"
                              @click="openDeleteDialog(folder, idx)"
                              style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease"
                            >
                              <div class="mr-2 d-flex align-center justify-center">
                                <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                              </div>
                              <div>
                                <span class="body-2 error--text" style="color: #ff5252 !important">Delete</span>
                              </div>
                              <v-tooltip activator="parent" location="end" max-width="420"><span>{{ $t('navb_help_folderDelete') }}</span></v-tooltip>
                            </div>
                          </div>
                        </v-card>
                      </v-menu>
                    </div>
                  </div>
                  <!-- {{ Subtopic }} -->
                  <div v-if="folder.expanded" class="folder-subtopics" style="padding: 8px 0px 0px 6px !important">
                    <div class="topic-list-container">
                      <div v-show="folder.topics">
                        <div v-for="(item, index) in folder.topics" :key="item.topicID" style="border-radius: 14px" :class="item.topicID === Log_History_TopicID ? 'highlighted-topic' : ''">
                          <!-- Editing State -->
                          <div v-if="item.status == true" class="topic-item topic-item--editing">
                            <div class="d-flex align-center w-100">
                              <div class="flex-grow-1 mr-2">
                                <v-text-field
                                  class="Cls_Text_field_TopicName"
                                  :id="'TopicId_' + item.topicID"
                                  variant="outlined"
                                  density="compact"
                                  hide-details
                                  v-model="item.topicName"
                                  rounded="lg"
                                  style="width: 100%; background-color: #ffffff; font-family: 'Inter', sans-serif"
                                  @blur="
                                    () => {
                                      item.status = false;
                                      RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token);
                                    }
                                  "
                                  @keyup="keyupKeyRename()"
                                  @keyup.enter="
                                    item.status = false;
                                    RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token);
                                  "
                                />
                              </div>
                            </div>
                          </div>
                          <!-- Normal State -->
                          <div v-else class="topic-item topic-item--clickable" @click="selectTopic(item)">
                            <div class="d-flex align-center w-100">
                              <div class="topic-icon-wrapper mr-3">
                                <v-img :src="chatTopicIcon" alt="Topic Icon" height="16" width="16" contain />
                              </div>
                              <div class="topic-content flex-grow-1 mr-2">
                                <v-tooltip location="top" open-delay="300" max-width="300">
                                  <template v-slot:activator="{ props }">
                                    <div v-bind="props" class="topic-title-wrapper" style="max-width: 100%">
                                      <span class="topic-title text-truncate">
                                        {{ item.topicName }}
                                      </span>
                                    </div>
                                  </template>
                                  <span>{{ item.topicName.length > 100 ? item.topicName.substring(0, 100) + '...' : item.topicName }}</span>
                                </v-tooltip>
                              </div>
                              <v-menu location="bottom left" transition="slide-y-transition" :close-on-content-click="true" offset-y min-width="200" content-class="topic-menu-container">
                                <template v-slot:activator="{ props }">
                                  <v-btn icon v-bind="props" variant="text" size="large" :color="selectedColor" class="topic-menu-button">
                                    <v-icon size="small">mdi-dots-vertical</v-icon>
                                    <v-tooltip activator="parent" location="top">{{ $t('navb_moreActions') }}</v-tooltip>
                                  </v-btn>
                                </template>
                                <v-card class="topic-menu-card" style="width: 200px; max-width: 100%">
                                  <div class="topic-menu-list pa-2" style="border-radius: 12px; border: none; overflow: hidden; background: white">
                                    <div
                                      class="topic-menu-item mb-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                      @click="openMoveToFolderDialog(item)"
                                    >
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                                      </div>
                                      <div class="d-flex align-center">
                                        <span class="body-2">Move to folder</span>
                                      </div>
                                    </div>
                                    <div
                                      class="topic-menu-item mb-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                      @click="removeTopicFromFolder(folder.id, item.topicID, index)"
                                    >
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" color="warning">mdi-folder-remove</v-icon>
                                      </div>
                                      <div class="d-flex align-center">
                                        <span class="body-2">Remove from folder</span>
                                      </div>
                                      <v-tooltip activator="parent" location="end" max-width="420"><span>{{ $t('navb_help_topicMenuActions') }}</span></v-tooltip>
                                    </div>
                                    <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px"></div>
                                    <div
                                      class="topic-menu-item mt-1 mb-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                      @click="
                                        RenameChat(item);
                                        focusInput('TopicId_' + item.topicID);
                                      "
                                    >
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                      </div>
                                      <div>
                                        <span class="body-2">Rename</span>
                                      </div>
                                    </div>
                                    <div
                                      class="topic-menu-item mt-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                                      @click="openDeleteTopicDialog(item)"
                                    >
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                      </div>
                                      <div>
                                        <span class="body-2 error--text" style="color: #ff5252 !important">Delete chat</span>
                                      </div>
                                      <v-tooltip activator="parent" location="end" max-width="420"><span>{{ $t('navb_help_topicMenuActions') }}</span></v-tooltip>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="!folder.topics || folder.topics.length === 0" class="empty-folder-state">
                        <v-icon color="grey lighten-1" size="20">mdi-chat-outline</v-icon>
                        <span class="empty-folder-text ml-2">No chats in this folder</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-skeleton-loader>

        <!-- Topics -->
        <v-row style="padding-top: 21px">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Topics</span>
          </v-col>
          <!-- NEW CHAT -->
          <v-col class="col-7" style="background-color: transparent; padding-top: 0px; display: flex; justify-content: flex-end; align-items: center">
            <div :color="selectedColor" depressed rounded hide-details class="new-chat-fab" style="margin-right: 5px; height: 26px !important; width: 26px !important" v-on:click="newChat()">
              <v-img
                :src="chatTopicPlusIcon"
                alt="Plus Icon"
                height="24"
                width="24"
                style="margin-left: 2px; filter: brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(831%) hue-rotate(102deg) brightness(95%) contrast(88%)"
              />
            </div>
          </v-col>
        </v-row>

        <!-- Topic List -->
        <v-row id="topic_list_id_mobile" style="margin-top: 21px; display: block">
          <v-col class="col-12" style="padding-top: 0px; padding-bottom: 10px">
            <div class="topic-scroll-container">
              <div v-for="(item, index) in topicsNotInFolders" :key="item.topicID" style="border-radius: 14px" :class="highlightTopic(item)">
                <!-- Editing State -->
                <div v-if="item.status == true" class="topic-item topic-item--editing">
                  <div class="d-flex align-center w-100">
                    <div class="flex-grow-1 mr-2">
                      <v-text-field
                        class="Cls_Text_field_TopicName"
                        :id="'TopicId_' + item.topicID"
                        variant="outlined"
                        density="compact"
                        hide-details
                        v-model="item.topicName"
                        rounded="lg"
                        style="width: 100%; background-color: #ffffff; font-family: 'Inter', sans-serif"
                        @blur="
                          item.status = false;
                          RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token);
                        "
                        @keyup="keyupKeyRename()"
                        @keyup.enter="
                          item.status = false;
                          RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token);
                        "
                      />
                    </div>
                  </div>
                </div>

                <!-- Normal State -->
                <div v-else class="topic-item topic-item--clickable" @click="selectTopicOutside(item)">
                  <div class="d-flex align-center w-100">
                    <div class="topic-icon-wrapper mr-3">
                      <v-img :src="chatTopicIcon" alt="Topic Icon" height="16" width="16" contain />
                    </div>

                    <div class="topic-content flex-grow-1 mr-2">
                      <v-tooltip location="top" open-delay="300" max-width="300">
                        <template v-slot:activator="{ props }">
                          <div v-bind="props" class="topic-title-wrapper">
                            <span class="topic-title text-truncate">
                              {{ item.topicName }}
                            </span>
                          </div>
                        </template>
                        <span>{{ item.topicName.length > 100 ? item.topicName.substring(0, 100) + '...' : item.topicName }}</span>
                      </v-tooltip>
                    </div>

                    <v-menu location="right top" transition="slide-y-transition" :close-on-content-click="true" min-width="200" content-class="topic-menu-container">
                      <template v-slot:activator="{ props }">
                        <v-btn icon v-bind="props" variant="text" size="large" :color="selectedColor" class="topic-menu-button opacity-60">
                          <v-icon size="small">mdi-dots-vertical</v-icon>
                          <v-tooltip activator="parent" location="top">{{ $t('navb_moreActions') }}</v-tooltip>
                        </v-btn>
                      </template>
                      <v-card class="topic-menu-card" style="width: 200px">
                        <div class="topic-menu-list pa-2" style="border-radius: 12px; border: none; overflow: hidden; background: white">
                          <div
                            class="topic-menu-item mb-1 d-flex align-center"
                            style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                            @click="openMoveToFolderDialog(item)"
                          >
                            <div class="mr-2 d-flex align-center justify-center">
                              <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                            </div>
                            <div class="d-flex align-center">
                              <span class="body-2">Move to folder</span>
                            </div>
                          </div>

                          <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px"></div>

                          <div
                            class="topic-menu-item mt-1 mb-1"
                            style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                            @click="
                              RenameClick(item, 'TopicId_' + item.topicID);
                              focusInput('TopicId_' + item.topicID);
                            "
                          >
                            <div class="mr-2 d-flex align-center justify-center">
                              <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                            </div>
                            <div>
                              <span class="body-2">Rename</span>
                            </div>
                          </div>

                          <div
                            class="topic-menu-item mt-1"
                            style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer"
                            @click="openDeleteTopicDialog(item)"
                          >
                            <div class="mr-2 d-flex align-center justify-center">
                              <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                            </div>
                            <div>
                              <span class="body-2 error--text" style="color: #ff5252 !important">Delete chat</span>
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-if="pathUrl != 'FullStream' && pathUrl.toLocaleLowerCase() != 'fullstreamdga' && pathUrl != ''"
      style="
        overflow-y: hidden;
        background-color: var(--dga-color-sidebar);
        background-image: none;
        padding-bottom: calc(0px + env(safe-area-inset-bottom));
        border-radius: 0px;
        border: none !important;
        box-shadow: 1px 0 0 var(--dga-color-border) !important;
        font-family: var(--dga-font-family);
      "
      v-model="drawer"
      location="left"
      width="260"
      app
      clipped
    >
      <v-list-item>
        <v-list-item-content>
          <div class="d-flex flex-column align-center justify-center py-3">
            <v-avatar color="primary" size="42">
              <span class="white--text text-h5">{{ shotName }}</span>
            </v-avatar>

            <div class="profile-info">
              <h3 class="profile-name">{{ fullName }}</h3>
              <v-chip size="small" label color="primary" variant="flat" class="role-chip mt-1" :ripple="false">
                <span class="role-text">{{ role }}</span>
              </v-chip>
            </div>
          </div>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list class="modern-menu px-2" nav>
        <div v-for="(item, id) in filteredItems" :key="id">
          <!-- รายการเมนูที่ไม่มีเมนูย่อย
               เมนูที่เปิด wizard (เช่น "AI Assistant") ไม่ใช่ลิงก์: เปิด dialog ทับหน้าปัจจุบัน และไม่ทำให้เมนูอื่นหลุด active -->
          <v-list-item
            v-if="item.childstatus == true"
            :to="sidebarWizardMode(item) ? undefined : { path: item.route, replace: false }"
            @click="onSidebarItemClick(item)"
            active-class="menu-active"
            v-show="item.Check == true"
            class="menu-item my-1 rounded-lg"
            :ripple="{ class: 'primary--text' }"
          >
            <template v-slot:prepend>
              <div class="icon-container d-flex align-center justify-center me-3">
                <v-badge v-if="item.route == '/ChatService' && unreadCount > 0" color="error" :content="unreadCount ?? 0" :value="unreadCount ?? 0" offset-x="3" offset-y="3">
                  <v-icon size="small" :color="'rgba(0, 0, 0, 0.54)'">{{ item.icon }}</v-icon>
                </v-badge>
                <v-icon size="small" :color="'rgba(0, 0, 0, 0.54)'" v-else>{{ item.icon }}</v-icon>
              </div>
            </template>

            <v-tooltip location="right" open-delay="500">
              <template v-slot:activator="{ props }">
                <div v-bind="props" class="menu-item-content">
                  <v-list-item-title class="menu-title">
                    {{ localize(substring(item.title)) }}
                  </v-list-item-title>
                </div>
              </template>
              <span>{{ $t(item.title) }}</span>
            </v-tooltip>
          </v-list-item>

          <!-- รายการเมนูที่มีเมนูย่อย -->
          <v-list-group v-else v-model="openMenus[id]" active-class="menu-group-active" v-show="item.Check == true" class="menu-group my-1" :ripple="false">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" class="rounded-lg menu-group-header">
                <template v-slot:prepend>
                  <div class="icon-container d-flex align-center justify-center me-3">
                    <v-icon size="small" :color="'rgba(0, 0, 0, 0.54)'">{{ item.icon }}</v-icon>
                  </div>
                </template>
                <v-list-item-title class="menu-title">{{ localize(item.title) }}</v-list-item-title>
              </v-list-item>
            </template>

            <!-- รายการเมนูย่อย -->
            <div class="submenu-container ml-2">
              <v-list-item
                v-for="(childrenItem, childrenId) in item.children"
                :key="childrenId"
                :to="childrenItem.route"
                active-class="submenu-active"
                v-show="childrenItem.Check == true"
                class="submenu-item rounded-lg my-1 ps-4"
                :ripple="{ class: 'primary--text' }"
              >
                <v-list-item-title class="submenu-title">{{ localize(substring(childrenItem.title)) }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-breadcrumbs v-if="pathUrl != 'FullStream' && pathUrl != 'FlowCreator'" :items="breadcrumbsList" class="fixed-breadcrumbs" :style="{ paddingLeft: paddingLeft }">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item :href="item.query == true && queryID != undefined && queryID != null ? item.href + '?id=' + queryID : item.href" :text="item.href" :disabled="item.disabled">
          {{ localize(item.title) }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <!-- LLM Model Dropdown Dialog -->
    <v-dialog v-model="showModelDropdownDialog" max-width="500px" :close-on-content-click="false" :persistent="false" transition="dialog-transition">
      <!-- Dialog content -->
      <v-card class="llm-dialog-card-v2">
        <v-card-title class="llm-dialog-header-v2 d-flex justify-space-between align-center">
          <span>{{ $t('navb_selectLlmModel') }}</span>
          <v-btn icon size="small" variant="text" @click="closeModelDropdownDialog">
            <v-icon>mdi-close</v-icon>
            <v-tooltip activator="parent" location="top">{{ $t('close') }}</v-tooltip>
          </v-btn>
        </v-card-title>

        <v-card-text class="llm-dialog-content-v2">
          <v-expansion-panels v-model="expandedPanel" variant="accordion" class="llm-panels-v2" flat>
            <v-expansion-panel v-for="provider in providers" :key="provider.id" class="llm-panel-item-v2">
              <v-expansion-panel-title class="py-2 llm-panel-header-v2">
                <div class="d-flex align-center">
                  <v-icon size="16" :color="provider.color" class="mr-2">{{ provider.icon }}</v-icon>
                  <span class="llm-provider-name-v2">{{ provider.name }}</span>
                  <v-chip size="x-small" class="ml-2 llm-count-chip-v2" :color="`${provider.color}15`" :text-color="provider.color">
                    {{ getModelsByProvider(provider.id).length }}
                  </v-chip>
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pt-0 pb-0 llm-panel-content-v2">
                <v-list density="compact" class="llm-model-list-v2 py-0">
                  <v-list-item
                    v-for="model in getModelsByProvider(provider.id)"
                    :key="model.id"
                    @click="
                      SelectLLMMdel(model);
                      closeModelDropdown();
                      closeModelDropdownDialog();
                    "
                    class="llm-model-item-v2"
                    :class="{ 'llm-model-selected-v2': selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay }"
                  >
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="subtitle-2">{{ model.modelDisplay }}</v-list-item-title>
                      <v-list-item-subtitle class="caption text--secondary">{{ model.modelName }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <template v-if="selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay">
                      <v-list-item-action>
                        <v-icon size="16" color="primary">mdi-check</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--Consent PDPA-->
    <v-dialog v-if="flagUpdateVersion" v-model="consent_dialog" persistent max-width="900px" class="consent-dialog">
      <v-card class="consent-card" elevation="12">
        <!-- Header with gradient -->
        <v-card-title class="consent-header">
          <div class="header-content">
            <div class="header-icon">
              <v-icon size="28" color="white">mdi-shield-check</v-icon>
            </div>
            <div class="header-text">
              <h2 class="consent-title">ข้อกำหนดและเงื่อนไขการขอใช้บริการ</h2>
              <p class="consent-subtitle">โปรดตรวจสอบและยอมรับเงื่อนไขการใช้งานบริการของเรา</p>
            </div>
          </div>
        </v-card-title>

        <!-- Version and Language Selection -->
        <div class="version-language-section">
          <div class="version-info">
            <v-chip color="primary" variant="outlined" size="small" prepend-icon="mdi-information"> Version {{ dataVersion }} </v-chip>
          </div>

          <div class="language-selector">
            <v-btn-toggle v-model="selectedLanguage" color="primary" variant="outlined" density="compact" class="language-toggle">
              <v-btn value="th" @click="dataConsent = dataConsentTH" class="language-btn">
                <flag style="margin-right: 8px" iso="TH" />
                ไทย
              </v-btn>
              <v-btn value="en" @click="dataConsent = dataConsentEN" class="language-btn">
                <flag style="margin-right: 8px" iso="US" />
                English
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>

        <!-- Content Area -->
        <v-card-text class="consent-content">
          <div class="content-wrapper">
            <div class="content-scroll-area">
              <div class="consent-text-content" v-html="dataConsent"></div>
            </div>
          </div>
        </v-card-text>

        <!-- Action Buttons -->
        <v-card-actions class="consent-actions">
          <v-spacer></v-spacer>
          <v-btn id="button-disagreeconsent-navbar" variant="outlined" color="error" size="large" class="consent-action-btn decline-btn" @click="DisAgreeConsent()" prepend-icon="mdi-close">
            Decline
          </v-btn>
          <v-btn id="button-agreeconsent-navbar" color="success" size="large" class="consent-action-btn accept-btn" @click="AgreeConsent()" prepend-icon="mdi-check"> Accept & Continue </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Folder editor-->
    <v-dialog v-model="folderDialog.visible" max-width="400" transition="slide-y-transition" content-class="folder-dialog-wrapper" style="border-radius: 18px !important">
      <v-card class="folder-dialog" :elevation="5">
        <v-card-title class="dialog-title">
          <v-icon left color="rgb(76, 175, 135)" class="folder-icon-animation mr-3" size="28">
            {{ folderDialog.isNew ? 'mdi-folder-plus' : 'mdi-folder-edit' }}
          </v-icon>
          <span class="headline">{{ folderDialog.isNew ? 'Create Folder' : 'Rename Folder' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="dialog-content pt-4">
          <p class="subtitle-2 text--secondary mb-2">
            {{ folderDialog.isNew ? 'Create a new folder to organize your chats.' : 'Update the name for this folder.' }}
          </p>
          <v-text-field
            v-model="folderDialog.name"
            label="Folder Name"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            autofocus
            @keyup.enter="confirmFolderDialog"
            color="rgb(76, 175, 135)"
            placeholder="Enter folder name"
            counter="50"
            maxlength="50"
            class="input-folder mt-3"
            rounded="lg"
            bg-color="white"
          >
            <template v-slot:prepend-inner>
              <v-icon color="rgb(76, 175, 135)" class="folder-icon-pulse">mdi-folder-outline</v-icon>
            </template>
            <template v-slot:append-inner>
              <v-fade-transition>
                <v-tooltip v-if="folderDialog.name" location="top" max-width="400">
                  <template #activator="{ props }">
                    <v-icon size="small" color="rgb(76, 175, 135)" v-bind="props" @click="folderDialog.name = ''" class="clear-input-icon"> mdi-close-circle </v-icon>
                  </template>
                  <span>{{ $t('navb_clearInput') }}</span>
                </v-tooltip>
              </v-fade-transition>
            </template>
          </v-text-field>
        </v-card-text>

        <v-card-actions class="dialog-actions pa-4">
          <v-spacer />
          <v-btn text class="cancel-btn" @click="closeFolderDialog" :disabled="folderDialogStatus.isLoading">
            <span class="text-capitalize">Cancel</span>
          </v-btn>
          <v-btn
            text
            :color="folderDialogStatus.isSuccess ? 'success' : folderDialogStatus.isError ? 'error' : selectedColor"
            class="save-btn"
            :class="{
              'loading-btn': folderDialogStatus.isLoading,
              'success-btn': folderDialogStatus.isSuccess,
              'error-btn': folderDialogStatus.isError,
            }"
            :disabled="!folderDialog.name || folderDialogStatus.isLoading || folderDialogStatus.isSuccess"
            @click="confirmFolderDialog"
          >
            <transition name="fade-btn" mode="out-in">
              <template v-if="folderDialogStatus.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                  <span class="text-capitalize">Saving...</span>
                </div>
              </template>
              <template v-else-if="folderDialogStatus.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation mr-1">mdi-check-circle</v-icon>
                  <span class="text-capitalize">Done!</span>
                </div>
              </template>
              <template v-else-if="folderDialogStatus.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation mr-1">mdi-alert-circle</v-icon>
                  <span class="text-capitalize">Failed</span>
                </div>
              </template>
              <template v-else>
                <span class="text-capitalize">{{ folderDialog.isNew ? 'Create' : 'Save' }}</span>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteFolderDialog.visible" max-width="400" style="border-radius: 18px !important">
      <v-card class="delete-folder-dialog" style="border-radius: 18px; overflow: hidden">
        <v-card-title class="dialog-header">
          <v-icon color="error" class="mr-2" size="28">mdi-alert-circle</v-icon>
          <span class="title">Delete folder?</span>
        </v-card-title>

        <v-card-text class="dialog-content">
          <p class="folder-name-delete mb-3" style="white-space: normal; word-wrap: break-word; width: 100%">
            "{{ deleteFolderDialog.name.substring(0, 28) + (deleteFolderDialog.name.length > 28 ? '...' : '') }}"
          </p>
          <p class="warning-text">
            This will permanently delete this folder and all its contents.
            <span class="font-weight-medium">This action cannot be undone.</span>
          </p>
          <p class="hint-text mt-4">To save topics, move them to your chat list or another folder before deleting.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-btn text class="cancel-btn" @click="closeDeleteDialog" :disabled="deleteFolderDialog.isLoading"> Cancel </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :color="deleteFolderDialog.isSuccess ? 'success' : deleteFolderDialog.isError ? 'error' : 'error'"
            class="delete-btn"
            :class="{
              'loading-btn': deleteFolderDialog.isLoading,
              'success-btn': deleteFolderDialog.isSuccess,
              'error-btn': deleteFolderDialog.isError,
            }"
            :disabled="deleteFolderDialog.isLoading || deleteFolderDialog.isSuccess"
            @click="confirmDeleteDialog"
          >
            <transition name="fade-btn" mode="out-in">
              <template v-if="deleteFolderDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                  <span>Deleting...</span>
                </div>
              </template>
              <template v-else-if="deleteFolderDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Deleted</span>
                </div>
              </template>
              <template v-else-if="deleteFolderDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <div class="d-flex align-center">
                  <v-icon left small>mdi-delete</v-icon>
                  <span>Delete</span>
                </div>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="moveToFolderDialog.visible" max-width="400" transition="slide-y-transition" content-class="move-folder-dialog" style="border-radius: 18px !important">
      <v-card class="folder-dialog">
        <v-card-title class="dialog-title">
          <v-icon left :color="selectedColor" class="move-icon mr-2">mdi-folder-move</v-icon>
          <span class="headline">Move to Folder</span>
        </v-card-title>
        <v-card-text class="dialog-content">
          <p class="mb-2">
            Select destination folder for "<span class="topic-highlight"> {{ moveToFolderDialog.topicName.substring(0, 28) + (moveToFolderDialog.topicName.length > 28 ? '...' : '') }}</span
            >"
          </p>

          <div class="folder-selector-container" :class="{ 'options-loading': moveToFolderDialog.isLoading }">
            <div
              v-for="folder in filteredFolders"
              :key="folder.id"
              class="folder-option"
              :class="{
                'folder-option-selected': moveToFolderDialog.selectedFolderId === folder.id,
                'folder-option-disabled': folder.id === moveToFolderDialog.currentFolderId,
              }"
              @click="!isFolderDisabled(folder) && selectFolder(folder.id)"
            >
              <div class="folder-option-icon">
                <v-icon :color="isFolderSelected(folder) ? selectedColor : 'grey darken-1'" size="24">
                  {{ isFolderSelected(folder) ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
              </div>
              <div class="folder-option-content">
                <div class="folder-option-name">{{ folder.name.substring(0, 20) + (folder.name.length > 20 ? '...' : '') }}</div>
                <div class="folder-option-info" v-if="folder.topics && folder.topics.length > 0">{{ folder.topics.length }} topic{{ folder.topics.length > 1 ? 's' : '' }}</div>
              </div>
              <div class="folder-option-action">
                <v-icon v-if="isFolderSelected(folder)" :color="selectedColor" size="20" class="check-animation"> mdi-check-circle </v-icon>
              </div>
            </div>

            <div v-if="!filteredFolders.length" class="text-center pa-4">
              <v-icon color="grey lighten-1" size="48">mdi-folder-outline</v-icon>
              <p class="text-subtitle-1 grey--text text--darken-1 mt-2">No folders available</p>
              <v-btn small color="primary" text class="mt-2" @click="createFolder">
                <v-icon left size="18" color="rgb(76, 175, 135)">mdi-folder-plus</v-icon>
                Create a new folder
              </v-btn>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text class="cancel-btn" @click="closeMoveToFolderDialog" :disabled="moveToFolderDialog.isLoading">Cancel</v-btn>
          <v-btn
            text
            :color="moveToFolderDialog.isSuccess ? 'success' : moveToFolderDialog.isError ? 'error' : selectedColor"
            class="save-btn"
            :class="{
              'loading-btn': moveToFolderDialog.isLoading,
              'success-btn': moveToFolderDialog.isSuccess,
              'error-btn': moveToFolderDialog.isError,
            }"
            :disabled="!moveToFolderDialog.selectedFolderId || moveToFolderDialog.selectedFolderId === moveToFolderDialog.currentFolderId || moveToFolderDialog.isLoading"
            @click="confirmMoveToFolder"
          >
            <transition name="fade-btn" mode="out-in">
              <template v-if="moveToFolderDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                  <span>Moving...</span>
                </div>
              </template>
              <template v-else-if="moveToFolderDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Done!</span>
                </div>
              </template>
              <template v-else-if="moveToFolderDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <span>Move</span>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeTopicDialog.visible" max-width="400" transition="slide-y-transition" content-class="remove-topic-dialog" style="border-radius: 18px !important">
      <v-card class="folder-dialog">
        <v-card-title class="dialog-title">
          <v-icon left color="warning" class="mr-2">mdi-folder-remove</v-icon>
          <span class="headline">Remove from folder?</span>
        </v-card-title>

        <v-card-text class="dialog-content">
          <p class="mb-3">
            <span class="topic-highlight">"{{ removeTopicDialog.topicName.substring(0, 28) + (removeTopicDialog.topicName.length > 28 ? '...' : '') }}"</span>
            <br />
            will be moved to your main chat list.
          </p>

          <v-alert dense text color="info" border="left" class="mb-0 mt-4">
            <v-icon left small>mdi-information</v-icon>
            You can always add it back to this or another folder later.
          </v-alert>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text class="cancel-btn" @click="closeRemoveTopicDialog" :disabled="removeTopicDialog.isLoading"> Cancel </v-btn>
          <v-btn
            text
            :color="removeTopicDialog.isSuccess ? 'success' : removeTopicDialog.isError ? 'error' : 'warning'"
            class="remove-btn"
            :class="{
              'loading-btn': removeTopicDialog.isLoading,
              'success-btn': removeTopicDialog.isSuccess,
              'error-btn': removeTopicDialog.isError,
            }"
            :disabled="removeTopicDialog.isLoading"
            @click="confirmRemoveTopic"
          >
            <transition name="fade-btn" mode="out-in">
              <template v-if="removeTopicDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                  <span>Removing...</span>
                </div>
              </template>
              <template v-else-if="removeTopicDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Removed</span>
                </div>
              </template>
              <template v-else-if="removeTopicDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <div class="d-flex align-center">
                  <v-icon left small>mdi-folder-remove</v-icon>
                  <span>Remove</span>
                </div>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteTopicDialog.visible" max-width="400" transition="slide-y-transition" content-class="delete-topic-dialog" style="border-radius: 18px !important">
      <v-card class="folder-dialog">
        <v-card-title class="dialog-title">
          <v-icon left color="error" class="mr-2">mdi-alert-circle</v-icon>
          <span class="headline">Delete this chat?</span>
        </v-card-title>

        <v-card-text class="dialog-content">
          <p class="mb-3">
            <span class="topic-highlight">"{{ deleteTopicDialog.topicName.substring(0, 28) + (deleteTopicDialog.topicName.length > 28 ? '...' : '') }}"</span>
            <br />
            will be permanently deleted.
          </p>

          <v-alert dense text color="error" border="left" class="mb-0 mt-4">
            <v-icon left small>mdi-information</v-icon>
            This action cannot be undone. All messages in this chat will be lost.
          </v-alert>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text class="cancel-btn" @click="closeDeleteTopicDialog" :disabled="deleteTopicDialog.isLoading"> Cancel </v-btn>
          <v-btn
            color="error"
            class="delete-btn"
            :class="{
              'loading-btn': deleteTopicDialog.isLoading,
              'success-btn': deleteTopicDialog.isSuccess,
              'error-btn': deleteTopicDialog.isError,
            }"
            :disabled="deleteTopicDialog.isLoading || deleteTopicDialog.isSuccess"
            @click="confirmDeleteTopic"
          >
            <transition name="fade-btn" mode="out-in">
              <template v-if="deleteTopicDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                  <span>Deleting...</span>
                </div>
              </template>
              <template v-else-if="deleteTopicDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Deleted</span>
                </div>
              </template>
              <template v-else-if="deleteTopicDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <div class="d-flex align-center">
                  <v-icon left small>mdi-delete</v-icon>
                  <span>Delete</span>
                </div>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- wizard "สร้าง AI Assistant ของคุณ" — โหลด component ตอนเปิดครั้งแรก
         first-time: เด้งเองครั้งแรกที่ Admin เข้าหน่วยงาน + เมนูโปรไฟล์ (ไว้ทดสอบ) · assistant: เมนู "AI Assistant" ใน sidebar -->
    <AssistantSetupWizard v-if="assistantWizardLoaded" v-model="assistantWizardOpen" :mode="assistantWizardMode" />
  </nav>

  <div v-if="backToSuperAdminLoading" class="superadmin-transition-shell" aria-live="polite" aria-busy="true">
    <aside class="superadmin-transition-sidebar">
      <div class="superadmin-transition-logo-row">
        <v-skeleton-loader type="avatar" class="superadmin-transition-logo-skeleton"></v-skeleton-loader>
        <div class="superadmin-transition-logo-text">
          <v-skeleton-loader type="text" width="120"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="92"></v-skeleton-loader>
        </div>
      </div>

      <div class="superadmin-transition-menu">
        <v-skeleton-loader v-for="item in 8" :key="`superadmin-nav-skeleton-${item}`" type="list-item-avatar" class="superadmin-transition-menu-item"></v-skeleton-loader>
      </div>
    </aside>

    <section class="superadmin-transition-main">
      <header class="superadmin-transition-topbar">
        <v-skeleton-loader type="text" width="240"></v-skeleton-loader>
        <div class="superadmin-transition-topbar-actions">
          <v-skeleton-loader type="avatar" class="superadmin-transition-action"></v-skeleton-loader>
          <v-skeleton-loader type="avatar" class="superadmin-transition-action"></v-skeleton-loader>
          <v-skeleton-loader type="avatar" class="superadmin-transition-action"></v-skeleton-loader>
        </div>
      </header>

      <div class="superadmin-transition-content">
        <div class="superadmin-transition-status">
          <v-progress-circular indeterminate size="28" width="3" color="primary"></v-progress-circular>
          <div>
            <div class="superadmin-transition-title">{{ $t('backtosuperadmin') }}</div>
            <div class="superadmin-transition-subtitle">{{ $t('loadingpleasewait') }}</div>
          </div>
        </div>

        <div class="superadmin-transition-hero">
          <v-skeleton-loader type="heading" width="300"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="220"></v-skeleton-loader>
        </div>

        <div class="superadmin-transition-cards">
          <v-skeleton-loader v-for="card in 4" :key="`superadmin-card-skeleton-${card}`" type="card" class="superadmin-transition-card"></v-skeleton-loader>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import store from '../store';
import Cookies from 'js-cookie';
import { useDisplay } from 'vuetify';
import { version } from '../../package.json';

import dgaLogo from '@/assets/DGAlogo.png';

import fullDrawerImg from '@/assets/images/NavMenu icon.png';
import notificationSound from '@/assets/sounds/notification-2-269292.mp3';
import chatTopicIconImg from '@/assets/images/Topic.svg';
import chatTopicPlusIconImg from '@/assets/images/TopicPlus.svg';
import * as signalR from '@microsoft/signalr';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import draggable from 'vuedraggable';
import { defineAsyncComponent } from 'vue';
import { shouldAutoOpenWizard, shouldCheckOnboarding, sidebarWizardMode as wizardModeOfSidebarItem } from './onboarding/assistantWizardEntry.js';
import { allowedPagesFromResponse } from '@/utils/companyPagePermission';
import { portalRoleLabelKey } from '@/utils/portalRole';
import { brand } from '@/components/ds/tokens/tokens.js';

export default {
  name: 'Navbar',
  inject: [
    'SetStatusKeyRename',
    'tabSocialType',
    'getStartUpImage',
    'flagNav',
    'Status_Error',
    'Snippet_Username',
    'Snippet_Status',
    'User_Id_Show',
    'User_Id',
    'User_Id_Status',
    'Time_Delay',
    'flagShowTopic',
    'LeftNavBar',
    'SetPopup',
    'flagGetAllTopic',
    'miniVariant',
    'NavbarTxtColorTheme',
    'NavbarBtnColorTheme',
    'ModelFirst',
    'colorThemeChat',
    'TopicName',
    'listTopic',
    'Log_History_TopicID',
    'Click_History_List',
    'DeleteTopicStream',
    'RenameClick',
    'RenameTopicStream',
    'keyupKeyRename',
    'auth_token',
    'isAllowLLMChange',
    'FileUploadLimit',
    'IsChainMassage',
    'maximumChatInput',
    'IsAllowImage',
    'Time_Delay',
    'TopicModelID',
    'selectedLLMModelInChat',
    'lastLLMID',
    'firstModel',
    'ResetTextToImageFlagF',
  ],
  components: {
    draggable,
    AssistantSetupWizard: defineAsyncComponent(() => import('./onboarding/AssistantSetupWizard.vue')),
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const display = useDisplay();
    const { locale } = useI18n();
    const { t } = useI18n();
    return {
      display,
      route,
      router,
      locale,
      t,
    };
  },
  data() {
    const initialUrl = new URL(globalThis.location.href);
    const initialParameterURL = [];

    for (const [key, value] of initialUrl.searchParams) {
      initialParameterURL[key.toLowerCase()] = value;
    }

    return {
      selectedLanguage: 'th',
      expandedPanel: 0,
      backToSuperAdminLoading: false,
      profileMenuOpen: false,
      assistantWizardLoaded: false,
      assistantWizardOpen: false,
      assistantWizardMode: 'first-time',
      // GetConsentConfig ตอบแล้ว (สำเร็จหรือไม่ก็ตาม) — wizard ที่เด้งครั้งแรกต้องรอรู้ก่อนว่า consent dialog จะขึ้นไหม
      consentChecked: false,
      // ถามสถานะ "เคยเห็น wizard แล้วหรือยัง" ไปแล้วในการโหลดหน้านี้ (ถามครั้งเดียว)
      assistantOnboardingChecked: false,
      allLLMModel: [],
      selectedLLMModel: null,
      showModelDropdown: false,
      showModelDropdownDialog: false,
      providers: [
        { id: 'azure', name: 'Azure', icon: 'mdi-microsoft' },
        { id: 'google', name: 'Google', icon: 'mdi-google' },
        { id: 'anthropic', name: 'Anthropic', icon: 'mdi-alpha-a-circle' },
        { id: 'others', name: 'Others', icon: 'mdi-dots-horizontal-circle' },
      ],
      isScrolled: false,
      showSidebarTooltip: false,
      chatTopicIcon: chatTopicIconImg,
      chatTopicPlusIcon: chatTopicPlusIconImg,
      fullDrawerImg: fullDrawerImg,
      openMenus: {},
      urlApi: import.meta.env.VITE_APP_API,
      unreadCount: 0,
      connection: null,
      pathUrl: initialUrl.pathname.replace('/', '') || '',
      show: false,
      recentlyUpdatedFolderId: null,
      folderUpdateStatus: null,
      isDeleting: false,
      isDroppingOnFolder: null,
      isStartFromOutside: false,
      draggedItem: null,
      targetFolder: null,
      targetToOutsideArea: false,
      drag: false,
      deleteTopicDialog: {
        visible: false,
        topicId: null,
        keyTopic: null,
        index: null,
        topicName: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      },
      pendingDeleteTopicIds: [],
      folderDialogStatus: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      },
      removeTopicDialog: {
        visible: false,
        folderId: null,
        topicId: null,
        topicIndex: null,
        topicName: '',
        folderName: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      },
      deleteFolderDialog: {
        visible: false,
        id: null,
        idx: null,
        name: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
        topics: [],
      },
      moveToFolderDialog: {
        visible: false,
        topicId: null,
        topicName: '',
        selectedFolderId: null,
        currentFolderId: null,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      },
      folders: [],
      flagLoadingFolders: false,
      showAllFolders: false,
      showFolderDialog: false,
      showFolderMenu: false,
      folderListSize: 999,
      folderDialog: {
        visible: false,
        isNew: false,
        id: null,
        name: '',
      },
      username: Cookies.get('username'),
      fullName: Cookies.get('fullName'),
      roleId: Cookies.get('roleId'),
      userType: Cookies.get('userType') || '',
      companyName: Cookies.get('companyName') || '',
      isSuperAdmin: store.state.isSuperAdmin,
      ProductAdminFlag: import.meta.env.VITE_APP_ProductAdmin === 'true',
      hasMultiCompany: false,
      SuperAdminRights: [
        'dashboard',
        'Vector',
        'Validation',
        'FlowList',
        'User',
        'Setting',
        'Stream',
        'Replace',
        'Report',
        'release-notes',
        'userprofile',
        'Playground',
        'IntentGroup',
        'ChatManagement',
        'Logs',
        'LogMessage',
        'LogEvent',
        'ChatService',
        'ShortcutMenu',
        // 'ProductGroup',
        'PdfToMarkdownTool',
        // กลุ่มเมนูใหม่ตาม Figma DGA
        'AIAssistant',
        'AIModels',
        'ModelComparison',
        'ServiceTheme',
      ],
      adminRights: [
        'dashboard',
        'Vector',
        'Validation',
        'FlowList',
        'User',
        'Setting',
        'Stream',
        'Replace',
        'Report',
        'release-notes',
        'userprofile',
        'Playground',
        'IntentGroup',
        'ChatManagement',
        'Logs',
        'ChatService',
        'ShortcutMenu',
        // 'ProductGroup',
        'PdfToMarkdownTool',
        // กลุ่มเมนูใหม่ตาม Figma DGA
        'AIAssistant',
        'AIModels',
        'ModelComparison',
        'ServiceTheme',
      ],
      generalUsersRights: ['GPTModelManagement', 'Vector', 'DataIntegration', 'Validation', 'FlowList', 'Stream', 'Replace', 'userprofile', 'Playground', 'IntentGroup', 'PdfToMarkdownTool', 'AIModels', 'ModelComparison'],
      operatorRights: ['GPTModelManagement', 'Vector', 'DataIntegration', 'Validation', 'FlowList', 'Stream', 'Replace', 'userprofile', 'Playground', 'IntentGroup', 'ChatService', 'ShortcutMenu', 'PdfToMarkdownTool', 'AIModels', 'ModelComparison'],
      shotName: '',
      usertype: store.state.usertype,
      drawer: null,
      images: {
        // header logo default (no custom NavLogo uploaded) — DGA logo, same as SuperAdminLayout's sidebar
        logo: dgaLogo,
        dgaLogo: dgaLogo,
      },
      currentflag: 'en',
      languages: [
        { flag: 'us', language: 'en', title: 'English' },
        { flag: 'th', language: 'th', title: 'ไทย' },
      ],
      // เมนู Admin Portal เรียงและตั้งชื่อตาม Figma DGA-AI-SMART-SEARCH (node 3046-19118 …) — เมนูที่ไม่มีในแบบ comment ไว้ท้าย array
      items: [
        {
          // title: "Dashboard",
          title: '_Dashboard',
          icon: 'mdi-view-dashboard-outline',
          route: '/dashboard',
          href: 'dashboard',
          Check: false,
          disabled: false,
          childstatus: true,
          children: [],
        },
        {
          // ตอนนี้เป็นหน้าว่าง — รอทำ wizard "สร้าง AI Assistant ของคุณ" ตาม Figma (section AI Assistant)
          title: '_AIAssistant',
          icon: 'mdi-hexagon-multiple-outline',
          route: '/AIAssistant',
          href: 'AIAssistant',
          Check: false,
          disabled: false,
          childstatus: true,
          children: [],
        },
        {
          // title: this.$t("user"),
          title: '_UserManagement',
          icon: 'mdi-account-multiple-outline',
          route: '',
          href: 'User',
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "User Management",
              title: '_PortalUserManagement',
              icon: 'mdi-account-multiple',
              route: '/UserManagement',
              href: 'UserManagement',
              Check: true,
              disabled: false,
            },
            {
              title: '_InvitationManagement',
              icon: 'mdi-email-plus-outline',
              route: '/InvitationManagement',
              href: 'InvitationManagement',
              Check: true,
              disabled: false,
              productAdminOnly: true,
            },
            {
              // title: "User Chat Management",
              title: '_ChatUserManagement',
              icon: 'mdi-account-multiple',
              route: '/UserChatManagement',
              href: 'UserChatManagement',
              Check: true,
              disabled: false,
            },
            // {
            //   // title: "User Group",
            //   title: '_GroupUserManagement',
            //   icon: 'mdi-account-multiple',
            //   route: '/GroupUserManagement',
            //   href: 'GroupUserManagement',
            //   Check: true,
            //   disabled: false,
            //   childstatus: true,
            //   children: [
            //     {
            //       // title: "User Group Management",
            //       title: '_UserGroupDetail',
            //       icon: 'mdi-account-multiple',
            //       route: '/UserGroupDetail',
            //       href: 'UserGroupDetail',
            //       query: true,
            //       Check: true,
            //       disabled: false,
            //       childstatus: true,
            //       children: [
            //         {
            //           // title: "Setup User Group",
            //           title: '_SetupUserGroup',
            //           icon: 'mdi-account-multiple',
            //           route: '/SetupUserGroup',
            //           href: 'SetupUserGroup',
            //           query: true,
            //           Check: true,
            //           disabled: false,
            //         },
            //       ],
            //     },
            //   ],
            // },
            {
              title: '_BlacklistChatUserManagement',
              icon: 'mdi-account-multiple',
              route: '/BlacklistChatUserManagement',
              href: 'BlacklistChatUserManagement',
              Check: true,
              disabled: false,
            },
          ],
        },
        {
          title: '_AIModels',
          icon: 'mdi-robot-outline',
          route: '',
          href: 'AIModels',
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "Model",
              title: '_ModelCreator',
              icon: 'mdi-file-document',
              route: '/GPTModelManagement',
              href: 'GPTModelManagement',
              Check: true,
              disabled: false,
              children: [
                {
                  // title: "LLMs Model Detail" — breadcrumb ตาม Figma "Create Bot"; มี ?id = แก้ไขบอท → "Edit Bot"
                  // title เป็น getter (คืน key i18n ให้ localize()) — arrow fn จับ this ของ data() = instance จึงอ่าน $route ได้
                  // และ render ของ breadcrumb track $route.query จึงเปลี่ยนเองหลังบันทึกแล้วได้ ?id
                  get title() {
                    return this.titleKey();
                  },
                  titleKey: () => (this.$route?.query?.id ? 'mm2_editBot' : 'mm2_createBot'),
                  icon: 'mdi-file-document',
                  route: '/GPTModelDetail',
                  href: 'GPTModelDetail',
                  Check: true,
                  disabled: false,
                },
              ],
            },
            {
              // title: "groupModel",
              title: '_ModelGrouping',
              icon: 'mdi-wrench',
              route: '/SetupGroupModel',
              href: 'SetupGroupModel',
              // ย้ายมาจากกลุ่ม Chat Management — rightsHref ให้ยังใช้สิทธิ์ 'ChatManagement' เดิม (role 2/6 ไม่เห็นเมนูนี้)
              rightsHref: 'ChatManagement',
              Check: false,
              disabled: false,
            },
          ],
        },
        {
          // title: "Vector",
          title: '_KnowledgeManagement',
          icon: 'mdi-clipboard-text-outline',
          route: '',
          href: 'Vector',
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "Vector Management",
              title: '_Documents',
              icon: 'mdi-cloud-upload',
              route: '/VectorManagement',
              href: 'VectorManagement',
              Check: true,
              disabled: false,
              children: [
                {
                  // title: "Upload Vector",
                  title: '_DocumentManagement',
                  icon: 'mdi-file-document',
                  route: '/UploadVector',
                  href: 'UploadVector',
                  Check: true,
                  disabled: false,
                },
              ],
            },
            {
              // title: "Data Integration Management",
              title: '_DatabaseIntegration',
              icon: 'mdi-database-import',
              route: '/DataIntegration',
              href: 'DataIntegration',
              Check: true,
              disabled: false,
              children: [
                {
                  title: 'DataIntegrationDetail',
                  icon: 'mdi-file-document',
                  route: '/DataIntegrationDetail',
                  href: 'DataIntegrationDetail',
                  Check: true,
                  disabled: false,
                },
              ],
            },
            // {
            //   title: 'Upload Sound To Document',
            //   icon: 'mdi-database-import',
            //   route: '/UploadSoundToDocument',
            //   href: 'UploadSoundToDocument',
            //   Check: true,
            //   disabled: false,
            //   children: [
            //     {
            //       title: 'Generate Question Set',
            //       route: '/UploadSoundToDocumentDetail',
            //       href: 'UploadSoundToDocumentDetail',
            //       Check: true,
            //       disabled: false,
            //     },
            //   ],
            // },
            // {
            //   title: '_Product',
            //   icon: 'mdi-database-import',
            //   route: '/ProductGroup',
            //   href: 'ProductGroup',
            //   Check: true,
            //   disabled: false,
            //   children: [
            //     {
            //       title: '_ProductDetail',
            //       route: '/ProductDetail',
            //       href: 'ProductDetail',
            //       Check: true,
            //       disabled: false,
            //     },
            //   ],
            // },
            // Knowledge source #7 — NEXA Knowledge Graphs (proxy + iframe hybrid)
            {
              title: '_KnowledgeGraphs',
              icon: 'mdi-graph-outline',
              route: '/KnowledgeGraphs',
              href: 'KnowledgeGraphs',
              Check: true,
              disabled: false,
              children: [
                {
                  title: '_KnowledgeGraphDetail',
                  route: '/KnowledgeGraphs/Detail',
                  href: 'KnowledgeGraphDetail',
                  Check: true,
                  disabled: false,
                },
              ],
            },
            {
              title: 'Flow',
              icon: 'mdi-chart-timeline-variant-shimmer',
              route: '/FlowList',
              href: 'FlowList',
              Check: true,
              disabled: false,
            },
          ],
        },
        {
          // title: "Validation",
          title: '_ModelTesting',
          icon: 'mdi-page-layout-footer',
          route: '',
          href: 'Validation',
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "Positive generate",
              title: '_SetQuestions',
              icon: 'mdi-cloud-upload',
              route: '/ValidationGenerate',
              href: 'ValidationGenerate',
              Check: true,
              disabled: false,
              children: [
                {
                  // title: "Positive generate upload",
                  title: 'Generate Question Set',
                  icon: 'mdi-cloud-upload',
                  route: '/ValidationGenerateUpload',
                  href: 'ValidationGenerateUpload',
                  Check: true,
                  disabled: false,
                },
              ],
            },
            // {
            //   // title: "Positive Question set"
            //   title: 'PositiveQuestionSet',
            //   icon: 'mdi-cloud-upload',
            //   route: '/ValidationPositive',
            //   href: 'ValidationPositive',
            //   Check: true,
            //   disabled: false,
            //   children: [
            //     {
            //       title: 'Upload Positive Question Set',
            //       icon: 'mdi-cloud-upload',
            //       route: '/ValidationPositiveDetail',
            //       href: 'ValidationPositiveDetail',
            //       Check: true,
            //       disabled: false,
            //     },
            //   ],
            // },
            // {
            //   // title: "Negative generate",
            //   title: '_NegativeQuestionSet',
            //   icon: 'mdi-cloud-upload',
            //   route: '/ValidationNegative',
            //   href: 'ValidationNegative',
            //   Check: true,
            //   disabled: false,
            //   children: [
            //     {
            //       // title: "Negative generate detail",
            //       title: '_UploadNegativeQuestionSet',
            //       icon: 'mdi-cloud-upload',
            //       route: '/ValidationNegativeDetail',
            //       href: 'ValidationNegativeDetail',
            //       Check: true,
            //       disabled: false,
            //     },
            //   ],
            // },
            {
              // title: "Process",
              title: '_ExecuteTestRuns',
              icon: 'mdi-cloud-upload',
              route: '/ValidationProcess',
              href: 'ValidationProcess',
              Check: true,
              disabled: false,
              children: [
                {
                  title: 'Dashboard score',
                  icon: 'mdi-cloud-upload',
                  route: '/DashboardScore',
                  href: 'DashboardScore',
                  Check: false,
                  disabled: false,
                },
                {
                  // หน้าเพิ่ม/แก้ไขการทดสอบ (เดิมเป็น dialog ในหน้า Execute Test Runs)
                  title: 'vproc_uploadQuestionSet',
                  icon: 'mdi-cloud-upload',
                  route: '/ValidationProcessUpload',
                  href: 'ValidationProcessUpload',
                  Check: false,
                  disabled: false,
                },
              ],
            },
          ],
        },
        {
          title: '_ModelComparison',
          icon: 'mdi-forum-outline',
          route: '',
          href: 'ModelComparison',
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "Chat Preview",
              // icon: "mdi-application-settings-outline",
              title: '_ChatPlayground',
              icon: 'mdi-monitor',
              route: '/Stream',
              href: 'Stream',
              Check: true,
              disabled: false,
            },
            {
              // title: "Playground",
              title: '_DualChatPlayground',
              // icon: "mdi-motion-play",
              icon: 'mdi-monitor-multiple',
              route: '/Playground',
              href: 'Playground',
              Check: true,
              disabled: false,
            },
          ],
        },
        // {
        //   title: ('_FileManagement'),
        //   icon: "mdi-file-multiple",
        //   route: "/FileManagements",
        //   href: "FileManagements",
        //   Check: false,
        //   disabled: false,
        //   childstatus: true,
        //   children: [],
        // },
        {
          // title: "Setup",
          title: '_Setting',
          icon: 'mdi-cog-outline',
          // route ต้อง resolve ไปหา record ที่มี meta.isProductAdmin (filteredItems → hasAdminRights)
          // href คงเป็น 'Setting' เพราะ rights arrays (SuperAdminRights/adminRights) match ที่ item.href
          // ต้องขึ้นต้นด้วย '/' — $router.resolve() แปลง path ไม่มี '/' แบบ relative กับหน้าปัจจุบัน (จาก /KnowledgeGraphs/12
          // ได้ /KnowledgeGraphs/SnippetCustomization ซึ่งบังเอิญตรง /KnowledgeGraphs/:graphId) — หน้าซ้อนที่ไม่ตรง route ไหน = ทั้งกลุ่มหาย
          route: '/SnippetCustomization',
          href: 'Setting',
          Check: false,
          disabled: true,
          children: [
            {
              title: '_SnippetSmallCustomization',
              icon: 'mdi-palette-outline',
              route: '/SnippetCustomization',
              // href ต้องตรงกับ route name (breadcrumbsList match item.href === $route.name)
              href: 'SnippetCustomization',
              Check: true,
              disabled: false,
            },
            {
              // ไม่มีใน Figma แต่ยังต้องใช้ — widget เต็มจอ (FullV2) ตั้งค่าแยกจาก Snippet เล็ก
              title: '_SnippetFullCustomization',
              icon: 'mdi-palette-swatch-outline',
              route: '/SnippetFullCustomization',
              // href ต้องตรงกับ route name (breadcrumbsList match item.href === $route.name)
              href: 'SnippetFullCustomization',
              Check: true,
              disabled: false,
            },
            // {
            //   title: '_CoreConfigurations',
            //   icon: 'mdi-wrench',
            //   route: '/setup',
            //   href: 'Setup',
            //   Check: true,
            //   disabled: false,
            // },
            {
              title: '_ExternalConnector',
              icon: 'mdi-wrench',
              route: '/SettingExternalConnector',
              href: 'SettingExternalConnector',
              // Super Admin ต้องเปิดสิทธิ์ให้บริษัทก่อน (applyCompanyPagePermissions)
              companyPagePermission: 'SettingExternalConnector',
              Check: true,
              disabled: false,
            },
            // {
            //   title: '_LLMsManagement',
            //   icon: 'mdi-database-outline',
            //   route: '/modeldata',
            //   href: 'ModelData',
            //   Check: true,
            //   disabled: false,
            // },
            {
              title: '_PlatformIntegration',
              icon: 'mdi-wrench',
              route: '/SetupSocial',
              href: 'SetupSocial',
              // Super Admin ต้องเปิดสิทธิ์ให้บริษัทก่อน (applyCompanyPagePermissions)
              companyPagePermission: 'SetupSocial',
              Check: true,
              disabled: false,
            },
            {
              title: '_EntraApps',
              icon: 'mdi-shield-account',
              route: '/EntraApps',
              href: 'EntraApps',
              Check: true,
              disabled: false,
            },
            {
              title: '_manageVerifiedUsers',
              icon: 'mdi-account-check',
              route: '/LineEntraLinks',
              href: 'LineEntraLinks',
              Check: true,
              disabled: false,
            },
            // serviceTheme ย้ายออกไปเป็นเมนูหลัก (ตาม Figma)
            // {
            //   title: 'consentConfig',
            //   icon: 'mdi-wrench',
            //   route: '/ConsentConfig',
            //   href: 'ConsentConfig',
            //   Check: true,
            //   disabled: false,
            // },
          ],
        },
        // ซ่อนเมนู "ตั้งค่า Theme" ชั่วคราว (สีของหลังบ้านมาจาก design token แล้ว) — route /ServiceTheme ยังเปิดได้ตาม URL
        // {
        //   title: 'serviceTheme',
        //   icon: 'mdi-theme-light-dark',
        //   route: '/ServiceTheme',
        //   href: 'ServiceTheme',
        //   Check: false,
        //   disabled: false,
        //   childstatus: true,
        //   children: [],
        // },
        {
          title: 'Logs',
          icon: 'mdi-file-document-multiple-outline',
          route: '',
          href: 'Logs',
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            // ซ่อนเมนู Chat Logs ชั่วคราว (route /LogMessage ถูกบล็อกใน router.js ด้วย)
            // {
            //   title: '_ChatLogs',
            //   icon: 'mdi-clipboard-text',
            //   route: '/LogMessage',
            //   href: 'LogMessage',
            //   Check: true,
            //   disabled: false,
            // },
            {
              title: 'logEvent',
              icon: 'mdi-clipboard-search-outline',
              route: '/LogEvent',
              href: 'LogEvent',
              Check: true,
              disabled: false,
            },
            {
              title: 'API External Log',
              icon: '',
              route: 'LogAPIExternal',
              href: 'LogAPIExternal',
              Check: true,
              disabled: false,
            },
          ],
        },
        // ── ซ่อนไว้ก่อน: เมนูที่เว็บมีแต่ไม่มีใน Figma DGA (หน้ายังเปิดได้ตาม URL เดิม) ──
        // {
        //   title: '_PdfToMarkdownTool',
        //   icon: 'mdi-tools',
        //   route: '/PdfToMarkdownTool',
        //   href: 'PdfToMarkdownTool',
        //   Check: false,
        //   disabled: false,
        //   childstatus: true,
        //   children: [],
        // },
        // {
        //   title: 'Intent',
        //   icon: 'mdi-comment-processing-outline',
        //   route: '/IntentGroup',
        //   href: 'IntentGroup',
        //   Check: true,
        //   disabled: false,
        //   childstatus: true,
        //   children: [
        //     // {
        //     //   title: "IntentGroup",
        //     //   icon: "mdi-database-import",
        //     //   route: "/IntentGroup",
        //     //   href: "IntentGroup",
        //     //   Check: true,
        //     //   disabled: false,
        //     //   children: [],
        //     // },
        //     {
        //       title: 'IntentSession',
        //       icon: 'mdi-database-import',
        //       route: '/IntentSession',
        //       href: 'IntentSession',
        //       Check: true,
        //       disabled: false,
        //       children: [
        //         {
        //           title: 'Intent Session Detail',
        //           icon: 'mdi-file-document',
        //           route: '/IntentSessionDetail',
        //           href: 'IntentSessionDetail',
        //           Check: true,
        //           disabled: false,
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   // title: "Replace",
        //   title: '_OptimizationTechniques',
        //   icon: 'mdi-find-replace',
        //   route: '',
        //   href: 'Replace',
        //   Check: false,
        //   disabled: true,
        //   childstatus: false,
        //   children: [
        //     {
        //       // title: "GroupPromptTemplate",
        //       title: '_PromptTemplate',
        //       icon: 'mdi-database-outline',
        //       route: '/GroupPromptTemplate',
        //       href: 'GroupPromptTemplate',
        //       Check: false,
        //       disabled: false,
        //       children: [
        //         {
        //           // title: "PromptTemplate",
        //           title: 'Prompt Template Detail',
        //           icon: 'mdi-database-outline',
        //           route: '/PromptTemplate',
        //           href: 'PromptTemplate',
        //           Check: false,
        //           disabled: false,
        //         },
        //       ],
        //     },
        //     {
        //       // title: "Replace Text",
        //       title: '_TextReplacement',
        //       icon: 'mdi-file-document',
        //       route: '/GroupReplacetext',
        //       href: 'GroupReplacetext',
        //       Check: true,
        //       disabled: false,
        //       children: [
        //         {
        //           // title: "replaceText",
        //           title: 'Add Text Group',
        //           icon: 'mdi-file-document',
        //           route: '/ReplaceText',
        //           href: 'ReplaceText',
        //           Check: true,
        //           disabled: false,
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   title: '_ChatManagement',
        //   icon: 'mdi-message-settings',
        //   route: '',
        //   href: 'ChatManagement',
        //   Check: false,
        //   disabled: true,
        //   childstatus: false,
        //   children: [
        //     // _ModelGrouping ย้ายไปอยู่กลุ่ม AI Models (rightsHref: 'ChatManagement')
        //     // {
        //     //   // title: "Quick Model",
        //     //   title: '_ModelShortcut',
        //     //   icon: 'mdi-wrench',
        //     //   route: '/ModelShortcut',
        //     //   href: 'ModelShortcut',
        //     //   Check: true,
        //     //   disabled: false,
        //     // },
        //     {
        //       title: 'Model Quick Reply',
        //       icon: 'mdi-account-multiple',
        //       route: '/ModelQuickReply',
        //       href: 'ModelQuickReply',
        //       Check: true,
        //       disabled: false,
        //     },
        //     // {
        //     //   title: 'shortcutMenu',
        //     //   icon: 'mdi-account-multiple',
        //     //   route: '/ShortcutMenu',
        //     //   href: 'ShortcutMenu',
        //     //   Check: true,
        //     //   disabled: false,
        //     // },
        //   ],
        // },
        // {
        //   // title: "Report",
        //   title: '_Reports',
        //   icon: 'mdi-chart-box-multiple',
        //   route: '',
        //   href: 'Report',
        //   Check: false,
        //   disabled: true,
        //   childstatus: false,
        //   children: [
        //     // {
        //     //   // title: "Question",
        //     //   title: '_QuestionTrends',
        //     //   icon: 'mdi-chart-box-multiple',
        //     //   route: '/ReportQuestionTop10',
        //     //   href: 'ReportQuestionTop10',
        //     //   Check: true,
        //     //   disabled: false,
        //     // },
        //     {
        //       // title: "User",
        //       title: '_TopUsers',
        //       icon: 'mdi-chart-box-multiple',
        //       route: '/ReportUserTop10',
        //       href: 'ReportUserTop10',
        //       Check: true,
        //       disabled: false,
        //     },
        //     {
        //       // title: "Total Question By User",
        //       title: '_TotalUsageInsights',
        //       icon: 'mdi-chart-box-multiple',
        //       route: '/ReportUserUse',
        //       href: 'ReportUserUse',
        //       Check: true,
        //       disabled: false,
        //     },
        //     // {
        //     //   // title: "Token Per Page",
        //     //   title: '_TokenPerPage',
        //     //   icon: 'mdi-chart-box-multiple',
        //     //   route: '/ReportPageToken',
        //     //   href: 'ReportPageToken',
        //     //   Check: true,
        //     //   disabled: false,
        //     // },
        //     {
        //       title: 'TokenSummation',
        //       icon: 'mdi-chart-box-multiple',
        //       route: '/ReportTokenSum',
        //       href: 'ReportTokenSum',
        //       Check: true,
        //       disabled: false,
        //     },
        //     {
        //       title: 'Report Feedback',
        //       icon: 'mdi-chart-box-multiple',
        //       route: '/ReportFeedback',
        //       href: 'ReportFeedback',
        //       Check: true,
        //       disabled: false,
        //     },
        //   ],
        // },
        // {
        //   // title: "ChatService",
        //   title: '_ChatService',
        //   icon: 'mdi-forum',
        //   route: '/ChatService',
        //   href: 'ChatService',
        //   Check: false,
        //   disabled: true,
        //   childstatus: true,
        //   children: [],
        // },
      ],
      breadcrumbsItem: [],
      mini: true,
      miniDefault: true,
      drawerFull: false,
      drawerMobile: false,
      selectedColor: '#F7B34E',
      parameterURL: initialParameterURL,
      isSnippet: initialParameterURL.snippet === 'true',
      showBTNLogin: true,
      versioning: version,
      showScrollButton: false,
      queryID: null,
      consent_dialog: true,
      dataConsent: '',
      dataVersion: '',
      dataConsentTH: '',
      dataConsentEN: '',
      flagUpdateVersion: false,
      audioUnlocked: false,
      soundEnabled: false,
      sound: notificationSound,
      editorOptions: {
        readOnly: true,
        modules: {
          toolbar: false, // ซ่อน toolbar
        },
      },
    };
  },
  created() {
    // โหลดฝารตั้งค่าเสียงจาฝ localStorage
    const savedSoundSetting = localStorage.getItem('soundEnabled');
    if (savedSoundSetting !== null) {
      this.soundEnabled = savedSoundSetting === 'true';
    }

    // โหลดสถานะฝารอนุฝาตเสียงจาฝ localStorage
    const savedAudioUnlocked = localStorage.getItem('audioUnlocked');
    if (savedAudioUnlocked === 'true') {
      this.audioUnlocked = true;
    }

    this.syncRouteUiState();
  },
  computed: {
    // portal: SuperAdmin ของบริษัท (0) กับ Admin (1) แสดงเป็น "ผู้ดูแลระบบ" ตัวเดียวกัน — ดู utils/portalRole
    role() {
      return this.$t(portalRoleLabelKey(this.roleId) || '_Operator');
    },
    currentRouter() {
      return this.$router;
    },
    currentRoute() {
      return this.$route;
    },
    currentRoutePath() {
      return this.$route?.path || '';
    },
    topicsNotInFolders() {
      const topicsInFolders = this.folders.reduce((ids, folder) => {
        if (folder.topics && folder.topics.length > 0) {
          for (const topic of folder.topics) {
            ids.add(topic.topicID);
          }
        }
        return ids;
      }, new Set());
      return this.listTopic.filter((topic) => topic.topicID !== -1 && !topicsInFolders.has(topic.topicID));
    },
    filteredFolders() {
      return this.folders.filter((folder) => folder.id !== this.moveToFolderDialog.currentFolderId);
    },
    modelFirstComputed() {
      try {
        const temp = this.ModelFirst.split('(').map((item) => item.trim());
        return temp[1].replace(')', ' ') + '(' + temp[0] + ')';
      } catch {
        return '-';
      }
    },
    currentRouteName() {
      return this.route?.name || this.$route?.name || '';
    },
    currentFullName() {
      return store.state.fullName;
    },
    checkMini() {
      let miniC = (!this.Snippet_Username && this.Snippet_Status === true) || (!!this.Snippet_Username && this.Snippet_Status === false) ? this.miniDefault : this.mini;
      return miniC;
    },
    paddingLeft() {
      if (this.pathUrl == 'FullStream') {
        return this.SetPopup ? '273px' : '15px';
      } else {
        return this.drawer ? '273px' : '15px';
      }
    },
    breadcrumbsList() {
      let path = this.$route.name;
      const breadcrumbs = this.findBreadcrumbPath(this.items, path);
      this.breadcrumbsItem = [];

      if (breadcrumbs.length > 0) {
        // เมนูที่ย้ายกลุ่มแต่ต้องคงสิทธิ์เดิม (rightsHref) ให้เช็กจาก rightsHref แทน href ของกลุ่มบนสุด
        const rightsItem = [...breadcrumbs].reverse().find((item) => item.rightsHref);
        if (this.hasAccessRights(rightsItem ? rightsItem.rightsHref : breadcrumbs[0].href)) {
          this.breadcrumbsItem = breadcrumbs;
        } else {
          this.breadcrumbsItem = [];
          this.AccessDenied();
        }
      }
      return this.breadcrumbsItem;
    },
    headers() {
      return [
        { title: 'no', align: 'left', sortable: false },
        {
          title: 'question',
          align: 'left',
          sortable: true,
          value: 'Question',
        },
        {
          title: 'answer',
          align: 'left',
          sortable: true,
          value: 'Answer',
        },
        {
          title: 'score',
          align: 'left',
          sortable: true,
          value: 'Score',
        },
      ];
    },
    // Wizard "สร้าง AI Assistant" สำหรับ admin ของบริษัท (SuperAdmin ที่สลับเข้าบริษัทก็เห็น)
    canOpenAssistantWizard() {
      return ['0', '1'].includes(String(this.roleId));
    },
    // ถึงเวลาถามว่าจะเด้ง wizard ครั้งแรกไหม (ผู้ดูแลหน่วยงาน/SuperAdmin · หน้า portal · consent dialog ปิดแล้ว · ถามครั้งเดียวต่อการโหลดหน้า)
    shouldCheckAssistantOnboarding() {
      return shouldCheckOnboarding({
        roleId: this.roleId,
        isSuperAdmin: this.$store.state.isSuperAdmin === true,
        pathUrl: this.pathUrl,
        consentChecked: this.consentChecked,
        consentDialogOpen: !!this.flagUpdateVersion && this.consent_dialog,
        alreadyChecked: this.assistantOnboardingChecked,
      });
    },
    ddProfile() {
      const items = [
        {
          no: 1,
          title: 'userprofile',
          icon: 'mdi-account-circle',
          route: '/userprofile',
          href: 'userprofile',
          action: () => {},
          Check: true,
        },
        ...(this.hasMultiCompany
          ? [
              {
                no: 5,
                title: 'switchcompany',
                icon: 'mdi-office-building-outline',
                action: () => {
                  this.switchCompany();
                },
                Check: true,
              },
            ]
          : []),
        ...(this.ProductAdminFlag && this.isSuperAdmin
          ? [
              {
                no: 7,
                title: 'backtosuperadmin',
                icon: 'mdi-shield-crown-outline',
                action: () => {
                  this.goBackToSuperAdmin();
                },
                Check: true,
              },
            ]
          : []),
        {
          no: 2,
          title: 'releasesnotes',
          icon: 'mdi-package-variant',
          route: '/release-notes',
          href: 'release-notes',
          action: () => {},
          Check: true,
        },
        {
          no: 3,
          title: 'usermanual',
          icon: 'mdi-book-open-variant',
          action: () => {
            this.downloadLink();
          },
          Check: true,
        },
        // เอาเมนู "สร้าง AI Assistant" (asw_menu — ปุ่มทดสอบ wizard แบบครั้งแรก) ออกจากเมนูโปรไฟล์แล้ว
        // wizard ยังเปิดได้จากเมนู "ผู้ช่วยอัจฉริยะ" ในแถบข้าง และเด้งเองครั้งแรกตามเดิม
        {
          no: 4,
          title: 'logout',
          icon: 'mdi-logout',
          action: () => {
            this.logout();
          },
          Check: true,
        },
      ];
      return items.filter((item) => item.Check !== false);
    },
    LeftNavBar() {
      return this.Snippet_Username;
    },
    // side menu is a temporary drawer below Vuetify's mobile breakpoint — the bar shows a menu button only then
    drawerIsTemporary() {
      return this.display.mobile.value;
    },
    ColorThemeChat() {
      return this.colorThemeChat;
    },
    filteredItems() {
      let res = this.items.filter((item) => {
        if (!item.route) return item.route === '';
        const route = this.$router.resolve(item.route);
        if (item.children && item.children.length > 0) {
          item.children = item.children.filter((child) => {
            try {
              if (!child.route) return false;
              const resChild = this.$router.resolve(child.route);
              return this.hasAdminRights(resChild);
            } catch (err) {
              console.error('Error resolving child route:', err);
              return false;
            }
          });
        }
        return this.hasAdminRights(route) || item.route === '';
      });
      return res;
    },
    mdAndUp() {
      return this.display.mdAndUp.value;
    },
    smAndUp() {
      return this.display.smAndUp.value;
    },
  },
  watch: {
    shouldCheckAssistantOnboarding(ready) {
      if (ready) this.checkAssistantOnboarding();
    },
    drawerFull(newValue) {
      this.$store.commit('SET_DRAWER_OPEN', newValue); // สมมติว่ามี mutation ชื่อ SET_DRAWER_OPEN
    },
    currentFullName() {
      // อัปเดตข้อความหรือสถานะ component เมื่อภาษาเปลี่ยน
      this.setFullname(); // เรียฝฟังฝ์ชันเพื่อโหลดข้อมูลหรือข้อความใหม่
    },
    ColorThemeChat(newVal) {
      this.selectedColor = `#${newVal}`;
    },
    mini(val) {
      if (!val) {
        if (this.flagGetAllTopic === false) {
          this.flagShowTopic = true;
        }
        this.flagGetAllTopic = true;
      }
      this.miniVariant = val;
    },
    drawerMobile(val) {
      if (val) {
        if (this.flagGetAllTopic === false) {
          this.flagShowTopic = true;
        }
        this.flagGetAllTopic = true;
      }
    },
    '$route.fullPath': {
      handler() {
        this.syncRouteUiState();
      },
      immediate: true,
    },
    currentRouteName: {
      handler(newRouteName) {
        if (newRouteName) {
          this.pathUrl = newRouteName === 'FullStreamV2' ? 'FullStream' : newRouteName;
        }
      },
      immediate: true,
    },
    '$route.name': {
      handler(newName) {
        this.queryID = store.state.groupSecurityID;
        if (newName) {
          this.pathUrl = newName === 'FullStreamV2' ? 'FullStream' : newName;
        }
      },
      immediate: true,
    },
  },
  methods: {
    // #region Helper functions for reduced cognitive complexity
    isTruthyQueryParam(value) {
      if (typeof value === 'boolean') {
        return value;
      }

      if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
      }

      return Boolean(value);
    },
    syncRouteUiState() {
      const rawPathUrl = this.$route?.name || this.$route?.path?.replace('/', '') || this.pathUrl;
      const nextPathUrl = rawPathUrl === 'FullStreamV2' ? 'FullStream' : rawPathUrl;
      const nextParameterURL = [];

      for (let key in this.$route.query) {
        nextParameterURL[key.toLowerCase()] = this.$route.query[key];
      }

      if (nextPathUrl) {
        this.pathUrl = nextPathUrl;
      }

      this.parameterURL = nextParameterURL;
      this.isSnippet = this.isTruthyQueryParam(nextParameterURL.snippet);
    },
    findBreadcrumbPath(items, path, parentPath = []) {
      for (const item of items) {
        if (item.href === path) {
          return [...parentPath, item];
        }
        if (item.children?.length > 0) {
          const result = this.findBreadcrumbPath(item.children, path, [...parentPath, item]);
          if (result.length > 0) {
            return result;
          }
        }
      }
      return [];
    },
    hasAccessRights(href) {
      if (this.roleId === 2) {
        return this.generalUsersRights.includes(href);
      }
      if (this.roleId === 6) {
        return this.operatorRights.includes(href);
      }
      return true;
    },
    getRightsForRole(roleId) {
      const rightsMap = {
        0: this.SuperAdminRights,
        1: this.adminRights,
        2: this.generalUsersRights,
        6: this.operatorRights,
      };
      return rightsMap[roleId] || [];
    },
    applyRightsToItems(rights, includeChildren = true) {
      for (const item of this.items) {
        if (rights.includes(item.href)) {
          item.Check = true;
          if (includeChildren && item.children) {
            for (const child of item.children) {
              child.Check = true;
            }
          }
        }
        // เมนูย่อยที่มี rightsHref เห็นเฉพาะ role ที่มีสิทธิ์นั้น (เช่น Model Grouping ใช้สิทธิ์ 'ChatManagement' เดิม)
        for (const child of item.children || []) {
          if (child.rightsHref) {
            child.Check = rights.includes(child.rightsHref);
          }
        }
      }
    },
    // เมนูที่ Super Admin เปิด/ปิดให้รายบริษัท (child.companyPagePermission) — ซ่อนไว้ก่อนจน backend ยืนยันว่าบริษัทนี้ได้รับอนุญาต
    // แสดงเฉพาะเมนูที่ role เห็นอยู่แล้ว (Check จาก applyRightsToItems) · SuperAdmin ได้ทุกหน้าจาก backend · ถามไม่สำเร็จ = ซ่อน
    // router.beforeEach กันการพิมพ์ URL ตรงอีกชั้น
    applyCompanyPagePermissions() {
      const controlled = [];
      for (const item of this.items) {
        for (const child of item.children || []) {
          if (child.companyPagePermission) {
            controlled.push({ child, visibleByRole: item.Check === true && child.Check === true });
            child.Check = false;
          }
        }
      }
      if (controlled.length === 0 || !controlled.some((c) => c.visibleByRole)) return;
      this.$call.GetMyCompanyPages(
        (res) => {
          const allowed = allowedPagesFromResponse(res);
          for (const { child, visibleByRole } of controlled) {
            child.Check = visibleByRole && allowed.includes(child.companyPagePermission);
          }
        },
        () => {
          // คงซ่อนไว้ — เข้าทาง URL ก็ถูก router ถามซ้ำอยู่ดี
        }
      );
    },
    applyRightsToProfile(rights) {
      for (const item of this.ddProfile) {
        if (rights.includes(item.href)) {
          item.Check = true;
        }
      }
    },
    moveFolderTopic(fromFolderIndex, toFolderIndex, topicId) {
      if (fromFolderIndex === -1 || !this.folders[fromFolderIndex].topics) return null;

      const topicIndex = this.folders[fromFolderIndex].topics.findIndex((t) => t.topicID === topicId);
      if (topicIndex === -1) return null;

      const topic = { ...this.folders[fromFolderIndex].topics[topicIndex] };
      this.folders[fromFolderIndex].topics.splice(topicIndex, 1);

      if (toFolderIndex !== -1) {
        if (!this.folders[toFolderIndex].topics) {
          this.folders[toFolderIndex].topics = [];
        }
        this.folders[toFolderIndex].topics.push(topic);
      }
      return topic;
    },
    setFolderUpdateStatus(folderId, status, delay = 2000) {
      this.recentlyUpdatedFolderId = folderId;
      this.folderUpdateStatus = status;
      setTimeout(() => {
        this.recentlyUpdatedFolderId = null;
        this.folderUpdateStatus = null;
      }, delay);
    },
    handleMoveDialogError(message) {
      this.moveToFolderDialog.isLoading = false;
      this.moveToFolderDialog.isError = true;
      this.moveToFolderDialog.errorMessage = message;
      setTimeout(() => {
        this.moveToFolderDialog.isError = false;
      }, 1000);
    },
    handleMoveDialogSuccess() {
      this.moveToFolderDialog.isSuccess = true;
      setTimeout(() => {
        this.closeMoveToFolderDialog();
      }, 600);
    },
    getSnippetCredentials() {
      const sources = [
        { storage: sessionStorage, prefix: '' },
        { storage: localStorage, prefix: '' },
        { storage: Cookies, prefix: '', isCookes: true },
      ];

      for (const source of sources) {
        const username = source.isCookes ? Cookies.get('username_Snippet') : source.storage.getItem('username_Snippet');
        const email = source.isCookes ? Cookies.get('email_Snippet') : source.storage.getItem('email_Snippet');
        if (username != null && email != null) {
          return { username, email };
        }
      }
      return null;
    },
    hasSnippetToken() {
      return sessionStorage.getItem('token_Snippet') != null || localStorage.getItem('token_Snippet') != null || Cookies.get('token_Snippet') != null;
    },
    setupDrawerScrollListener() {
      this.$nextTick(() => {
        const drawerContent = document.querySelector('#NavFullStream .v-navigation-drawer__content');
        if (drawerContent) {
          drawerContent.addEventListener('scroll', this.handleDrawerScroll);
        }
      });
    },
    initializeConsent() {
      const skipConsentPaths = ['FullStream', 'Snippet', 'LoginSnippet', 'Login'];
      if (!skipConsentPaths.includes(this.pathUrl)) {
        this.GetConsent();
      }
      this.consent_dialog = true;
    },
    initializePathAndParams() {
      if (!this.pathUrl) {
        this.setPathUrl();
      }
      this.mini = false;
      for (let key in this.$route.query) {
        this.parameterURL[key.toLowerCase()] = this.$route.query[key];
      }
      const routePathUrl = this.$route?.name || 'dashboard';
      this.pathUrl = this.pathUrl || (routePathUrl === 'FullStreamV2' ? 'FullStream' : routePathUrl);
    },
    async handlePathSpecificSetup() {
      if (this.pathUrl === 'FullStream') {
        await this.setupFullStreamPath();
      } else if (this.pathUrl === 'Snippet') {
        await this.setupSnippetPath();
      } else {
        this.setupDefaultPath();
      }
    },
    async setupFullStreamPath() {
      this.setupDrawerScrollListener();
      this.applyStoredLocaleOrDefault();
      if (this.parameterURL.snippet) {
        this.handleSnippetAuth(false);
      }
    },
    async setupSnippetPath() {
      this.setupDrawerScrollListener();
      this.applyStoredLocaleOrDefault();
      this.handleSnippetAuth(true);
    },
    setupDefaultPath() {
      this.currentflag = localStorage.getItem('flag');
      this.applyStoredLocaleOrDefault();
      if (this.username && this.fullName?.length > 1) {
        this.shotName = this.fullName.substring(0, 1).toUpperCase();
      }
    },
    applyStoredLocaleOrDefault() {
      let locale;
      try {
        locale = localStorage.getItem('locale') === 'en' ? 'en' : 'th';
      } catch {
        locale = 'th';
      }
      this.applyLocale(locale);
    },
    setEnglishLocale() {
      this.applyLocale('en');
    },
    setThaiLocale() {
      this.applyLocale('th');
    },
    applyLocale(locale) {
      const nextLocale = locale === 'en' ? 'en' : 'th';
      if (this.$i18n) this.$i18n.locale = nextLocale;
      if (i18n.global) i18n.global.locale = nextLocale;
      i18n.locale = nextLocale;
      this.locale = nextLocale;
      this.currentflag = nextLocale === 'en' ? 'us' : 'th';
    },
    handleSnippetAuth(isSnippetPage) {
      if (this.hasSnippetToken()) {
        const credentials = this.getSnippetCredentials();
        if (credentials) {
          this.Snippet_Username = credentials.username;
          this.User_Id_Show = credentials.email;
        }
        this.Snippet_Status = !isSnippetPage;
      } else {
        this.GetCheckAnonymous();
        this.Snippet_Username = '';
        this.Snippet_Status = isSnippetPage;
      }
    },
    initializeMenuState() {
      for (const index of this.items.keys()) {
        this.openMenus[index] = false;
      }
    },
    // #endregion

    truncateText(text) {
      const maxLength = 35; // กำหนดความยาวสูงสุดที่ต้องการ
      if (!text || text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    },
    getCurrentPath() {
      return this.$route?.name || this.$route?.path?.replace('/', '') || 'dashboard';
    },
    async AccessDenied() {
      this.$router.push(`/AccessDenied`);
    },
    focusInput(element) {
      this.$nextTick(() => {
        document.getElementById(element)?.focus();
      });
    },

    // #region Drag & Drop functions
    handleDropForNone(event) {
      event.preventDefault();
    },
    onDragLeaveFolder(leftFolderId) {
      if (this.isDroppingOnFolder == leftFolderId) {
        return;
      }
      this.targetFolder = null;
      this.isDroppingOnFolder = null;
    },

    onDragOverFolder(event, folder) {
      event.preventDefault(); // จำเป็นต้องมี
      this.targetFolder = folder;
      if (!this.draggedItem) return;

      if (!this.draggedItem.sourceFolder || this.draggedItem.sourceFolder.id !== folder.id) {
        this.isDroppingOnFolder = folder.id;
        // ระบุการดำเนินการ - copy แทน move
        event.dataTransfer.dropEffect = 'copy';
      }
    },
    onDragStart(evt, sourceFolder) {
      this.drag = true;
      this.isDroppingOnFolder = null;
      this.targetFolder = null;
      // เก็บข้อมูลที่จำเป็นสำหรับการลาก
      const topic = sourceFolder ? sourceFolder.topics[evt.oldIndex] : this.topicsNotInFolders[evt.oldIndex];

      this.draggedItem = {
        index: evt.oldIndex,
        sourceFolder: sourceFolder,
        topic: topic,
      };

      // เพิ่ม class เพื่อการแสดงผล CSS
      document.body.classList.add('dragging-topic');
    },
    onDragStartFromOutside(val) {
      this.isStartFromOutside = val;
    },
    onDragEnd() {
      this.handleDrop();
      this.drag = false;
      document.body.classList.remove('dragging-topic');
    },
    handleDrop() {
      try {
        if (!this.isStartFromOutside && this.targetToOutsideArea) {
          this.removeTopicFromFolderBypassDialog(this.draggedItem.sourceFolder.id, this.draggedItem.topic.topicID, this.draggedItem.index);
          this.targetToOutsideArea = false;
          return;
        }
        this.targetToOutsideArea = false;
        if (!this.draggedItem || !this.targetFolder) {
          return;
        }

        if (this.draggedItem.sourceFolder && this.targetFolder.id == this.draggedItem.sourceFolder.id) {
          return;
        }

        const topic = this.draggedItem.topic;

        this.isDroppingOnFolder = null;

        if (!this.draggedItem.sourceFolder) {
          this.addTopicToFolderAPI(this.targetFolder.id, topic.topicID);
        } else if (this.draggedItem.sourceFolder && this.draggedItem.sourceFolder.id !== this.targetFolder.id) {
          this.moveTopicToFolderAPI(topic.topicID, this.draggedItem.sourceFolder.id, this.targetFolder.id);
        }

        setTimeout(() => {
          this.targetFolder.expanded = true;
        }, 500);
      } catch (e) {
        console.log('Error in handleDrop:', e);
      }
    },
    onDragOverOutsideTopic(event) {
      // ป้องกัน default behavior
      event.preventDefault();
      console.log('Dragging over outside area');
      this.targetToOutsideArea = true;
      // ล้างค่า highlight และ target folder
      this.isDroppingOnFolder = null;
      this.targetFolder = null;
    },
    onDragOverOutsideDragArea(event) {
      // ป้องกัน default behavior
      event.preventDefault();
      this.targetToOutsideArea = false;
      this.isDroppingOnFolder = null;
      this.targetFolder = null;
    },
    addTopicToFolderAPI(folderId, topicId) {
      // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.AddTopicToFolder ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
    },
    moveTopicToFolderAPI(topicId, fromFolderId, toFolderId) {
      // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.MoveTopicToFolder ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
    },

    // #endregion
    // #region Folder functions
    RenameChat(item) {
      item.status = true;

      this.SetStatusKeyRename(false);
      this.$nextTick(() => {
        const refName = 'topicRef_' + item.topicID;
        if (this.$refs[refName]) {
          setTimeout(() => {
            const inputElement = document.querySelector(`input[name="topicRef_${item.topicID}"]`) || document.querySelector(`.topic-name-input[ref="topicRef_${item.topicID}"] input`);
            if (inputElement) inputElement.focus();
          }, 50);
        }
      });
    },
    async waitForUserId() {
      return new Promise((resolve) => {
        const checkUserId = () => {
          if (this.User_Id && this.User_Id !== '') {
            if (this.isSnippet) resolve(this.User_Id_Show);
            else resolve(this.User_Id);
          } else {
            setTimeout(checkUserId, 500);
          }
        };
        checkUserId();
      });
    },
    highlightTopic(topic) {
      const activeTopicId = this.Log_History_TopicID;
      if (activeTopicId && activeTopicId === topic.topicID) {
        return 'highlighted-topic';
      }
      return '';
    },
    expandFolderWithActiveTopic() {
      const activeTopicId = this.Log_History_TopicID;

      if (!activeTopicId || activeTopicId === -1) return;

      // ค้นหาโฟลเดอร์ที่มี Topic ที่กำลังเปิดอยู่
      for (let folder of this.folders) {
        if (folder.topics && folder.topics.length > 0) {
          // ตรวจสอบว่า Topic ที่กำลังเปิดอยู่อยู่ในโฟลเดอร์นี้หรือไม่
          const foundTopic = folder.topics.find((topic) => topic.topicID === activeTopicId);

          if (foundTopic) {
            // ขยายโฟลเดอร์ที่มี Topic ที่กำลังเปิดอยู่
            folder.expanded = true;
            break; // หยุดเมื่อพบโฟลเดอร์แล้ว
          }
        }
      }
    },
    async loadFolders() {
      try {
        if (this.isSnippet && !this.parameterURL.full) {
          this.flagLoadingFolders = false;
          return;
        }
        this.flagLoadingFolders = true;
      } catch (error) {
        console.error('Error in loadFolders:', error);
        this.flagLoadingFolders = false;
      }
    },
    toggleFolder(folder) {
      folder.expanded = !folder.expanded;
    },
    selectFolder(folderId) {
      if (this.moveToFolderDialog.isLoading || this.moveToFolderDialog.isSuccess) return;

      this.moveToFolderDialog.selectedFolderId = folderId;
    },
    isFolderSelected(folder) {
      return this.moveToFolderDialog.selectedFolderId === folder.id;
    },
    isFolderDisabled(folder) {
      return folder.id === this.moveToFolderDialog.currentFolderId;
    },
    newChat() {
      this.isTextToImage = false;
      try {
        if (typeof this.ResetTextToImageFlagF === 'function') {
          this.ResetTextToImageFlagF();
        } else {
          console.warn('Can not reset TextToImage flag');
        }
      } catch {
        console.warn('Can not reset TextToImage flag');
      }
      this.ModelFirst = '-';
      this.Click_History_List(-1, '...', this.ModelFirst, -1, null);
    },
    selectTopic(topic) {
      const parentTopic = this.listTopic.find((t) => t.topicID === topic.topicID);
      if (parentTopic) {
        topic.topicModelID = parentTopic.topicModelID;
        topic.topicModelID_long = parentTopic.topicModelID_long;
        topic.llmid = parentTopic.llmid;
        this.isAllowLLMChange = topic.isAllowLLMChange;
        this.lastLLMID = topic.llmid;
      }
      this.Click_History_List(topic.topicID, topic.topicName, topic.topicModelID, topic.topicModelID_long, topic.keyTopic);
      this.SetLLMModel();
    },
    selectTopicOutside(topic) {
      this.lastLLMID = topic.llmid;
      this.isAllowLLMChange = topic.isAllowLLMChange;
      this.Click_History_List(topic.topicID, topic.topicName, topic.topicModelID, topic.topicModelID_long, topic.keyTopic);
      this.SetLLMModel();
    },
    SetLLMModel() {
      this.selectedLLMModel = this.allLLMModel.find((model) => model.id === this.lastLLMID);
    },
    openCreateDialog() {
      this.folderDialogStatus = {
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      };

      this.folderDialog = {
        visible: true,
        isNew: true,
        id: Date.now(),
        name: '',
      };
    },
    // แทน startEditFolder เดิม
    openRenameDialog(folder, idx) {
      this.folderDialogStatus = {
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      };

      this.folderDialog = {
        visible: true,
        isNew: false,
        id: folder.id,
        name: folder.name,
        idx,
      };
    },
    closeFolderDialog() {
      this.folderDialog.visible = false;

      setTimeout(() => {
        this.folderDialogStatus = {
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: '',
        };
      }, 300);
    },
    confirmFolderDialog() {
      const { name } = this.folderDialog;
      if (!name.trim()) return;

      this.folderDialogStatus.isLoading = true;
      this.folderDialogStatus.isSuccess = false;
      this.folderDialogStatus.isError = false;
      this.folderDialogStatus.errorMessage = '';

      // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.CreateFolder (folderDialog.isNew) / this.$call.UpdateFolder (แก้ไขโฟลเดอร์) ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
    },
    createFolder() {
      this.openCreateDialog();
    },
    startEditFolder(folder, idx) {
      this.openRenameDialog(folder, idx);
    },
    saveFolderName(folder) {
      folder.edit = false;
    },

    openDeleteDialog(folder, idx) {
      this.pendingDeleteTopicIds = folder.topics ? folder.topics.map((topic) => topic.topicID) : [];

      this.deleteFolderDialog = {
        visible: true,
        id: folder.id,
        idx,
        name: folder.name,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      };
    },
    closeDeleteDialog() {
      this.pendingDeleteTopicIds = [];
      setTimeout(() => {
        this.deleteFolderDialog = {
          visible: false,
          id: null,
          idx: null,
          name: '',
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: '',
          topics: [],
        };
      }, 300);
    },
    confirmDeleteDialog() {
      if (this.deleteFolderDialog.isLoading || this.deleteFolderDialog.isSuccess) return;

      this.deleteFolderDialog.isLoading = true;
      this.deleteFolderDialog.isSuccess = false;
      this.deleteFolderDialog.isError = false;
      this.deleteFolderDialog.errorMessage = '';

      setTimeout(() => {
        // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.DeleteFolder ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
      }, 600); // หน่วงเวลาเพื่อให้เห็น animation การโหลด
    },
    deleteFolder(id, idx) {
      // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.DeleteFolder ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
    },
    addTopicToFolder(folderId, topic) {
      // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.AddTopicToFolder ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
    },
    removeTopicFromFolder(folderId, topicId, topicIndex) {
      const folderIndex = this.folders.findIndex((f) => f.id === folderId);
      let topicName = '';
      let folderName = '';

      if (folderIndex !== -1) {
        folderName = this.folders[folderIndex].name;
        if (this.folders[folderIndex].topics && this.folders[folderIndex].topics[topicIndex]) {
          topicName = this.folders[folderIndex].topics[topicIndex].topicName;
        }
      }

      // เปิด Dialog
      this.removeTopicDialog = {
        visible: true,
        folderId: folderId,
        topicId: topicId,
        topicIndex: topicIndex,
        topicName: topicName,
        folderName: folderName,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      };
    },
    removeTopicFromFolderBypassDialog(folderId, topicId, topicIndex) {
      this.removeTopicDialog = {
        visible: false,
        folderId: folderId,
        topicId: topicId,
        topicIndex: topicIndex,
        topicName: '',
        folderName: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      };
      this.confirmRemoveTopic();
    },

    // เพิ่มเมธอดใหม่
    closeRemoveTopicDialog() {
      this.removeTopicDialog.visible = false;
      // รีเซ็ตค่าหลังจากปิด Dialog (ด้วย delay เล็กน้อย)
      setTimeout(() => {
        this.removeTopicDialog = {
          visible: false,
          folderId: null,
          topicId: null,
          topicIndex: null,
          topicName: '',
          folderName: '',
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: '',
        };
      }, 300);
    },

    // เพิ่มเมธอดใหม่สำหรับการยืนยันการลบ
    confirmRemoveTopic() {
      if (this.removeTopicDialog.isLoading || this.removeTopicDialog.isSuccess) return;

      // เปลี่ยนสถานะเป็นกำลังโหลด
      this.removeTopicDialog.isLoading = true;
      this.removeTopicDialog.isSuccess = false;
      this.removeTopicDialog.isError = false;
      this.removeTopicDialog.errorMessage = '';

      // หน่วงเวลาเล็กน้อยเพื่อให้เห็น animation การโหลด
      setTimeout(() => {
        // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.RemoveTopicFromFolder ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
      }, 600); // หน่วงเวลาให้เห็น animation loading
    },
    openMoveToFolderDialog(topic) {
      // ค้นหาว่า topic นี้อยู่ในโฟลเดอร์ใดบ้าง
      let currentFolder = null;
      for (const folder of this.folders) {
        const topicIndex = folder.topics ? folder.topics.findIndex((t) => t.topicID === topic.topicID) : -1;
        if (topicIndex !== -1) {
          currentFolder = folder;
          break;
        }
      }

      this.moveToFolderDialog = {
        visible: true,
        topicId: topic.topicID,
        topicName: topic.topicName,
        selectedFolderId: null,
        currentFolderId: currentFolder ? currentFolder.id : null,
      };
    },

    closeMoveToFolderDialog() {
      this.moveToFolderDialog = {
        visible: false,
        topicId: null,
        topicName: '',
        selectedFolderId: null,
        currentFolderId: null,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      };
    },

    confirmMoveToFolder() {
      if (this.moveToFolderDialog.isLoading || this.moveToFolderDialog.isSuccess) return;
      const { topicId, selectedFolderId, currentFolderId } = this.moveToFolderDialog;

      if (!selectedFolderId || selectedFolderId === currentFolderId) return;

      this.startMoveDialogLoading();
      this.$nextTick(() => {
        if (currentFolderId) {
          this.executeMoveTopicBetweenFolders(topicId, currentFolderId, selectedFolderId);
        } else {
          this.executeAddTopicToFolder(topicId, selectedFolderId);
        }
      });
    },
    startMoveDialogLoading() {
      this.moveToFolderDialog.isLoading = true;
      this.moveToFolderDialog.isSuccess = false;
      this.moveToFolderDialog.isError = false;
      this.moveToFolderDialog.errorMessage = '';
    },
    executeMoveTopicBetweenFolders(topicId, fromFolderId, toFolderId) {
      // ฟีเจอร์โฟลเดอร์ปิดอยู่: ลบโค้ดเรียก this.$call.MoveTopicToFolder ที่ comment ไว้แล้ว ดูของเดิมได้จาก git history (commit efb1a82bc หรือก่อนหน้า)
    },
    handleMoveTopicResponse(response, topicId, fromFolderId, toFolderId) {
      this.moveToFolderDialog.isLoading = false;

      if (response.status === 0 && response.data?.success !== false) {
        const fromFolderIndex = this.folders.findIndex((f) => f.id === fromFolderId);
        const toFolderIndex = this.folders.findIndex((f) => f.id === toFolderId);
        this.moveFolderTopic(fromFolderIndex, toFolderIndex, topicId);
        this.handleMoveDialogSuccess();
      } else {
        this.handleMoveDialogError(response.message || 'Failed to move topic');
      }
    },
    executeAddTopicToFolder(topicId, folderId) {
      const topic = this.listTopic.find((t) => t.topicID === topicId);
      if (!topic) {
        // confirmMoveToFolder has already set moveToFolderDialog.isLoading; without this the dialog
        // spins forever when listTopic has not hydrated yet. FullStreamDrawer handles it inline.
        this.handleMoveDialogError('Topic not found');
      }
    },
    handleAddTopicResponse(response, topic, folderId) {
      this.moveToFolderDialog.isLoading = false;

      if (response.status === 0 && response.data?.success !== false) {
        this.addTopicToFolderData(topic, folderId);
        this.handleMoveDialogSuccess();
      } else {
        this.handleMoveDialogError(response.message || 'Failed to add topic to folder');
      }
    },
    addTopicToFolderData(topic, folderId) {
      const folderIndex = this.folders.findIndex((f) => f.id === folderId);
      if (folderIndex === -1) return;

      if (!this.folders[folderIndex].topics) {
        this.folders[folderIndex].topics = [];
      }
      this.folders[folderIndex].topics.push({
        topicID: topic.topicID,
        topicName: topic.topicName,
        topicModelID: topic.topicModelID || 1,
        topicModelID_long: topic.topicModelID_long || topic.topicID,
        keyTopic: topic.keyTopic || topic.topicID.toString(),
      });
    },

    // #endregion

    // #region Delete chat
    openDeleteTopicDialog(item) {
      let realindex = this.listTopic.findIndex((t) => t.topicID === item.topicID);

      this.deleteTopicDialog = {
        visible: true,
        topicId: item.topicID,
        keyTopic: item.keyTopic,
        index: realindex,
        topicName: item.topicName,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
      };
    },

    closeDeleteTopicDialog() {
      this.deleteTopicDialog.visible = false;

      setTimeout(() => {
        this.deleteTopicDialog = {
          visible: false,
          topicId: null,
          keyTopic: null,
          index: null,
          topicName: '',
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: '',
        };
      }, 300);
    },

    confirmDeleteTopic() {
      if (this.deleteTopicDialog.isLoading || this.deleteTopicDialog.isSuccess) return;

      const { topicId, keyTopic, index } = this.deleteTopicDialog;

      this.deleteTopicDialog.isLoading = true;
      this.deleteTopicDialog.isSuccess = false;
      this.deleteTopicDialog.isError = false;

      setTimeout(() => {
        try {
          // ก่อนลบ topic ให้ตรวจสอบว่า topic นี้อยู่ใน folder ไหนบ้าง
          let folderContainingTopic = null;
          let topicIndexInFolder = -1;

          // ค้นหาทุก folder ที่มี topic นี้อยู่
          for (const folder of this.folders) {
            if (folder.topics && folder.topics.length > 0) {
              const foundIndex = folder.topics.findIndex((t) => t.topicID === topicId);
              if (foundIndex !== -1) {
                folderContainingTopic = folder;
                topicIndexInFolder = foundIndex;
                break;
              }
            }
          }

          // เรียกใช้ฟังก์ชันลบ topic
          this.DeleteTopicStream(topicId, keyTopic, index);

          // ถ้าพบว่า topic อยู่ใน folder ให้ลบออกจาก folder ด้วย
          if (folderContainingTopic && topicIndexInFolder !== -1) {
            folderContainingTopic.topics.splice(topicIndexInFolder, 1);
          }

          // แสดงสถานะสำเร็จ
          this.deleteTopicDialog.isLoading = false;
          this.deleteTopicDialog.isSuccess = true;

          // ปิด dialog หลังจากเสร็จสิ้น
          setTimeout(() => {
            this.closeDeleteTopicDialog();
          }, 1500);
        } catch (error) {
          console.error('Error deleting topic:', error);
          this.deleteTopicDialog.isLoading = false;
          this.deleteTopicDialog.isError = true;
          this.deleteTopicDialog.errorMessage = 'Failed to delete chat';

          setTimeout(() => {
            this.deleteTopicDialog.isError = false;
          }, 3000);
        }
      }, 600);
    },
    // #endregion
    clearSelectedModel(event) {
      this.selectedLLMModel = null;
      this.selectedLLMModelInChat = null;
      if (this.listTopic) {
        this.IsAllowImage = this.listTopic.find((e) => e.topicID == this.Log_History_TopicID).isAllowImage;
      }
      event.stopPropagation();
    },
    isActiveModel(item) {
      return this.TopicModelID === item.modelDisplayID;
    },
    selectModel(item) {
      this.Click_History_List(-1, item.modelName, item.modelDisplayID + ' (' + item.modelName + ')', item.modelID, null);
      this.Time_Delay = item.timeDelay;
      this.IsAllowImage = item.isAllowImage;
      this.maximumChatInput = item.maximumChatInput;
      this.IsChainMassage = item.isChainMassage;
      this.FileUploadLimit = item.fileUploadLimit;
      this.isAllowLLMChange = item.isAllowLLMChange;
      this.showMenu = false;
    },
    toggleModelDropdown() {
      this.showModelDropdown = !this.showModelDropdown;
    },

    closeModelDropdown() {
      this.showModelDropdown = false;
    },
    toggleModelDropdownDialog() {
      console.log('Toggle model dropdown dialog');
      this.showModelDropdownDialog = true;
    },

    closeModelDropdownDialog() {
      this.showModelDropdownDialog = false;
    },
    getModelsByProvider(providerId) {
      return this.allLLMModel.filter((model) => {
        if (providerId === 'azure') {
          return model.provider == 'Azure';
        } else if (providerId === 'anthropic') {
          return model.provider == 'Anthropic';
        } else if (providerId === 'google') {
          return model.provider == 'Google';
        } else if (providerId === 'others') {
          return model.provider == 'Other';
        }
        return false;
      });
    },
    SelectLLMMdel(model) {
      this.selectedLLMModel = model;
      this.selectedLLMModelInChat = model;
      this.showMenu = false;
    },
    // GetAllLLMModelData() {
    //   try {
    //     this.$call.GetAllLLMModelData(
    //       this.auth_token,
    //       (response) => {
    //         if (response.status === 0) {
    //           this.allLLMModel = response.data;
    //         } else {
    //           console.error('Failed to load models:', response.message || 'Unknown error');
    //         }
    //       },
    //       (error) => {
    //         console.error('Error loading models:', error);
    //       }
    //     );
    //   } catch (error) {
    //     console.error('Exception in GetAllModelData:', error);
    //   }
    // },
    handleDrawerScroll(e) {
      const scrollTop = e.target.scrollTop;
      this.isScrolled = scrollTop > 20;
    },
    sidebarClickHandle() {
      this.showSidebarTooltip = !this.showSidebarTooltip;
      this.drawerFull = !this.drawerFull;
    },
    setPathUrl() {
      // ลองหลายวิธีในการดึง route name
      const routeName = this.$route?.name || this.currentRoute?.name || this.currentRouter?.currentRoute?.value?.name;

      if (routeName) {
        this.pathUrl = routeName;
        return true;
      }

      // ถ้าไม่มี name ลองใช้ path แทน
      const routePath = this.$route?.path || this.currentRoute?.path || this.currentRouter?.currentRoute?.value?.path;

      if (routePath && routePath !== '/') {
        // แปลง path เป็น name (เอา / ออก)
        this.pathUrl = routePath.replace('/', '') || 'dashboard';
        return true;
      }

      return false;
    },
    async waitForRouter() {
      let attempts = 0;
      const maxAttempts = 15;

      while (attempts < maxAttempts) {
        if (this.$route?.name || this.$router?.currentRoute?.value?.name) {
          if (this.setPathUrl()) {
            return this.pathUrl;
          }
        }

        // รอ 100ms แล้วลองใหม่
        await new Promise((resolve) => setTimeout(resolve, 100));
        attempts++;
      }

      // ถ้ายังไม่ได้ ให้ใช้ค่า default
      if (!this.pathUrl) {
        this.pathUrl = 'dashboard'; // หรือค่า default ที่เหมาะสม
        console.warn('Failed to get route name, using default');
      }
      return this.pathUrl;
    },
    async ManageMights() {
      const rights = this.getRightsForRole(this.roleId);
      const includeChildren = this.roleId === 0 || this.roleId === 1;
      this.applyRightsToItems(rights, includeChildren);
      this.applyCompanyPagePermissions();
      this.applyRightsToProfile(rights);
      // hide productAdminOnly menus when ProductAdmin feature is disabled
      const isProductAdminEnabled = import.meta.env.VITE_APP_ProductAdmin == 'true' || Number(import.meta.env.VITE_APP_ProductAdmin) === 1;
      if (!isProductAdminEnabled) {
        this.hideProductAdminOnlyMenus();
      }
    },
    hideProductAdminOnlyMenus() {
      for (const item of this.items) {
        if (item.productAdminOnly) item.Check = false;
        if (item.children) {
          for (const child of item.children) {
            if (child.productAdminOnly) child.Check = false;
          }
        }
      }
    },
    hasAdminRights(route) {
      if (!route) {
        return false;
      }
      const isProductAdminEnabled = import.meta.env.VITE_APP_ProductAdmin == 'true' || Number(import.meta.env.VITE_APP_ProductAdmin) === 1;
      if (isProductAdminEnabled) {
        if (route.meta && route.meta.isProductAdmin) {
          return true;
        }
        if (route.children) {
          return route.children.some((child) => this.hasAdminRights(child));
        }
        return route.path === '';
      } else {
        return true;
      }
    },
    setFullname() {
      this.fullName = Cookies.get('fullName');
    },
    changeLocale(locale, flag) {
      this.applyLocale(locale);
      this.currentflag = flag;
      localStorage.setItem('flag', flag);
      localStorage.setItem('locale', locale);
      store.state.languages = locale;
    },
    downloadLink() {
      try {
        this.$call.DownloadUserManual(
          (dataResponse) => {
            const { fileContents, contentType, fileDownloadName } = dataResponse.data;
            const blob = this.base64ToBlob(fileContents, contentType);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileDownloadName);
            document.body.appendChild(link);
            link.click();
            globalThis.URL.revokeObjectURL(url);
            link.remove();
          },
          (errorResource) => {
            console.error(errorResource);
            this.$swal.fire({
              icon: 'error',
              title: 'File not found',
              text: 'The requested user manual could not be found.',
              showConfirmButton: true,
            });
          }
        );
      } catch {
        console.log('Error : File not found');
        this.$swal.fire({
          icon: 'error',
          title: 'File not found',
          text: 'Error, the requested user manual could not be found.',
          showConfirmButton: true,
        });
      }
    },
    base64ToBlob(base64, mimeType = '') {
      const binaryStr = atob(base64);
      const len = binaryStr.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryStr.codePointAt(i);
      }
      return new Blob([bytes], { type: mimeType });
    },
    async switchCompany() {
      this.$call.LoginThaiIDSwitchCompany(
        (data) => {
          const tempToken = data?.data?.tempToken;
          if (tempToken) {
            globalThis.location.href = `/select-company?t=${encodeURIComponent(tempToken)}`;
          }
        },
        (err) => {
          const msg = err?.response?.data?.message || 'ไม่สามารถเปลี่ยนองค์กรได้ กรุณาลอง Login ใหม่';
          console.error('switchCompany error:', err);
          alert(msg);
        }
      );
    },
    // mode: 'first-time' (เด้งครั้งแรก / เมนูโปรไฟล์) | 'assistant' (เมนู AI Assistant ใน sidebar) — ต่างกันที่ขั้น 1 และ 3
    openAssistantWizard(mode = 'first-time') {
      this.profileMenuOpen = false;
      // เปิดอยู่แล้ว = ไม่สลับโหมดกลางทาง (wizard ไม่ reset ตอนโหมดเปลี่ยน — ของที่เลือกไว้ในโหมด AI Assistant จะยังถูกนับ
      // ทั้งที่ส่วนให้เลือกหายไปแล้ว)
      if (this.assistantWizardOpen) return;
      this.assistantWizardMode = mode === 'assistant' ? 'assistant' : 'first-time';
      this.assistantWizardLoaded = true;
      this.assistantWizardOpen = true;
    },
    // เด้ง wizard ครั้งแรกที่ Admin เข้าหน่วยงาน — backend ตัดสินจากตาราง mas.AssistantWizardOnboarding (หน่วยงาน/ผู้ใช้จาก claim)
    // บันทึก "เห็นแล้ว" ทันทีที่เด้ง (ไม่รอให้ทำครบ) — ปิดกลางทาง/รีเฟรชก็ไม่เด้งซ้ำ ใช้ต่อได้จากเมนู AI Assistant
    // ล้มด้วยเหตุใดก็ตาม (เช่น backend ยังไม่ deploy) = ไม่เด้ง ไม่แจ้งอะไรผู้ใช้
    checkAssistantOnboarding() {
      this.assistantOnboardingChecked = true;
      this.$call.AssistantWizardOnboardingStatus(
        (response) => {
          if (!shouldAutoOpenWizard(response, { wizardOpen: this.assistantWizardOpen })) return;
          this.openAssistantWizard('first-time');
          this.$call.AssistantWizardOnboardingShown(
            () => {},
            () => {}
          );
        },
        () => {}
      );
    },
    // เมนู sidebar ที่เปิด wizard แทนการเปลี่ยนหน้า (เช่น "AI Assistant") — เมนูอื่นไม่มีผล (ไปตาม :to ปกติ)
    sidebarWizardMode(item) {
      return this.canOpenAssistantWizard ? wizardModeOfSidebarItem(item) : null;
    },
    onSidebarItemClick(item) {
      const mode = this.sidebarWizardMode(item);
      if (mode) this.openAssistantWizard(mode);
    },
    async goBackToSuperAdmin() {
      this.backToSuperAdminLoading = true;
      // รอให้ Vue flush DOM ก่อน fire API call — ป้องกัน dialog ไม่ทันแสดงถ้า API เร็วเกินไป
      await this.$nextTick();
      this.$call.SuperAdminResetToSuperAdmin(
        async (data) => {
          if (data.status === 0) {
            // Clear company cookies — auth cookie ถูก re-issue เป็น companyId=null แล้ว
            Cookies.remove('companyId');
            Cookies.remove('companyName');
            Cookies.remove('isSuperAdmin');
            this.companyName = '';
            sessionStorage.setItem('isSuperAdmin', 'true');
            // ส่ง flag ไปให้ SuperAdminDashboard แสดง loading dialog เมื่อ page โหลด
            sessionStorage.setItem('_fusion_sa_navigating_back', '1');
            await this.$router.replace({ name: 'SuperAdminDashboard' });
          } else {
            this.backToSuperAdminLoading = false;
            console.error('goBackToSuperAdmin business error:', data.message);
          }
        },
        (err) => {
          this.backToSuperAdminLoading = false;
          console.error('goBackToSuperAdmin error:', err);
        }
      );
    },
    logout() {
      if ((Cookies.get('roleId') == 0 || Cookies.get('roleId') == 1 || Cookies.get('roleId') == 6) && this.connection) {
        this.connection.stop();
      }
      const loginProvider = Cookies.get('loginProvider');
      const dgaIdpSession = Cookies.get('dga_idp_session');
      this.$call.ClearUserInfo();
      this.$store
        .dispatch('logout')
        .then(() => {
          // login ผ่าน DGA หรือมี DGA IdP session ค้าง (เช่น login user/pass แล้วมา link DGA)
          // → redirect ไป DGA end-session เพื่อล้าง DGA session จริงๆ ไม่งั้นกด Login DGA รอบหน้าจะ
          //   silent SSO ไม่ถามตัวตน (DGA ไม่ honor prompt=login จึงต้องล้าง session ตอน logout)
          if (loginProvider === 'digitalid' || dgaIdpSession === '1') {
            const apiBase = import.meta.env.VITE_APP_API;
            globalThis.location.href = `${apiBase}api/v0/LoginDGADigitalID/logout`;
            return;
          }
          // ถ้า login ผ่าน ThaID → เรียก revoke API ของ ThaID (server-to-server) + clear local session
          // ThaID ไม่มี end_session endpoint แบบ DGA — browser session ฝั่ง ThaID จะหมดตาม timeout
          if (loginProvider === 'thaid') {
            const apiBase = import.meta.env.VITE_APP_API;
            globalThis.location.href = `${apiBase}api/v0/LoginThaiID/logout`;
            return;
          }
          this.$call.Logout();
        })
        // eslint-disable-next-line no-console
        .catch((err) => console.log(err));
    },

    chatLogout() {
      // self.$store
      //   .dispatch("logout")
      //   .then(() => {
      //     self.$call.ChatLogout()
      //     self.$parent.$parent.clearInfo();

      this.$swal
        .fire({
          icon: 'success',
          title: 'Logout success',
          showConfirmButton: false,
          timer: 1500,
        })
        .then(() => {
          // self.$nextTick(()=>{
          // Cookies.remove("token");
          // Cookies.remove("email");
          // Cookies.remove("username");
          // Cookies.remove("isSnippet");
          this.mini = true;
          let cookies = Cookies.get(); // get all cookies
          for (let cookie in cookies) {
            Cookies.remove(cookie); // remove each cookie
          }

          sessionStorage.removeItem('token_Snippet');
          sessionStorage.removeItem('username_Snippet');
          sessionStorage.removeItem('email_Snippet');
          sessionStorage.removeItem('isSnippet');

          Cookies.remove('token_Snippet');
          Cookies.remove('username_Snippet');
          Cookies.remove('email_Snippet');
          Cookies.remove('isSnippet');
          this.User_Id = '';
          this.User_Id_Show = '';
          this.User_Id_Status = false;
          this.Snippet_Username = '';

          sessionStorage.removeItem('token_Snippet');
          sessionStorage.removeItem('username_Snippet');
          sessionStorage.removeItem('email_Snippet');
          sessionStorage.removeItem('isSnippet');

          localStorage.removeItem('token_Snippet');
          localStorage.removeItem('username_Snippet');
          localStorage.removeItem('email_Snippet');
          localStorage.removeItem('isSnippet');

          Cookies.remove('token_Snippet');
          Cookies.remove('username_Snippet');
          Cookies.remove('email_Snippet');
          Cookies.remove('isSnippet');
          this.showBTNLogin = true;
          globalThis.location.reload();
          //  });
        });
      // })
    },
    UserProfile() {
      this.$router.push('/userprofile');
    },
    substring(text) {
      return text;
    },
    homepage() {
      if (this.roleId == 0 || this.roleId == 1) {
        this.$router.push('/dashboard');
      } else {
        this.$router.push('/GPTModelManagement');
      }
    },
    Themecolor() {
      this.selectedColor = `#${this.colorThemeChat}`;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 20;
    },
    async GetCheckAnonymous() {
      try {
        if (
          (Cookies.get('token_Snippet') != null && Cookies.get('username_Snippet') != null && Cookies.get('email_Snippet') != null) ||
          (sessionStorage.getItem('token_Snippet') != null && sessionStorage.getItem('username_Snippet') != null && sessionStorage.getItem('email_Snippet') != null)
        ) {
          return;
        } else {
          this.$call.GetCheckAnonymous(
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (dataResponse.data != '1') {
                  this.OpenTabLogin();
                }
              }
            },
            (errorResource) => {
              console.error(errorResource);
            }
          );
        }
      } catch {

        console.log('catch : Get');
      }
    },
    async OpenTabLogin() {
      this.LeftNavBar = false;
      this.showBTNLogin = false;
      this.mini = true;
      this.drawerFull = false;
      this.flagNav = true;
      if (this.$route.name != 'LoginSnippet') {
        this.$router.push({
          name: 'LoginSnippet',
          params: { path: this.pathUrl },
          query: this.$route.query,
        });
      }
    },
    GetConsent() {
      this.$call.GetConsentConfig(
        'backend',
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.dataConsentTH = dataResponse.data.consentTH;
            this.dataConsentEN = dataResponse.data.consentEN;
            this.dataConsent = dataResponse.data.consentTH;
            this.dataVersion = dataResponse.data.showVersion;
            this.flagUpdateVersion = dataResponse.data.flagUpdateVersion;
          } else {
            this.dataConsentTH = '';
            this.dataConsentEN = '';
            this.dataConsent = '';
            this.dataVersion = '';
          }
          this.consentChecked = true;
        },
        (errorResource) => {
          console.error(errorResource);
          this.consentChecked = true;
        }
      );
    },
    async DisAgreeConsent() {
      try {
        // รอให้ router พร้อมก่อน
        if (!this.pathUrl) {
          await this.waitForRouter();
        }

        this.$call.Logout(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.$swal.fire({
                icon: 'success',
                title: 'Logout success',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
          (errorResource) => {
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.error('Error in DisAgreeConsent:', error);
      }
    },
    AgreeConsent() {
      let temp = {
        ConsentVersions: this.dataVersion,
        targetSystem: 'backend',
      };
      this.$call.SaveAgreeConsent(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.consent_dialog = false;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    formatText(text) {
      return text.replaceAll('\n', '<br>').replaceAll('\t', '&emsp;').replaceAll(/ {2} /g, '&nbsp;&nbsp;');
    },
    TopicUnread() {
      this.$call.TopicUnread(
        (dataResponse) => {
          if (dataResponse.status === 0) {
            let countUnreads = dataResponse.data;
            this.tabSocialType = this.tabSocialType.map((item) => {
              if (item.value === 'All') {
                // คำนวณผลรวมทั้งหมดของ unreadCount จาฝ countUnreads
                const total = countUnreads.reduce((sum, curr) => sum + curr.unreadCount, 0);
                return { ...item, unreadCount: total };
              } else {
                // ค้นหาข้อมูลใน countUnreads ที่ socialType ตรงฝับ text ของ tabSocialType
                const match = countUnreads.find((x) => x.socialType === item.value);
                return { ...item, unreadCount: match ? match.unreadCount : 0 };
              }
            });
            this.unreadCount = this.tabSocialType.find((x) => x.value === 'All').unreadCount;
          }
        },
        (errorResource) => {
          console.log('errorResource');
          console.error('Error: ', errorResource);
        }
      );
    },
    unlockAudio() {
      const sound = new Audio(this.sound);
      sound
        .play()
        .then(() => {
          this.audioUnlocked = true;
          localStorage.setItem('audioUnlocked', 'true');
          console.log('Audio unlocked');
        })
        .catch((err) => {
          console.error('Error unlocking audio:', err);
        });
    },

    // เพิ่มฟังฝ์ชันสำหรับเปิด/ปิดเสียง
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      // บันทึฝฝารตั้งค่าลง localStorage เพื่อเฝ็บฝารตั้งค่าไว้
      localStorage.setItem('soundEnabled', this.soundEnabled);

      // แสดงข้อความแจ้งเตือนฝารเปลี่ยนสถานะ
      this.$swal.fire({
        icon: 'success',
        title: this.soundEnabled ? this.$t('_InfoNotiOn') : this.$t('_InfoNotiOff'),
        showConfirmButton: false,
        timer: 1500,
      });
    },

    // ๝ฝ้ไขฝารเล่นเสียงใน TopicUnread เพื่อตรวจสอบสถานะฝารเปิดเสียง
    playNotificationSound() {
      if (this.soundEnabled) {
        let notificationSound = new Audio(this.sound);
        notificationSound.play().catch((err) => {
          console.error('Audio play error: ', err);
          // หาฝเฝิดข้อผิดพลาด ให้รีเซ็ตค่า audioUnlocked
          this.audioUnlocked = false;
          localStorage.setItem('audioUnlocked', 'false');
        });
      }
    },
    localize(text) {
      return this.$t(text);
    },
    // #region SignalR helper methods
    shouldInitializeSignalR() {
      const roleId = Cookies.get('roleId');
      const isValidRole = roleId == 0 || roleId == 1 || roleId == 6;
      const isExcludedPath = this.pathUrl === 'FullStream' || this.pathUrl === 'Snippet' || this.pathUrl === 'LoginSnippet';
      const isSuperAdmin = this.$store.state.isSuperAdmin;
      return isValidRole && !isExcludedPath && !isSuperAdmin;
    },
    createSignalRConnection() {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${this.urlApi}hub`, {
          // Avoid long-polling on App Gateway to prevent 504 timeouts on /hub?id=... requests.
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Error)
        .withAutomaticReconnect([5000, 5000, 10000, 10000, 15000])
        .build();
      this.connection.serverTimeoutInMilliseconds = 120000;
    },
    calculateUnreadCount(item, countUnreads) {
      if (item.value === 'All') {
        const total = countUnreads.reduce((sum, curr) => sum + curr.unreadCount, 0);
        return { ...item, unreadCount: total };
      }
      const match = countUnreads.find((x) => x.socialType === item.value);
      return { ...item, unreadCount: match ? match.unreadCount : 0 };
    },
    handleTopicUnreadResponse(dataResponse) {
      if (dataResponse.status !== 0) return;

      const countUnreads = dataResponse.data;
      this.tabSocialType = this.tabSocialType.map((item) => this.calculateUnreadCount(item, countUnreads));

      const temp = this.tabSocialType.find((x) => x.value === 'All').unreadCount;
      if (temp > 0 && this.unreadCount < temp) {
        this.playNotificationSound();
      }
      this.unreadCount = temp;
    },
    handleTopicUnreadError(errorResource) {
      console.log('errorResource');
      console.error('Error: ', errorResource);
    },
    setupTopicUnreadListener() {
      this.connection.on('TopicUnread', () => {
        this.$call.TopicUnread(
          (dataResponse) => this.handleTopicUnreadResponse(dataResponse),
          (errorResource) => this.handleTopicUnreadError(errorResource)
        );
      });
    },
    async initializeSignalR() {
      this.createSignalRConnection();

      this.connection
        .start()
        .then(() => {
          this.TopicUnread();
        })
        .catch((err) => console.log(err));

      this.setupTopicUnreadListener();
    },
    // #endregion
  },
  async beforeMount() {
    if (!this.pathUrl) {
      await this.waitForRouter();
    }
    try {
      await this.getStartUpImage();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    if (this.shouldInitializeSignalR()) {
      await this.initializeSignalR();
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    try {
      this.connection.stop();
    } catch {
      // intentionally ignored: SignalR connection may be absent or already stopped on teardown
    }

    const drawerContent = document.querySelector('#NavFullStream .v-navigation-drawer__content');
    if (drawerContent) {
      drawerContent.removeEventListener('scroll', this.handleDrawerScroll);
    }
  },
  async mounted() {
    // Re-read userType/companyName cookies
    this.userType = Cookies.get('userType') || '';
    this.companyName = Cookies.get('companyName') || '';
    this.isSuperAdmin = this.$store.state.isSuperAdmin;
    this.getCurrentPath();
    if (!this.pathUrl) {
      await this.waitForRouter();
    }
    this.initializeConsent();
    this.queryID = store.state.groupSecurityID;
    window.addEventListener('scroll', this.handleScroll);
    await this.ManageMights();

    this.$nextTick(async function () {
      this.initializePathAndParams();
      await this.handlePathSpecificSetup();
      this.show = true;
      this.isSnippet = this.parameterURL.snippet;
      await this.loadFolders();
    });

    this.initializeMenuState();
    document.documentElement.style.setProperty('--drawer-width', this.mini ? '0px' : '256px');
  },
};
</script>

<style>
:root {
  --drawer-width: 0px;
}

/* Add this to your existing styles */
.v-content__wrap {
  padding-left: var(--drawer-width) !important;
  transition: padding-left 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

/* Set drawer transition for smooth animation */
#NavFullStream {
  transition:
    width 0.3s cubic-bezier(0.2, 0, 0.4, 1),
    transform 0.3s cubic-bezier(0.2, 0, 0.4, 1) !important;
}

/* Adjust the container width in FullStreamReDesign.vue */
.container-chat {
  width: calc(100% - var(--drawer-width)) !important;
  margin-left: var(--drawer-width) !important;
  transition:
    width 0.3s cubic-bezier(0.2, 0, 0.4, 1),
    margin-left 0.3s cubic-bezier(0.2, 0, 0.4, 1);
  grid-template-columns: 1fr !important;
}


#Fusion_toolbar_FullStream {
  background-size: unset !important;
  background-repeat: no-repeat !important;
}

#Fusion_toolbar_FullStream.dga-navbar {
  height: 120px !important;
  min-height: 120px !important;
  max-height: 120px !important;
}

#Fusion_toolbar_FullStream.dga-navbar .v-toolbar__content {
  height: 120px !important;
  min-height: 120px !important;
  max-height: 120px !important;
}

#Fusion_toolbar_FullStream.fullstream-header-cover[id*='fullstreamdga'] {
  height: 120px !important;
  min-height: 120px !important;
}

#Fusion_toolbar_FullStream .v-toolbar__content {
  padding-left: 0px;
  border-bottom-style: solid;
  border-bottom-width: 3px;
  border-bottom-color: #f0f0f7;
}

#Fusion_Logo_FullStream {
  margin: auto;
  margin-left: 12px;
  margin-top: 0.2px;
}

#Fusion_Logo_FullStream.logo-dga {
  height: 104px !important;
  width: auto !important;
  object-fit: contain;
  margin-top: 8px;
}

/* Force DGA navbar height */
.v-app-bar.dga-navbar {
  height: 120px !important;
  min-height: 120px !important;
  max-height: 120px !important;
}

.v-app-bar.dga-navbar > .v-toolbar__content {
  height: 120px !important;
  min-height: 120px !important;
  max-height: 120px !important;
  align-items: center !important;
  border-bottom: solid;
}

.app {
  margin-left: 1rem;
  cursor: pointer;
}

.list {
  cursor: pointer;
}

.tooltip {
  position: relative;
  height: 45px;
  margin-bottom: 2rem;
}

.tooltip .tooltiptext {
  display: none;
}

.tooltip .tooltiptext2 {
  display: block;
}

.tooltip:hover .tooltiptext {
  display: block;
}

.tooltip:hover .tooltiptext2 {
  display: none;
}

#NavFullStream .v-navigation-drawer__border {
  background-color: rgba(0, 0, 0, 0);
}
</style>

<!-- #region style Snippet -->
<style>
#Nav_SnippetFull {
  position: fixed;
  width: 100%;
}

#Nav_SnippetFull .v-overlay {
  position: fixed;
}

#Toolbar_SnippetFull {
  background-size: unset !important;
  background-repeat: no-repeat !important;
  box-shadow: none !important;
  background-color: #ffffff;
  height: 62px !important;
}

#Toolbar_SnippetFull .v-toolbar__content {
  padding-left: 0px;
  border-bottom-style: solid;
  border-bottom-width: 3px;
  border-bottom-color: #f0f0f7;
}

#Chat_Logo_SnippetFull {
  cursor: unset;
  margin: auto;
  margin-left: 12px;
  margin-top: 0.2px;
}

#NavSnippetFull .v-navigation-drawer__border {
  background-color: rgba(0, 0, 0, 0);
}

.scroll-to-top {
  transition: 0.2s ease !important;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.scroll-to-top-close {
  transition: 0.2s ease !important;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  opacity: 0;
}

.no-border-editor .ql-editor {
  border: none !important;
  box-shadow: none !important;
}

.no-border-editor .ql-container {
  border: none !important;
}

.floating-nav-button {
  position: fixed;
  top: 72px;
  color: RGB(76, 175, 135);
  left: 20px;
  z-index: 999;
}

.colored-icon {
  /* RGB(76, 175, 135) color effect */
  filter: brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(831%) hue-rotate(102deg) brightness(95%) contrast(88%) !important;
}

.no-border-editor {
  border: none !important;
  box-shadow: none !important;
  padding: 10px;
}

.no-border-editor .codex-editor__redactor {
  padding: 0 !important;
}

.no-border-editor .ce-block__content {
  max-width: 100% !important;
  margin: 0;
}

.no-border-editor .codex-editor {
  border: none !important;
}

.profile-info {
  width: 100%;
  margin-top: 8px;
  text-align: center;
  z-index: 1;
}

.profile-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--dga-color-ink);
  margin-bottom: 2px;
  line-height: 1.3;
  font-family: var(--dga-font-family);
}

.role-chip {
  font-size: 11px !important;
}

.role-text {
  font-size: 11px;
  opacity: 0.95;
}

.menu-item {
  border-radius: 8px;
  transition: background-color 0.2s ease;
  height: 44px;
  margin-bottom: 2px !important;
  color: rgba(0, 0, 0, 0.65) !important;
}

.menu-item:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
  color: rgba(0, 0, 0, 0.9) !important;
}

.v-list-group__header {
  min-height: 44px !important;
  border-radius: 8px;
  color: rgba(0, 0, 0, 0.65) !important;
}

.v-list-group__header:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
  color: rgba(0, 0, 0, 0.9) !important;
}

.submenu-item {
  min-height: 38px !important;
  padding-left: 12px !important;
  height: 40px !important;
  border-radius: 8px !important;
  transition: all 0.15s ease !important;
  margin: 2px 0 !important;
  color: rgba(0, 0, 0, 0.65) !important;
}

.submenu-title {
  font-size: 0.8375rem !important;
  font-weight: 400 !important;
  color: var(--dga-color-ink-muted) !important;
  letter-spacing: 0.0125em;
  font-family: var(--dga-font-family) !important;
  transition: all 0.15s ease;
}

.submenu-icon {
  font-size: 18px !important;
  color: rgba(0, 0, 0, 0.55);
}

.menu-group .v-list-group__items {
  padding-left: 16px;
}

.v-list-item--active .submenu-title {
  color: var(--dga-color-primary) !important;
  font-weight: 500;
}

.v-list-item--active .submenu-icon {
  color: var(--dga-color-primary) !important;
}

.fixed-breadcrumbs {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 5;
  /* White breadcrumb bar (per design) — opaque, so it masks content scrolling underneath. */
  background-color: white;
  padding-bottom: 0px;
}

/* ---- portal top bar (fixed design, no company theme): พื้น background token + เส้นใต้, โลโก้ DGA 70×40,
   ปุ่มวงกลม/แคปซูลกรมท่า (primary) ตัวอักษรขาว ---- */
.portal-topbar.v-app-bar {
  background: var(--dga-color-background) !important;
  border-bottom: 1px solid var(--dga-color-border) !important;
}
.portal-topbar .v-toolbar__content {
  padding-inline: 16px 16px;
  gap: 12px;
}
.portal-topbar__logo {
  display: block;
  width: 70px;
  height: 40px;
  object-fit: contain;
}
.portal-topbar__burger {
  color: var(--dga-color-ink) !important;
}
.portal-topbar__btn.v-btn,
.portal-topbar__profile.v-btn {
  background: var(--dga-color-primary) !important;
  color: rgb(var(--v-theme-on-primary)) !important;
}
.portal-topbar__btn.v-btn {
  width: 40px;
  height: 40px;
}
.portal-topbar__avatar {
  background: var(--dga-color-surface) !important;
  color: var(--dga-color-primary) !important;
}
.portal-topbar__profile .user-name {
  color: inherit;
  text-transform: uppercase;
}
/* phones: avatar + chevron only, so the three controls fit next to the logo and menu button */
@media (max-width: 599px) {
  .portal-topbar__profile .user-name {
    display: none;
  }
}

.user-profile-button {
  border-radius: 40px !important;
  height: 40px !important;
  padding: 0 14px 0 2px !important;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease !important;
}

.user-profile-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;
}

.user-name {
  font-weight: 500;
  letter-spacing: 0.0125em;
  font-size: 0.9rem;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-menu-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.user-menu-header {
  background: linear-gradient(to right, rgba(240, 240, 245, 0.5), rgba(240, 240, 245, 0.1));
}

.menu-list-item {
  min-height: 40px !important;
  transition:
    background-color 0.15s ease,
    transform 0.15s ease !important;
}

.menu-list-item:hover {
  background-color: rgba(25, 118, 210, 0.08);
  transform: translateX(2px);
}

.menu-item-title {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

/* เพิ่ม styles สำหรับ divider */
.v-divider {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

/* Enhance other nav buttons */
.v-btn.icon {
  border-radius: 12px !important;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.v-btn.icon:hover {
  transform: translateY(-1px);
  opacity: 0.95;
}

/* Tooltip enhancements */
.v-tooltip .v-overlay__content {
  background: rgba(33, 33, 33, 0.9) !important;
  border-radius: 8px !important;
  font-size: 12px !important;
  padding: 6px 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.modern-menu {
  padding-top: 4px !important;
  background: transparent !important;
  font-family: var(--dga-font-family) !important;
}

.menu-item,
.menu-group-header {
  border-radius: 8px !important;
  height: 44px !important;
  margin: 2px 0 !important;
  position: relative;
  transition: all 0.15s ease-in-out !important;
  color: rgba(0, 0, 0, 0.65) !important;
}

.menu-item::before,
.menu-group-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.06);
  transition: opacity 0.15s ease;
  pointer-events: none;
}

.menu-item:hover::before,
.menu-group-header:hover::before {
  opacity: 1;
}

.icon-container {
  transition: all 0.15s ease;
  min-width: 22px;
  width: 22px;
}

.menu-item:hover .icon-container,
.menu-group-header:hover .icon-container {
  transform: none;
}

.menu-title {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.01em !important;
  font-family: var(--dga-font-family) !important;
}

/* Active flat item — same selected tint as the SuperAdmin sidebar */
.menu-active {
  background: var(--dga-color-nav-active-bg) !important;
  border-radius: 8px !important;
}

/* Neutralise Vuetify's own active overlay so it doesn't stack on top of our primary tint
   (the stacking is what made the active item look heavier vs SuperAdmin). */
.menu-active .v-list-item__overlay,
.menu-group-active .v-list-item__overlay {
  opacity: 0 !important;
}

.menu-active .menu-title,
.menu-active .v-icon {
  color: var(--dga-color-selected-ink) !important;
  font-weight: 600 !important;
}

.menu-active .icon-container {
  transform: none;
}

/* Active group header */
.menu-group-active > .v-list-group__header,
.menu-group-active .menu-group-header {
  background: color-mix(in srgb, var(--dga-color-nav-active-bg) 60%, transparent) !important;
  border-radius: 8px !important;
}

.menu-group-active > .v-list-group__header .menu-title,
.menu-group-active > .v-list-group__header .v-icon {
  color: var(--dga-color-selected-ink) !important;
}

/* Submenu styling */
.submenu-container {
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  margin-left: 12px !important;
  padding-left: 8px !important;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.submenu-item:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
  color: rgba(0, 0, 0, 0.9) !important;
}

.submenu-item:hover .submenu-title {
  color: rgba(0, 0, 0, 0.9) !important;
  transform: none;
}

.submenu-active {
  background: var(--dga-color-nav-active-bg) !important;
  border-radius: 8px !important;
}

/* Same overlay neutralisation as the flat items, so active children show the clean primary tint */
.submenu-active .v-list-item__overlay {
  opacity: 0 !important;
}

.submenu-active .submenu-title {
  color: var(--dga-color-selected-ink) !important;
  font-weight: 500 !important;
}

/* Group menu styling */
.v-list-group--active > .v-list-group__header .v-icon {
  transform: rotate(90deg);
  color: var(--dga-color-primary) !important;
}

.v-list-group__items {
  margin-bottom: 4px !important;
  /* Animation for dropdown */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Badge styling */
.v-badge__badge {
  font-size: 10px !important;
  min-width: 18px !important;
  height: 18px !important;
  font-weight: bold !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;
}

.v-list-group--active > .v-list-group__items {
  margin-top: 2px !important;
}

#Fusion_nav_FullStream .v-navigation-drawer .v-list-group__items .v-list-item,
nav .modern-menu .v-list-group__items .v-list-item {
  padding-inline-start: 8px !important;
}

.icon-container .v-icon {
  color: rgba(0, 0, 0, 0.55) !important;
  font-size: 20px !important;
  opacity: 1;
  transition: all 0.15s ease;
}

/* icon colour on hover */
.menu-item:hover .icon-container .v-icon,
.menu-group-header:hover .icon-container .v-icon {
  color: rgba(0, 0, 0, 0.75) !important;
  opacity: 1;
}

/* icon colour when active */
.menu-active .icon-container .v-icon,
.v-list-group--active > .v-list-group__header .icon-container .v-icon {
  color: var(--dga-color-primary) !important;
  opacity: 1;
}

.data-consent-text::-webkit-scrollbar {
  width: 10px;
  /* ปรับความกว้างของ scrollbar */
}

.data-consent-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* สีพื้นหลังของ track */
  border-radius: 10px;
}

.data-consent-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  /* สีของตัวเลื่อน (thumb) */
  border-radius: 10px;
}

.data-consent-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
  /* สีของตัวเลื่อนเมื่อ hover */
}

/* For Firefox */
.data-consent-text {
  scrollbar-width: thin;
  /* 'auto', 'thin', 'none' */
  scrollbar-color: #c1c1c1 #f1f1f1;
  /* thumb color track color */
}

.data-consent-text h1,
.data-consent-text h2,
.data-consent-text h3,
.data-consent-text h4,
.data-consent-text h5,
.data-consent-text h6 {
  all: revert !important;
}

.data-consent-text ul,
.data-consent-text ol {
  list-style: initial !important;
  /* ลองใช้ initial หรือ revert */
  padding-left: 20px !important;
  /* ค่ามาตรฐานของ browser */
  margin-left: 20px !important;
  /* หรือปรับตามความเหมาะสม */
  display: block !important;
  /* ตรวจสอบว่าไม่ได้ถูกตั้งเป็น flex หรือ inline */
}

.data-consent-text li {
  /* ใช้ selector ที่ครอบคลุมทั้ง ul li และ ol li */
  display: list-item !important;
  list-style-position: outside !important;
  /* ลองเพิ่ม property นี้ */
  list-style-type: inherit !important;
  /* ให้ li รับค่า style type จาก ul/ol แม่ */
  margin-bottom: 0.3em;
  /* เว้นระยะห่างระหว่างรายการ (ถ้าต้องการ) */
  padding-left: 0 !important;
  /* ป้องกัน padding ที่ไม่ต้องการใน li */
  text-indent: 0 !important;
  /* ป้องกันการเยื้องที่ไม่ต้องการ */
}

/* หาก inherit ไม่ทำงาน ลองกำหนดโดยตรง */
.data-consent-text ul > li {
  list-style-type: disc !important;
  /* หรือ circle, square */
}

.data-consent-text ol > li {
  list-style-type: decimal !important;
  /* หรือ lower-alpha, upper-roman */
}
</style>
<!-- #endregion -->

<style scoped>
.superadmin-transition-shell {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  background: var(--dga-color-background);
}

.superadmin-transition-sidebar {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px 16px;
  background: var(--dga-color-sidebar);
  border-right: 1px solid var(--dga-color-border);
}

.superadmin-transition-logo-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 6px 18px;
}

.superadmin-transition-logo-skeleton {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
}

.superadmin-transition-logo-text {
  flex: 1;
}

.superadmin-transition-menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.superadmin-transition-menu-item {
  border-radius: 16px;
  overflow: hidden;
}

.superadmin-transition-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.superadmin-transition-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 64px;
  padding: 0 24px;
  background: var(--dga-color-surface);
  border-bottom: 1px solid var(--dga-color-border);
}

.superadmin-transition-topbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.superadmin-transition-action {
  width: 34px;
  height: 34px;
}

.superadmin-transition-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
}

.superadmin-transition-status {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  align-self: flex-start;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid var(--dga-color-border);
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(var(--v-theme-secondary), 0.08);
}

.superadmin-transition-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--dga-color-title-ink);
}

.superadmin-transition-subtitle {
  margin-top: 2px;
  font-size: 0.875rem;
  color: var(--dga-color-ink-muted);
}

.superadmin-transition-hero {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.superadmin-transition-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.superadmin-transition-card {
  border-radius: 20px;
  overflow: hidden;
  min-height: 180px;
}

@media (max-width: 960px) {
  .superadmin-transition-shell {
    grid-template-columns: 1fr;
  }

  .superadmin-transition-sidebar {
    display: none;
  }

  .superadmin-transition-topbar {
    padding: 0 16px;
  }

  .superadmin-transition-content {
    padding: 16px;
  }

  .superadmin-transition-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .superadmin-transition-topbar-actions {
    gap: 8px;
  }

  .superadmin-transition-status {
    width: 100%;
  }

  .superadmin-transition-cards {
    grid-template-columns: 1fr;
  }
}

.drawer-header-sticky {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
  height: 60px !important;
  display: flex !important;
  justify-content: flex-end !important;
  margin: -20px -12px 0px 0px !important;
  transition: all 0.3s ease !important;

  /* Base background */
  background: rgb(236, 240, 244) !important;
}

.drawer-header-sticky.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  background: rgba(236, 240, 244, 0.95) !important;
}

.new-chat-fab {
  opacity: 1 !important;
  width: 22px !important;
  height: 22px !important;
  margin-top: 8px !important;
  border-radius: 12px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: none !important;
  cursor: pointer !important;
}

.new-chat-fab:hover {
  transform: scale(1.1) !important;
}

.user-id-badge {
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 5px 6px;
}

.user-id-icon {
  background: rgb(76, 175, 135);
  border-radius: 8px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.user-id-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.user-id-label {
  font-size: 10px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
  font-weight: 500;
}

.user-id-value {
  font-size: 12px;
  color: #1e293b;
  font-weight: 600;
  line-height: 1.2;
  margin-top: 2px;
  line-break: anywhere;
  max-width: 160px;
}

.topic-list-item {
  padding: 0 0 6px 0;
}

.topic-item {
  width: 100%;
  background-color: white;
  border-radius: 14px;
  padding: 3px 16px;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 45px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.topic-item:hover {
  background-color: #f8fafc;
  transform: translateY(-1px);
}

.topic-item--editing {
  width: 100%;
  background-color: #f8fafc;
  cursor: default;
}

.topic-item--clickable {
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.topic-item--clickable:active {
  transform: translateY(0);
}

.topic-icon-wrapper {
  flex-shrink: 0;
  opacity: 0.7;
}

.topic-content {
  min-width: 0;
}

.topic-title-wrapper {
  width: 100%;
}

.topic-title {
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  line-height: 1.3;
  display: block;
}

.topic-menu-button {
  border-radius: 50% !important;
  transition:
    opacity 0.2s ease,
    background-color 0.2s ease;
  width: 30px !important;
  height: 30px !important;
}

.topic-menu-button:hover {
  opacity: 1 !important;
  background-color: rgba(255, 145, 0, 0.2);
}

.Cls_Text_field_TopicName :deep(.v-input__control) {
  width: 100% !important;
}

/* Menu items */
.v-list-item.text-error:hover {
  background-color: rgba(244, 67, 54, 0.04);
}

/* Scroll container */
.topic-scroll-container {
  padding: 4px 0;
}

.time-delay-input {
  background: white;
  border-radius: 12px;
}

.time-delay-input .v-field {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.time-delay-input:hover .v-field {
  border-color: rgba(25, 118, 210, 0.3);
}

.time-delay-input.v-field--focused .v-field {
  border-color: var(--v-primary-base);
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.floating-nav-button-div {
  position: fixed;
  top: 130px;
  z-index: 999;
  width: 40px;
  height: 40px;
  margin-right: -8px !important;
  background-color: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

.floating-nav-button-div:hover {
  background: rgba(0, 0, 0, 0.05);
}

.floating-nav-button-div:active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.floating-nav-dropdown {
  position: fixed;
  top: 130px;
  z-index: 999;
  width: 40px;
  height: 40px;
  margin-right: -8px !important;
  background-color: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

.consent-dialog :deep(.v-overlay__content) {
  border-radius: 20px;
  overflow: hidden;
  /* Animation for dialog entrance */
  animation: slideUp 0.3s ease-out;
}

.consent-card {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
}

.consent-header {
  background: linear-gradient(135deg, #1a5276 0%, #2471a3 50%, #3498db 100%);
  color: white;
  padding: 24px 32px;
  position: relative;
  overflow: hidden;
}

.consent-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="1.5" fill="rgba(255,255,255,0.08)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.1)"/></svg>');
  opacity: 0.3;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.header-icon {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 12px;
  backdrop-filter: blur(10px);
}

.header-text {
  flex: 1;
}

.consent-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.consent-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 4px 0 0 0;
  font-weight: 400;
}

.version-language-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  background: #f8fafc;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.version-info :deep(.v-chip) {
  font-weight: 500;
}

.language-toggle {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.language-btn {
  border-radius: 0 !important;
  transition: all 0.2s ease;
  font-weight: 500;
}

.language-btn:hover {
  background-color: rgba(25, 118, 210, 0.08);
}

.consent-content {
  padding: 0 !important;
}

.content-wrapper {
  padding: 32px;
}

.content-scroll-area {
  max-height: 40vh;
  overflow-y: auto;
  padding: 24px;
  background: white;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
}

.consent-text-content {
  font-size: 15px;
  line-height: 1.6;
  color: #374151;
}

/* Enhanced scrollbar */
.content-scroll-area::-webkit-scrollbar {
  width: 8px;
}

.content-scroll-area::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.content-scroll-area::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.content-scroll-area::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
}

.consent-actions {
  padding: 24px 32px;
  background: #f8fafc;
  gap: 16px;
}

.consent-action-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.25px !important;
  min-width: 140px !important;
  height: 48px !important;
  transition: all 0.2s ease !important;
}

.decline-btn {
  border-width: 2px !important;
}

.decline-btn:hover {
  background-color: rgba(244, 67, 54, 0.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.2);
}

.accept-btn {
  color: white !important;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3) !important;
}

.accept-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.4) !important;
}

.accept-btn:active {
  transform: translateY(0);
}

/* Content styling enhancements */
.consent-text-content :deep(h1),
.consent-text-content :deep(h2),
.consent-text-content :deep(h3),
.consent-text-content :deep(h4),
.consent-text-content :deep(h5),
.consent-text-content :deep(h6) {
  color: #1f2937;
  margin-top: 24px;
  margin-bottom: 12px;
  font-weight: 600;
}

.consent-text-content h1 {
  font-size: 24px;
}

.consent-text-content h2 {
  font-size: 20px;
}

.consent-text-content h3 {
  font-size: 18px;
}

.consent-text-content p {
  margin-bottom: 16px;
  color: #374151;
}

.consent-text-content :deep(ul),
.consent-text-content :deep(ol) {
  margin: 16px 0 !important;
  padding-left: 32px !important;
}

.consent-text-content li {
  margin-bottom: 8px;
  color: #4b5563;
}

.consent-text-content strong {
  color: #1f2937;
  font-weight: 600;
}

/* Responsive design */
@media (max-width: 768px) {
  .consent-card {
    margin: 16px;
    border-radius: 16px !important;
  }

  .consent-header {
    padding: 20px 24px;
  }

  .consent-title {
    font-size: 20px;
  }

  .version-language-section {
    flex-direction: column;
    gap: 16px;
    padding: 16px 24px;
    text-align: center;
  }

  .content-wrapper {
    padding: 24px;
  }

  .consent-actions {
    flex-direction: column;
    gap: 12px;
    padding: 20px 24px;
  }

  .action-btn {
    width: 100% !important;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 100;
  border-radius: 8px;
  animation: dropdownFadeIn 0.2s ease;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.08);
}

.custom-model-card {
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
  min-width: 320px;
  max-width: 460px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.custom-model-header {
  padding: 12px 16px 8px;
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.75);
}

.custom-model-content {
  padding: 0 12px 8px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 250px);
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

/* Minimal Expansion Panels */
.minimal-panels {
  box-shadow: none !important;
  background-color: transparent !important;
}

.minimal-panel {
  margin-bottom: 4px !important;
  background-color: transparent !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  border-radius: 6px !important;
  overflow: hidden;
}

.minimal-panel:before {
  box-shadow: none !important;
}

.minimal-header {
  padding: 0 12px !important;
  min-height: 40px !important;
}

.provider-name {
  font-weight: 500;
  font-size: 14px;
}

.minimal-chip {
  font-size: 10px !important;
  height: 18px !important;
  font-weight: 500;
}

.minimal-content {
  padding: 0 !important;
}

.minimal-list {
  padding: 0 !important;
  background-color: transparent !important;
}

.minimal-list-item {
  border-radius: 4px !important;
  min-height: 40px !important;
  margin: 4px 0 !important;
  padding-left: 12px !important;
  transition: background-color 0.2s;
}

.minimal-list-item:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.selected-model {
  background-color: rgba(var(--v-primary-base), 0.05) !important;
}

/* Dropdown Trigger */
.model-dropdown-mobile {
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  height: 32px;
}
.model-dropdown {
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 6px;
  background-color: rgb(245, 245, 245);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s;
  height: 32px;
}

.model-dropdown:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.model-name {
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
}

.clear-model-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
  margin-right: 2px;
  background-color: transparent !important;
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
}

.clear-model-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

.model-avatar {
  background-color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* LLM Dialog Version 2 Styles */
.llm-nav-dropdown-v2 {
  position: fixed;
  top: 70px;
  z-index: 999;
  transition: all 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

.llm-model-selector-v2 {
  width: auto;
}

.llm-dropdown-container-v2 {
  position: relative;
}

.llm-model-activator-v2 {
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  min-height: 36px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.llm-model-activator-v2:hover {
  background-color: rgba(255, 255, 255, 1);
  border-color: rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.llm-model-display-name-v2 {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.llm-clear-btn-v2 {
  opacity: 0.7;
  transition: all 0.2s ease;
  background-color: transparent !important;
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
}

.llm-clear-btn-v2:hover {
  opacity: 1;
  transform: scale(1.1);
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.llm-dialog-card-v2 {
  border-radius: 16px !important;
  overflow: hidden;
  min-width: 450px;
  max-width: 550px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

.llm-dialog-header-v2 {
  background: linear-gradient(135deg, #e6f2ff 0%, #e2e8f0 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 18px 24px !important;
  font-size: 1.2rem !important;
  font-weight: 600;
  color: #1e293b;
}

.llm-dialog-content-v2 {
  padding: 20px 24px !important;
  max-height: 65vh;
  overflow-y: auto;
}

.llm-panels-v2 {
  box-shadow: none !important;
  background-color: transparent !important;
}

.llm-panel-item-v2 {
  margin-bottom: 8px !important;
  background-color: #f8fafc !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.2s ease;
}

.llm-panel-item-v2:hover {
  background-color: #f1f5f9 !important;
  border-color: rgba(25, 118, 210, 0.2) !important;
}

.llm-panel-item-v2:before {
  box-shadow: none !important;
}

.llm-panel-header-v2 {
  padding: 0 16px !important;
  min-height: 44px !important;
  background-color: transparent !important;
}

.llm-provider-name-v2 {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
}

.llm-count-chip-v2 {
  font-size: 11px !important;
  height: 20px !important;
  font-weight: 600;
  border-radius: 10px !important;
}

.llm-panel-content-v2 {
  padding: 0 !important;
  background-color: white !important;
}

.llm-model-list-v2 {
  padding: 8px !important;
  background-color: transparent !important;
}

.llm-model-item-v2 {
  border-radius: 8px !important;
  min-height: 44px !important;
  margin: 2px 0 !important;
  padding: 8px 16px !important;
  transition: all 0.2s ease;
  cursor: pointer;
}

.llm-model-item-v2:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
  transform: translateX(2px);
}

.llm-model-selected-v2 {
  background-color: rgba(25, 118, 210, 0.08) !important;
  border-left: 3px solid var(--v-primary-base) !important;
}

.llm-model-selected-v2:hover {
  background-color: rgba(25, 118, 210, 0.12) !important;
}

/* Dialog transition */
.dialog-transition-enter-active,
.dialog-transition-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.dialog-transition-enter-from {
  opacity: 0;
  transform: scale(0.9);
}

.dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

/* Enhanced scrollbar for dialog content */
.llm-dialog-content-v2::-webkit-scrollbar {
  width: 6px;
}

.llm-dialog-content-v2::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.llm-dialog-content-v2::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.llm-dialog-content-v2::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .llm-dialog-card-v2 {
    margin: 16px;
    min-width: 320px;
    max-width: calc(100vw - 32px);
  }

  .llm-dialog-header-v2 {
    padding: 16px 20px !important;
    font-size: 1.1rem !important;
  }

  .llm-dialog-content-v2 {
    padding: 16px 20px !important;
  }
}

.folder-list-container {
  max-width: 250px;
  background-color: transparent !important;
  max-height: none !important;
  overflow-y: visible !important;
  padding: 10px;
}

.folder-dialog-wrapper {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

.folder-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.folder-icon-animation {
  animation: bounceIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes bounceIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  60% {
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.slide-y-transition-enter-active,
.slide-y-transition-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  pointer-events: none;
}

.slide-y-transition-enter,
.slide-y-transition-leave-to {
  opacity: 0;
  transform: translateY(-20px) !important;
}

.dialog-title {
  background-color: #f8f9fa;
  padding: 16px 24px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.dialog-title .headline {
  font-size: 18px !important;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.dialog-content {
  padding: 24px !important;
}

.dialog-content .v-text-field {
  margin-top: 8px;
}

.dialog-actions {
  padding: 8px 24px 16px !important;
}

.dialog-actions .v-btn {
  width: 120px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.25px;
}

.cancel-btn {
  color: rgba(0, 0, 0, 0.6) !important;
  font-weight: 500;
}

.cancel-btn:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.save-btn {
  margin-left: 8px !important;
  min-width: 100px !important;
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}
.save-btn:hover {
  box-shadow: none !important;
}

.save-btn:disabled {
  opacity: 0.5;
}

.folder-selector-container {
  max-height: 300px;
  overflow-y: auto;
  margin: 8px 0;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.folder-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: #fff;
  position: relative;
  overflow: hidden;
}

.folder-option:last-child {
  border-bottom: none;
}

.folder-option:hover:not(.folder-option-disabled) {
  background-color: rgba(0, 0, 0, 0.03);
}

.folder-option-selected {
  background-color: rgba(250, 169, 27, 0.08) !important;
  border-left: 3px solid var(--v-primary-base, #faa91b);
}

.folder-option-disabled {
  opacity: 0.6;
  background-color: rgba(0, 0, 0, 0.02);
}

.folder-option-icon {
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.folder-option-selected .folder-option-icon {
  background-color: rgba(250, 169, 27, 0.15);
  transform: scale(1.1);
}

.folder-option-content {
  flex: 1;
}

.folder-option-name {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
}

.folder-option-info {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.folder-option-action {
  margin-left: 8px;
}

.delete-folder-dialog {
  transition: all 0.3s ease;
}

.folder-name-active {
  font-weight: 500;
}

.dialog-header {
  padding: 20px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.dialog-header .title {
  font-size: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.folder-name-delete {
  display: inline-block;
}

@keyframes pulse {
  0% {
    background-color: rgba(244, 67, 54, 0.03);
  }

  100% {
    background-color: rgba(244, 67, 54, 0.1);
  }
}

.warning-text {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.7);
}

.hint-text {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
  background-color: rgba(0, 0, 0, 0.03);
  padding: 12px;
  border-radius: 8px;
  border-left: 3px solid #ffb74d;
}

.delete-btn {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.25px;
  padding: 0 16px;
  min-width: 140px !important;
  width: auto !important;
  transition: all 0.3s ease;
}

.delete-btn .d-flex {
  width: 100%;
  justify-content: center;
}

.delete-btn .v-btn__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rounded-popup {
  border-radius: 18px !important;
}

.empty-folder-state {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin: 8px 0;
  height: 40px;
}

.empty-folder-text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  margin: 0 0 8px;
}

.folder-view-content {
  display: flex;
  align-items: center;
  padding: 0;
  font-size: 14px;
  color: #71717a;
  overflow: hidden;
  width: 100%;
}

.folder-view-content .folder-name {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.folder-view-content > .v-menu {
  margin-left: auto;
  flex: 0 0 auto;
}
.folder-menu-btn {
  margin-right: -10px;
  transition:
    transform 0.2s ease,
    background-color 0.2s ease;
}

.folder-menu-btn:hover {
  transform: rotate(90deg);
  background-color: rgba(250, 169, 27, 0.1) !important;
}

.folder-menu-container {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
}

.folder-menu-card {
  width: 150px !important;
  padding: 3px;
  border-radius: 12px !important;
  border: none !important;
  overflow: hidden;
}

.folder-menu-list {
  padding: 4px !important;
}

.folder-menu-item {
  border-radius: 8px !important;
  min-height: 40px !important;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
}

.folder-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.folder-menu-item .v-list-item__icon {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 36px !important;
}

.v-list-item-icon {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
}

.v-icon {
  vertical-align: middle !important;
}

/* #region topic menu */

.topic-menu-container {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
}

.topic-menu-card {
  border-radius: 12px !important;
  padding: 3px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.14) !important;
  border: none !important;
  overflow: hidden;
}

.topic-menu-list {
  padding: 4px !important;
}

.topic-menu-item {
  display: flex;
  padding-left: 18px !important;
  border-radius: 8px !important;
  min-height: 40px !important;
  transition: background-color 0.2s ease;
}

.topic-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.topic-menu-item .v-list-item__icon {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 36px !important;
}

@keyframes iconPop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }

  70% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.topic-menu-item .v-icon {
  animation: iconPop 0.3s ease forwards;
}

.v-ripple__container {
  opacity: 0.1 !important;
  border-radius: 8px !important;
}

.topic-menu-list .v-divider {
  margin: 4px 0 !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.topic-menu-item:active .v-icon.error--text {
  animation: deleteShake 0.4s ease;
}

@keyframes deleteShake {
  0% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-4px);
  }

  40% {
    transform: translateX(4px);
  }

  60% {
    transform: translateX(-2px);
  }

  80% {
    transform: translateX(2px);
  }

  100% {
    transform: translateX(0);
  }
}

/* #endregion */
/* #region move folder anim */
.move-folder-dialog {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease;
}

.move-icon {
  animation: moveIconAnimation 0.5s ease-in-out;
}

@keyframes moveIconAnimation {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.topic-highlight {
  font-weight: 500;
  color: var(--v-primary-base, #faa91b);
  border-bottom: 1px dashed var(--v-primary-base, #faa91b);
  padding-bottom: 2px;
}

.folder-option::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: rgba(250, 169, 27, 0.08);
  z-index: -1;
  transition: width 0.3s ease;
}

.folder-option-selected::after {
  width: 100%;
}

.folder-option:hover::after {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.03);
}

.folder-option-selected:hover::after {
  background-color: rgba(250, 169, 27, 0.12);
}

.check-animation {
  animation: scaleIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
  }

  70% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

.options-loading {
  opacity: 0.7;
  pointer-events: none;
}

.loading-btn {
  position: relative;
  overflow: hidden;
}

.loading-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 100%);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  100% {
    left: 100%;
  }
}

.success-btn {
  animation: successPulse 1.5s ease;
}

@keyframes successPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(62, 228, 67, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
}

.error-btn {
  animation: errorShake 0.4s ease;
}

@keyframes errorShake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }

  100% {
    transform: translateX(0);
  }
}

.success-icon-animation {
  animation: successIcon 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes successIcon {
  0% {
    transform: scale(0) rotate(-90deg);
  }

  70% {
    transform: scale(1.2) rotate(10deg);
  }

  100% {
    transform: scale(1) rotate(0);
  }
}

.error-icon-animation {
  animation: errorIcon 0.5s ease;
}

@keyframes errorIcon {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.3);
  }

  100% {
    transform: scale(1);
  }
}

.success-animation {
  animation: bounceIn 0.3s;
}

.success-text-animation {
  animation: fadeInRight 0.2s 0.1s both;
}

@keyframes bounceIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }

  50% {
    transform: scale(1.1);
  }

  70% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fadeInRight {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* #endregion */

.topic-list-container {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0px;
  padding-right: 10px;
  margin: 0;
  background-color: transparent !important;
}

.topic-view.active-topic .v-label {
  font-weight: 600;
  color: var(--v-primary-base, #faa91b);
}

.topic-item .topic-view {
  background-color: #ffffff;
  border-radius: 12px !important;
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.topic-item .topic-view:hover {
  background-color: #f5f5f5;
}

.topic-item .topic-editable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 28px;
  padding: 6px 12px;
}

.topic-item .topic-editable .topic-name-input {
  flex: 1;
  margin-right: 10px;
  border: none;
  outline: none;
  font-size: 14px;
  background-color: transparent;
}

.folder-subtopics {
  background-color: transparent !important;
  transition:
    height 0.3s ease,
    opacity 0.3s ease;
  margin-left: 5px;
  border-left: 2px solid rgba(0, 0, 0, 0.05);
  border-radius: 0 0 0 12px;
}
.folder-view {
  display: flex;
  align-items: center;
  cursor: pointer;
  min-height: 45px;
  border-radius: 10px;
  padding: 2px 12px;
  background-color: #ffffff;
  transition:
    background-color 0.2s,
    box-shadow 0.2s,
    transform 0.2s;
}

.folder-updated-success {
  background-color: rgba(76, 175, 80, 0.1) !important;
  transition: background-color 0.3s ease;
}

.folder-updated-error {
  background-color: rgba(244, 67, 54, 0.1) !important;
  transition: background-color 0.3s ease;
}

.folder-status-icon {
  margin-left: 8px;
  margin-right: 4px;
}

.success-bounce {
  animation: successBounce 0.5s ease;
}

.error-shake {
  animation: errorShake 0.5s ease;
}

@keyframes successBounce {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes errorShake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-4px);
  }

  50% {
    transform: translateX(4px);
  }

  75% {
    transform: translateX(-4px);
  }

  100% {
    transform: translateX(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.folder-item {
  border-radius: 10px;
  margin-bottom: 8px;
  transition:
    background-color 0.2s,
    box-shadow 0.2s,
    transform 0.2s;
}

.topic-item,
.folder-item,
.folder-view,
.topic-view {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Modern folder input styling */
.input-folder {
  border-radius: 12px;
  transition: all 0.2s ease;
}

.input-folder:deep(.v-field__outline) {
  opacity: 0.7;
}

.input-folder:deep(.v-field--focused .v-field__outline) {
  opacity: 1;
  border-width: 2px;
}

.input-folder:deep(.v-field__input) {
  font-weight: 500;
  letter-spacing: 0.01em;
  padding-top: 10px;
}

.input-folder:deep(.v-field__prepend-inner) {
  padding-right: 12px;
}

.folder-icon-pulse {
  animation: pulse 2s infinite;
  animation-delay: 0.5s;
}

.clear-input-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.2s ease;
}

.clear-input-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}

.input-folder:deep(.v-counter) {
  opacity: 0.7;
}

.dragging-topic {
  cursor: grabbing !important;
}
.dragging-topic .folder-item,
.dragging-topic .folder-view,
.dragging-topic .topic-item,
.dragging-topic .topic-view {
  cursor: grabbing !important;
}
.sortable-ghost {
  opacity: 0.5;
  background-color: #f5f5f5 !important;
  border: 1px dashed var(--v-primary-base, #faa91b) !important;
  border-radius: 12px;
  max-height: 44px;
}

.topic-view.sortable-ghost {
  background-color: rgba(250, 169, 27, 0.1) !important;
}

.folder-view.sortable-ghost {
  background-color: rgba(250, 169, 27, 0.1) !important;
}
.folder-view.drop-target * {
  cursor: copy !important;
}
.folder-view.drop-target {
  background-color: rgba(250, 169, 27, 0.1) !important;
  box-shadow: 0 0 8px rgba(250, 169, 27, 0.3) !important;
  transform: translateY(-2px);
  transition: all 0.2s ease;
  cursor: copy !important;
  border: 1px solid var(--v-primary-base, #faa91b) !important;
}
.drop-target-outside {
  background-color: rgba(250, 169, 27, 0.1) !important;
  box-shadow: 0 0 8px rgba(250, 169, 27, 0.3) !important;
  transform: translateY(-2px);
  transition: all 0.2s ease;
  cursor: copy !important;
  border: 1px solid var(--v-primary-base, #faa91b) !important;
}
.highlighted-topic {
  border-left: 2px solid var(--v-primary-base, #faa91b) !important;
  box-shadow: 0 2px 4px rgb(215 141 12 / 38%) !important;
}

.highlighted-topic .topic-title {
  color: #1e293b !important;
  font-weight: 500 !important;
}
.model-label-fade-in {
  opacity: 0;
  animation: fadeInUp 0.2s ease-out forwards;
  animation-delay: 1.2s;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.icon-mask {
  width: 20px;
  height: 20px;
  background-color: currentColor;
  mask: var(--mask-url) no-repeat center / contain;
  -webkit-mask: var(--mask-url) no-repeat center / contain;
}

.user-menu-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.user-menu-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* User Icon - Compact */
.user-icon {
  font-size: 40px !important;
  margin: 0 !important;
}

/* User Info - More Compact */
.user-info-compact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
  margin: 0 2px;
}

.user-name-compact {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.1;
  white-space: nowrap;
}

.user-role-compact {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 1.1;
  white-space: nowrap;
  margin-top: 1px;
}

/* Chevron - Compact */
.chevron-icon {
  font-size: 20px !important;
  color: #757575 !important;
  margin: 0 !important;
}

/* Dropdown Menu */
.user-dropdown {
  border-radius: 8px !important;
  margin-top: 4px;
  min-width: 180px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.user-dropdown .v-list-item {
  padding: 8px 16px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.user-dropdown .v-list-item:hover {
  background-color: rgba(33, 150, 243, 0.08);
}

.user-dropdown :deep(.v-list-item__prepend) {
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
}

.user-dropdown :deep(.v-list-item__prepend > *) {
  width: 20px;
  height: 20px;
}

.user-dropdown :deep(.v-list-item__content) {
  display: flex;
  align-items: center;
}

.user-dropdown :deep(.v-list-item-title) {
  display: block;
  text-align: left;
}

.user-menu-wrapper .v-icon {
  color: grey !important;
}
</style>
